(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[439],{

/***/ 75403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _facetId_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: external "React"
var external_React_ = __webpack_require__(37667);
var external_React_default = /*#__PURE__*/__webpack_require__.n(external_React_);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-esi-components/build/index.esm.js
var index_esm = __webpack_require__(1158);
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/elements/button/Button.js
var Button = __webpack_require__(73087);
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/components/button-carousel/ButtonCarousel.js
var ButtonCarousel = __webpack_require__(70951);
// EXTERNAL MODULE: ./src/components/filter-suggestions/FilterSuggestions.module.scss
var FilterSuggestions_module = __webpack_require__(46971);
var FilterSuggestions_module_default = /*#__PURE__*/__webpack_require__.n(FilterSuggestions_module);
// EXTERNAL MODULE: ./src/context/FacetContext.jsx
var FacetContext = __webpack_require__(22030);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/context/FilterSuggestionsContext.jsx


var Context = /*#__PURE__*/external_React_default().createContext();
var useFilterSuggestionsContext = function useFilterSuggestionsContext() {
  return (0,external_React_.useContext)(Context);
};
var Provider = function Provider(_ref) {
  var filterSuggestions = _ref.filterSuggestions,
      children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Context.Provider, {
    value: filterSuggestions || {},
    children: children
  });
};
// EXTERNAL MODULE: ./src/components/stateful-link/StatefulLink.jsx
var StatefulLink = __webpack_require__(85852);
// EXTERNAL MODULE: ./src/components/analytics/analyticsEvents.js
var analyticsEvents = __webpack_require__(85576);
;// CONCATENATED MODULE: ./src/components/filter-suggestions/FilterSuggestions.jsx








var MIN_SUGGESTIONS = 2;
var isFilterSuggestionsDisplayed = function isFilterSuggestionsDisplayed(filterSuggestions, pageType) {
  return (filterSuggestions === null || filterSuggestions === void 0 ? void 0 : filterSuggestions.length) >= MIN_SUGGESTIONS && pageType !== 'brand';
};
var FilterSuggestions = /*#__PURE__*/(0,external_React_.memo)(function (props) {
  var pageType = props.pageType;
  var filterSuggestions = useFilterSuggestionsContext();
  var MAX_SUGGESTIONS = 7;

  var _useFacetContext = (0,FacetContext/* useFacetContext */.gv)(),
      applied = _useFacetContext.applied;

  (0,external_React_.useEffect)(function () {
    var buttonCarouselEl = document.querySelector('.filter-suggestions');

    if (buttonCarouselEl !== null && buttonCarouselEl !== void 0 && buttonCarouselEl.scroll) {
      buttonCarouselEl.scroll(0, 0);
    }
  }, [filterSuggestions]);

  if (!isFilterSuggestionsDisplayed(filterSuggestions, pageType)) {
    return null;
  }

  var triggerAnalyticsEvent = function triggerAnalyticsEvent(filter, position) {
    var page = pageType === 'browse' ? 'product list page grid' : 'search results';
    var facetGroupName = filter.facetGroupName,
        facetName = filter.facetName,
        trackingId = filter.trackingId;
    var appliedFilter = "".concat(facetGroupName, ":").concat(facetName).toLowerCase();
    var newFilterCombination = applied !== null && applied !== void 0 && applied.filterCombination ? "".concat(applied.filterCombination, "|").concat(appliedFilter) : appliedFilter;
    var newFilterCombinationNvals = applied !== null && applied !== void 0 && applied.filterCombinationNvals ? "".concat(applied.filterCombinationNvals, "|").concat(trackingId) : trackingId;
    (0,analyticsEvents/* dispatchAnalyticsEvent */.$j)(analyticsEvents/* FILTER_APPLIED */.pg, {
      pagetype: page,
      filterCombination: newFilterCombination,
      filterCombinationNvals: newFilterCombinationNvals,
      appliedFilter: appliedFilter,
      appliedFilterNval: trackingId,
      additionalInfo: {
        isHorizontal: 'true',
        horizontalPosition: position.toString()
      }
    });
  };

  var buttonList = filterSuggestions.slice(0, MAX_SUGGESTIONS).map(function (filter, idx) {
    return {
      buttonKey: "".concat(idx).concat(filter.display),
      tag: StatefulLink/* default */.ZP,
      href: '/',
      facetId: filter.facetId,
      query: {
        page: undefined
      },
      children: filter.display,
      onClick: function onClick() {
        triggerAnalyticsEvent(filter, idx + 1);
      }
    };
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (FilterSuggestions_module_default()).container,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonCarousel/* default */.Z, {
      className: "filter-suggestions",
      buttonList: buttonList,
      ariaLabel: "Frequently used filters"
    })
  });
});
FilterSuggestions.displayName = 'FilterSuggestions';
FilterSuggestions.defaultProps = {
  pageType: undefined
};
/* harmony default export */ var filter_suggestions_FilterSuggestions = (FilterSuggestions);
// EXTERNAL MODULE: ./src/components/grid/GridRow.module.scss
var GridRow_module = __webpack_require__(45550);
var GridRow_module_default = /*#__PURE__*/__webpack_require__.n(GridRow_module);
;// CONCATENATED MODULE: ./src/components/grid/GridRow.jsx


var _excluded = ["children", "row", "column", "reverse", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var GridRow = function GridRow(_ref) {
  var _classes;

  var children = _ref.children,
      row = _ref.row,
      column = _ref.column,
      reverse = _ref.reverse,
      className = _ref.className,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var classes = (_classes = {}, (0,defineProperty/* default */.Z)(_classes, (GridRow_module_default()).row, row), (0,defineProperty/* default */.Z)(_classes, (GridRow_module_default())["row--reverse"], row && reverse && !column), (0,defineProperty/* default */.Z)(_classes, (GridRow_module_default()).column, column && !row && !reverse), (0,defineProperty/* default */.Z)(_classes, (GridRow_module_default())["row--reverse"], row && reverse), _classes);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread(_objectSpread({
    "data-test": "component-grid-row",
    className: classnames_default()(["".concat((GridRow_module_default()).row), classes, className])
  }, props), {}, {
    children: children
  }));
};

GridRow.defaultProps = {
  row: true,
  column: false,
  reverse: false,
  className: undefined
};
/* harmony default export */ var grid_GridRow = (GridRow);
// EXTERNAL MODULE: ./src/components/grid/GridColumn.jsx
var GridColumn = __webpack_require__(59376);
// EXTERNAL MODULE: ./src/components/banners/Banner.module.scss
var Banner_module = __webpack_require__(26171);
var Banner_module_default = /*#__PURE__*/__webpack_require__.n(Banner_module);
;// CONCATENATED MODULE: ./src/context/BannerContext.jsx


var BannerContext_Context = /*#__PURE__*/external_React_default().createContext();
var useBannerContext = function useBannerContext() {
  return (0,external_React_.useContext)(BannerContext_Context);
};
var BannerContext_Provider = function Provider(_ref) {
  var banners = _ref.banners,
      children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BannerContext_Context.Provider, {
    value: banners || {},
    children: children
  });
};
;// CONCATENATED MODULE: ./src/components/banners/Banner.tsx






var Banner = /*#__PURE__*/(0,external_React_.memo)(function (_ref) {
  var _ref$bannerId = _ref.bannerId,
      bannerId = _ref$bannerId === void 0 ? '' : _ref$bannerId,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'banners' : _ref$className;

  var _useBannerContext = useBannerContext(),
      id = _useBannerContext[bannerId];

  if (!bannerId || !id) {
    return null;
  } // ESIInclude div ID is id="assembly-content-renderer-{className}-{bannerId}-{id}"
  // e.g. <div id="assembly-content-renderer-banners-brands-all-saints-bnr-1502191-banners" >


  return /*#__PURE__*/(0,jsx_runtime.jsx)("aside", {
    "data-test": "".concat(className, "-container"),
    className: classnames_default()((Banner_module_default()).container, (Banner_module_default())[className]),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* default */.Z, {
      src: "/content-renderer/".concat(className, "/").concat(id, "?no-failure=true&includeCoreCss=false&includeCoreJS=false&includePolyfills=false"),
      id: className
    })
  });
});
Banner.displayName = 'Banner';
// EXTERNAL MODULE: ./src/components/breadcrumbs/Breadcrumbs.module.scss
var Breadcrumbs_module = __webpack_require__(86640);
var Breadcrumbs_module_default = /*#__PURE__*/__webpack_require__.n(Breadcrumbs_module);
;// CONCATENATED MODULE: ./src/context/BreadcrumbContext.jsx


var BreadcrumbContext_Context = /*#__PURE__*/external_React_default().createContext();
var useBreadcrumbContext = function useBreadcrumbContext() {
  return (0,external_React_.useContext)(BreadcrumbContext_Context);
};

var getCategory = function getCategory(breadcrumbs) {
  if (breadcrumbs && breadcrumbs[breadcrumbs.length - 1]) {
    var _breadcrumbs;

    return ((_breadcrumbs = breadcrumbs[breadcrumbs.length - 1]) === null || _breadcrumbs === void 0 ? void 0 : _breadcrumbs.displayName) || '';
  }

  return '';
};

var BreadcrumbContext_Provider = function Provider(_ref) {
  var breadcrumbs = _ref.breadcrumbs,
      children = _ref.children;
  var contextValue = {
    breadcrumbs: breadcrumbs || [],
    category: getCategory(breadcrumbs)
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbContext_Context.Provider, {
    value: contextValue,
    children: children
  });
};
;// CONCATENATED MODULE: ./src/components/breadcrumbs/Breadcrumbs.tsx








var getNvalFromUrl = function getNvalFromUrl(url) {
  if (!url) return null;
  var lastSlash = url.lastIndexOf('/');
  return url.slice(lastSlash + 1);
};
var EsiBreadcrumbs = function EsiBreadcrumbs(_ref) {
  var query = _ref.query,
      lastBreadcrumb = _ref.lastBreadcrumb;
  var routerPageType = query.type,
      term = query['search-term'],
      facetId = query.facetId,
      listHead = query.listHead;
  var item = lastBreadcrumb.item,
      url = lastBreadcrumb.url;
  var esiSource;

  switch (routerPageType) {
    case 'brand':
      {
        esiSource = "/esi/breadcrumbs/brand/".concat(encodeURIComponent(item));
        break;
      }

    case 'browse':
      {
        var _ref2 = facetId && facetId.length > 0 ? facetId.slice(-1) : [],
            _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 1),
            nVal = _ref3[0];

        var cVal = getNvalFromUrl(url);

        if (cVal && cVal.startsWith('c')) {
          esiSource = "/esi/breadcrumbs/category/".concat(cVal.substring(1));
        } else {
          if (nVal) esiSource = "/esi/breadcrumbs/browse/".concat(nVal);
        }

        break;
      }

    case 's':
      {
        var searchTerm = facetId && facetId.length > 0 ? facetId[0].replace(/-/g, ' ') : '';
        esiSource = "/esi/breadcrumbs/search/".concat(encodeURIComponent(searchTerm));
        break;
      }

    default:
      esiSource = listHead ? "/esi/breadcrumbs/search/".concat(encodeURIComponent(listHead)) : "/esi/breadcrumbs/search/".concat(encodeURIComponent(term));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()((Breadcrumbs_module_default())["breadcrumbs-carousel"]),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* default */.Z, {
      src: esiSource,
      id: "esiBreadcrumbs"
    })
  });
};
var Breadcrumbs = function Breadcrumbs() {
  var _useRouter = (0,next_router.useRouter)(),
      query = _useRouter.query;

  var _useBreadcrumbContext = useBreadcrumbContext(),
      breadcrumbs = _useBreadcrumbContext.breadcrumbs;

  if (!((breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length) > 0)) {
    return null;
  }

  var _breadcrumbs$slice = breadcrumbs.slice(-1),
      _breadcrumbs$slice2 = (0,slicedToArray/* default */.Z)(_breadcrumbs$slice, 1),
      lastBreadcrumb = _breadcrumbs$slice2[0];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(EsiBreadcrumbs, {
    query: query,
    lastBreadcrumb: lastBreadcrumb
  });
};
// EXTERNAL MODULE: ./src/components/header/Header.module.scss
var Header_module = __webpack_require__(89449);
var Header_module_default = /*#__PURE__*/__webpack_require__.n(Header_module);
;// CONCATENATED MODULE: ./src/components/header/Header.tsx





var Header = /*#__PURE__*/(0,external_React_.memo)(function (_ref) {
  var heading = _ref.heading,
      subHeading = _ref.subHeading,
      _ref$totalNumberOfRes = _ref.totalNumberOfResults,
      totalNumberOfResults = _ref$totalNumberOfRes === void 0 ? 0 : _ref$totalNumberOfRes,
      _ref$showNumberOfResu = _ref.showNumberOfResults,
      showNumberOfResults = _ref$showNumberOfResu === void 0 ? true : _ref$showNumberOfResu,
      alternativeSearchSuggestions = _ref.alternativeSearchSuggestions,
      correctedSearchTerm = _ref.correctedSearchTerm;
  var totalNumberOfResultsDisplay = showNumberOfResults && Number.isInteger(totalNumberOfResults) && totalNumberOfResults >= 0 ? "(".concat(totalNumberOfResults.toLocaleString('en'), ")") : '';
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (Header_module_default()).heading,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Breadcrumbs, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Header_module_default()).heading__copy,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h1", {
        tabIndex: -1,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          "data-test": "heading-term" // eslint-disable-next-line jsx-a11y/aria-role
          ,
          role: "text",
          className: (Header_module_default()).heading__main,
          children: "".concat(heading, " ")
        }), subHeading && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          "aria-hidden": "true",
          "data-test": "sub-heading",
          className: (Header_module_default()).heading__filters,
          children: subHeading
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (Header_module_default()).heading__count,
        "data-test": "heading-num-results",
        children: totalNumberOfResultsDisplay
      })]
    }), correctedSearchTerm, alternativeSearchSuggestions]
  });
});
Header.displayName = 'Header';
/* harmony default export */ var header_Header = (Header);
// EXTERNAL MODULE: ./src/components/header/sub-copy/SubCopy.module.scss
var SubCopy_module = __webpack_require__(43259);
var SubCopy_module_default = /*#__PURE__*/__webpack_require__.n(SubCopy_module);
;// CONCATENATED MODULE: ./src/components/header/sub-copy/SubCopy.tsx



var TEXT = "It might be temporarily out of stock. Try a more generic search term or try looking for alternative products within the departments.";

var SubCopy = function SubCopy(_ref) {
  var _ref$copy = _ref.copy,
      copy = _ref$copy === void 0 ? TEXT : _ref$copy;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    "data-test": "component-sub-copy",
    className: (SubCopy_module_default())["sub-copy"],
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      "data-test": "sub-copy-copy",
      className: (SubCopy_module_default())["sub-copy__copy"],
      children: copy
    })
  });
};

/* harmony default export */ var sub_copy_SubCopy = (SubCopy);
// EXTERNAL MODULE: ./src/components/header/corrected-search-term/CorrectedSearchTerm.module.scss
var CorrectedSearchTerm_module = __webpack_require__(47269);
var CorrectedSearchTerm_module_default = /*#__PURE__*/__webpack_require__.n(CorrectedSearchTerm_module);
;// CONCATENATED MODULE: ./src/components/header/corrected-search-term/CorrectedSearchTerm.tsx



var NOT_STOCKED_SUBSTITUTE = 'NotStockedSubstitute';
var SPELL_CORRECT = 'SpellCorrect';
var SUBSTITUTE = 'Substitute';
var allowedCorrectionTypes = [NOT_STOCKED_SUBSTITUTE, SPELL_CORRECT, SUBSTITUTE];
var CorrectedSearchTerm = function CorrectedSearchTerm(_ref) {
  var correctedSearchTerm = _ref.correctedSearchTerm,
      _ref$totalNumberOfRes = _ref.totalNumberOfResults,
      totalNumberOfResults = _ref$totalNumberOfRes === void 0 ? 0 : _ref$totalNumberOfRes,
      originalSearchTerm = _ref.originalSearchTerm,
      correctionType = _ref.correctionType;

  if (!allowedCorrectionTypes.includes(correctionType) || !correctedSearchTerm && correctionType !== NOT_STOCKED_SUBSTITUTE) {
    return null;
  }

  var copy;

  if (correctionType === NOT_STOCKED_SUBSTITUTE && totalNumberOfResults > 0) {
    correctedSearchTerm ? copy = "Sorry, we don't stock ".concat(originalSearchTerm, ". Here are ").concat(totalNumberOfResults, " results for ").concat(correctedSearchTerm, ".") : copy = "Sorry, we don't stock ".concat(originalSearchTerm, ". Here are ").concat(totalNumberOfResults, " similar products.");
  } else {
    copy = "Showing ".concat(totalNumberOfResults, " result").concat(totalNumberOfResults !== 1 ? 's' : '', " for '").concat(correctedSearchTerm, "'");
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    "data-test": "corrected-search-term",
    className: (CorrectedSearchTerm_module_default())["corrected-search-term"],
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      "data-test": "corrected-search-term-copy",
      className: (CorrectedSearchTerm_module_default())["corrected-search-term__copy"],
      children: copy
    })
  });
};
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/components/carousel/BETA/product-card-carousel/ProductCardCarousel.js
var ProductCardCarousel = __webpack_require__(99981);
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/utils/product/getProductUrl.js
var getProductUrl = __webpack_require__(84225);
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/components/message/v2/Message.js
var Message = __webpack_require__(65576);
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/components/loading-spinner/LoadingSpinner.js
var LoadingSpinner = __webpack_require__(72601);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(70131);
// EXTERNAL MODULE: ./src/components/product-grid/product-count/ProductCount.module.scss
var ProductCount_module = __webpack_require__(96011);
var ProductCount_module_default = /*#__PURE__*/__webpack_require__.n(ProductCount_module);
// EXTERNAL MODULE: ./src/context/ProductContext.jsx
var ProductContext = __webpack_require__(79164);
;// CONCATENATED MODULE: ./src/components/product-grid/product-count/ProductCount.jsx









var _getConfig = config_default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var ProductCount = function ProductCount(_ref) {
  var positionOnPage = _ref.positionOnPage,
      isListViewOn = _ref.isListViewOn;
  var pageSize = publicRuntimeConfig.pageSize;
  var router = (0,next_router.useRouter)();

  var _useProductContext = (0,ProductContext/* useProductContext */.$h)(),
      totalNumberOfResults = _useProductContext.totalNumberOfResults;

  var _router$query$page = router.query.page,
      page = _router$query$page === void 0 ? 1 : _router$query$page;
  var currentPage = parseInt(page, 10);

  if (!totalNumberOfResults) {
    return null;
  } // Calculate the position of the product in the total list of all products retrieved
  // e.g. for a page size of 192, the first product on page 2 is product 193
  // Note that positionOnPage is zero-based, so we add 1 to it
  // i.e. positionOnPage 0 is product 1 on that page


  var productPositionInList = (currentPage - 1) * pageSize + positionOnPage + 1;
  var copy = "You've viewed ".concat(productPositionInList.toLocaleString('en'), " of ").concat(totalNumberOfResults.toLocaleString('en'));
  return /*#__PURE__*/(0,jsx_runtime.jsx)("aside", {
    className: classnames_default()((ProductCount_module_default()).productCountInfo, (0,defineProperty/* default */.Z)({}, (ProductCount_module_default())["product-count__list-view"], isListViewOn)),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      "data-test": "product-count-copy",
      children: copy
    })
  });
};
ProductCount.defaultProps = {
  positionOnPage: 0
};
/* harmony default export */ var product_count_ProductCount = (ProductCount);
;// CONCATENATED MODULE: ./src/components/structured-data/StructuredData.jsx


var StructuredData = /*#__PURE__*/external_React_default().forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children;
  var stringifiedChildren = (0,external_React_.useMemo)(function () {
    switch (typeof children) {
      case 'function':
        {
          return JSON.stringify(children());
        }

      default:
        {
          return JSON.stringify(children);
        }
    }
  }, [children]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
    ref: forwardedRef,
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: stringifiedChildren
    }
  });
});
StructuredData.displayName = 'StructuredData';
/* harmony default export */ var structured_data_StructuredData = (StructuredData);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(20784);
// EXTERNAL MODULE: ./src/components/product-grid/ProductGrid.module.scss
var ProductGrid_module = __webpack_require__(28059);
var ProductGrid_module_default = /*#__PURE__*/__webpack_require__.n(ProductGrid_module);
// EXTERNAL MODULE: ./src/components/analytics/utils/mapProduct.js + 1 modules
var mapProduct = __webpack_require__(36524);
// EXTERNAL MODULE: ./node_modules/deepmerge/dist/cjs.js
var cjs = __webpack_require__(9996);
var cjs_default = /*#__PURE__*/__webpack_require__.n(cjs);
// EXTERNAL MODULE: ./src/components/experiences/Experiences.jsx + 1 modules
var Experiences = __webpack_require__(91576);
;// CONCATENATED MODULE: ./src/hooks/useProductCardSize.jsx


var useProductCardSize_excluded = ["cardType", "type", "facetId"];

function useProductCardSize_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useProductCardSize_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useProductCardSize_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useProductCardSize_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var DESKTOP = 'DESKTOP';
var TABLET = 'TABLET';
var MOBILE = 'MOBILE';

var getScreenSize = function getScreenSize() {
  if (window.matchMedia('(min-width: 768px)').matches) {
    return DESKTOP;
  }

  if (window.matchMedia('(min-width: 568px) and (max-width: 767px)').matches) {
    return TABLET;
  }

  return MOBILE;
};

var generateToggleJlData = function generateToggleJlData(isLargeCardSize) {
  var _DESKTOP$TABLET$MOBIL;

  var screenSize = getScreenSize();
  return {
    checked: isLargeCardSize ? 'min' : 'max',
    cardsPerCol: (_DESKTOP$TABLET$MOBIL = {}, (0,defineProperty/* default */.Z)(_DESKTOP$TABLET$MOBIL, DESKTOP, [4, 3]), (0,defineProperty/* default */.Z)(_DESKTOP$TABLET$MOBIL, TABLET, [3, 2]), (0,defineProperty/* default */.Z)(_DESKTOP$TABLET$MOBIL, MOBILE, [2, 1]), _DESKTOP$TABLET$MOBIL)[screenSize][Number(isLargeCardSize)]
  };
};

var useShowLargeCards = function useShowLargeCards(isLargeCardSizeFlagOn) {
  var _useBreadcrumbContext = useBreadcrumbContext(),
      breadcrumbs = _useBreadcrumbContext.breadcrumbs;

  return isLargeCardSizeFlagOn && ['Home & Garden', 'Furniture & Lights', 'Women', 'Men', 'Baby & Child', 'Sport & Leisure'].includes(breadcrumbs[0].displayName);
};

var useProductCardSize = function useProductCardSize() {
  var router = (0,next_router.useRouter)();

  var _useExperiencesContex = (0,Experiences/* useExperiencesContext */.Xe)(),
      isProductCardSizeOverrideOn = _useExperiencesContex.isProductCardSizeOverrideOn,
      isProductCardSizeFlagOn = _useExperiencesContex.isProductCardSizeFlagOn,
      isLargeCardSizeFlagOn = _useExperiencesContex.isLargeCardSizeFlagOn;

  var _router$query = router.query,
      cardType = _router$query.cardType,
      type = _router$query.type,
      facetId = _router$query.facetId,
      queryRest = (0,objectWithoutProperties/* default */.Z)(_router$query, useProductCardSize_excluded),
      asPath = router.asPath,
      pathname = router.pathname;

  var isLargeCardSize = useShowLargeCards(isLargeCardSizeFlagOn) || isProductCardSizeFlagOn && cardType !== 'small' || isProductCardSizeOverrideOn;
  var value = (0,external_React_.useMemo)(function () {
    var largeCardUrl = {
      as: {
        pathname: asPath.split('?')[0],
        query: useProductCardSize_objectSpread(useProductCardSize_objectSpread({}, queryRest), {}, {
          cardType: 'large'
        })
      },
      href: {
        pathname: pathname,
        query: useProductCardSize_objectSpread(useProductCardSize_objectSpread({}, queryRest), {}, {
          type: type,
          facetId: facetId,
          cardType: 'large'
        })
      }
    };
    var standardCardUrl = {
      as: {
        pathname: asPath.split('?')[0],
        query: useProductCardSize_objectSpread(useProductCardSize_objectSpread({}, queryRest), {}, {
          cardType: 'small'
        })
      },
      href: {
        pathname: pathname,
        query: useProductCardSize_objectSpread(useProductCardSize_objectSpread({}, queryRest), {}, {
          type: type,
          facetId: facetId,
          cardType: 'small'
        })
      }
    };
    var colsPerProductCard = {
      checked: isLargeCardSize ? 'largeSize' : 'normalSize'
    };
    return {
      largeCardUrl: largeCardUrl,
      standardCardUrl: standardCardUrl,
      isLargeCardSize: isLargeCardSize,
      colsPerProductCard: colsPerProductCard
    };
  }, [asPath, queryRest, pathname, facetId, type, isLargeCardSize]);
  (0,external_React_.useEffect)(function () {
    var detail = generateToggleJlData(isLargeCardSize);
    window.jlData = cjs_default()(window.jlData, {
      page: {
        productPages: {
          productCardView: detail
        }
      }
    });
  }, [isLargeCardSize]);
  return value;
};
// EXTERNAL MODULE: ./src/context/CompareContext.tsx + 1 modules
var CompareContext = __webpack_require__(13525);
// EXTERNAL MODULE: ./src/context/SearchContext.jsx
var SearchContext = __webpack_require__(80348);
;// CONCATENATED MODULE: ./src/api/products/product-chunks.js



var product_chunks_getConfig = config_default()(),
    features = product_chunks_getConfig.publicRuntimeConfig; // Client side


var stdPLPFetcher = function stdPLPFetcher() {
  return fetch.apply(void 0, arguments).then(function (r) {
    if (r.ok) {
      return r.json();
    }

    if (r.status === 404) {
      return {
        error: 404
      };
    }

    throw new Error('An unexpected response has occurred');
  })["catch"](function (e) {
    throw new Error(e);
  });
};

var PATH_PRODUCT_CHUNK = "".concat(features.applicationPrefix, "/api/product-chunks");
var getProductChunks = function getProductChunks(_ref, pageCorrelationId) {
  var _ref$page = _ref.page,
      page = _ref$page === void 0 ? 1 : _ref$page,
      _ref$chunk = _ref.chunk,
      chunk = _ref$chunk === void 0 ? 1 : _ref$chunk,
      _ref$term = _ref.term,
      term = _ref$term === void 0 ? '' : _ref$term,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? '' : _ref$type,
      _ref$facetId = _ref.facetId,
      facetId = _ref$facetId === void 0 ? '' : _ref$facetId,
      _ref$sortBy = _ref.sortBy,
      sortBy = _ref$sortBy === void 0 ? '' : _ref$sortBy,
      _ref$listHead = _ref.listHead,
      listHead = _ref$listHead === void 0 ? '' : _ref$listHead,
      _ref$lolcode = _ref.lolcode,
      lolcode = _ref$lolcode === void 0 ? '' : _ref$lolcode,
      _ref$price = _ref.price,
      price = _ref$price === void 0 ? '' : _ref$price,
      _ref$priceBands = _ref.priceBands,
      priceBands = _ref$priceBands === void 0 ? '' : _ref$priceBands;
  return stdPLPFetcher("".concat(PATH_PRODUCT_CHUNK, "?page=").concat(page, "&chunk=").concat(chunk, "&term=").concat(encodeURIComponent(term), "&type=").concat(type, "&facetId=").concat(facetId, "&sortBy=").concat(sortBy, "&price=").concat(price, "&priceBands=").concat(priceBands, "&listHead=").concat(listHead, "&lolcode=").concat(lolcode), {
    headers: (0,defineProperty/* default */.Z)({}, features.pageCorrelationId, pageCorrelationId)
  });
};
;// CONCATENATED MODULE: ./src/context/RequestContext.jsx


var RequestContext_Context = /*#__PURE__*/external_React_default().createContext();
var useRequestContext = function useRequestContext() {
  return (0,external_React_.useContext)(RequestContext_Context);
};
var RequestContext_Provider = function Provider(_ref) {
  var pageCorrelationId = _ref.pageCorrelationId,
      children = _ref.children;
  var contextValue = pageCorrelationId || '';
  return /*#__PURE__*/(0,jsx_runtime.jsx)(RequestContext_Context.Provider, {
    value: contextValue,
    children: children
  });
};
;// CONCATENATED MODULE: ./src/context/DiscoveryContext.jsx


var DiscoveryContext_Context = /*#__PURE__*/external_React_default().createContext();
var useDiscoveryContext = function useDiscoveryContext() {
  return (0,external_React_.useContext)(DiscoveryContext_Context);
};
var DiscoveryContext_Provider = function Provider(_ref) {
  var discovery = _ref.discovery,
      children = _ref.children;
  var contextValue = discovery || {};
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DiscoveryContext_Context.Provider, {
    value: contextValue,
    children: children
  });
};
// EXTERNAL MODULE: ./src/components/energy-drawer/useEnergyDrawerData.tsx
var useEnergyDrawerData = __webpack_require__(77554);
// EXTERNAL MODULE: ./node_modules/next/dist/build/polyfills/fetch/index.js
var polyfills_fetch = __webpack_require__(63144);
var fetch_default = /*#__PURE__*/__webpack_require__.n(polyfills_fetch);
;// CONCATENATED MODULE: ./src/api/social-proof-messaging/index.ts





var social_proof_messaging_getConfig = config_default()(),
    social_proof_messaging_features = social_proof_messaging_getConfig.publicRuntimeConfig;

var fetcher = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var url, products, appId;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = _ref.url, products = _ref.products, appId = _ref.appId;
            return _context.abrupt("return", fetch_default()(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                products: products,
                appId: appId
              })
            }).then(function (r) {
              if (r.ok) {
                return r.json();
              }

              throw new Error("Received error fetching social proof messaging data: ".concat(r.status));
            })["catch"](function (e) {
              throw new Error(e);
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetcher(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var PATH = social_proof_messaging_features.socialProofAPIService;
var fetchSocialProofData = function fetchSocialProofData(products) {
  return fetcher({
    url: "".concat(PATH),
    products: products,
    appId: social_proof_messaging_features.productCardSocialProofAppId
  });
};
;// CONCATENATED MODULE: ./src/context/SocialProofContext.jsx




function SocialProofContext_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SocialProofContext_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SocialProofContext_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SocialProofContext_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var SocialProofContext_Context = /*#__PURE__*/external_React_default().createContext();
var useSocialProofContext = function useSocialProofContext() {
  return (0,external_React_.useContext)(SocialProofContext_Context);
};
var SocialProofContext_Provider = function Provider(_ref) {
  var children = _ref.children;

  var _useProductContext = (0,ProductContext/* useProductContext */.$h)(),
      products = _useProductContext.products;

  var _useExperiencesContex = (0,Experiences/* useExperiencesContext */.Xe)(),
      isSocialProofingProductCardOn = _useExperiencesContex.isSocialProofingProductCardOn;

  var _useState = (0,external_React_.useState)({}),
      socialProofingMessages = _useState[0],
      setSocialProofingMessages = _useState[1];

  var _useState2 = (0,external_React_.useState)([]),
      previousProdIds = _useState2[0],
      setPreviousProdIds = _useState2[1];

  var _useState3 = (0,external_React_.useState)([]),
      availableSocialProofMessages = _useState3[0],
      setAvailableSocialProofMessages = _useState3[1];

  var getSocialProofingDataPackage = function getSocialProofingDataPackage() {
    return products.map(function (product) {
      if (previousProdIds.includes(product.id)) {
        return null;
      }

      return {
        productId: product.id,
        brand: product.brand,
        availableToOrder: product.isAvailableToOrder
      };
    }).filter(function (product) {
      return product !== null;
    });
  };

  var transformSocialProofingResponse = function transformSocialProofingResponse(newSocialProofingMessages) {
    if (newSocialProofingMessages && typeof newSocialProofingMessages === 'object') return Object.values(newSocialProofingMessages).reduce(function (acc, value) {
      var _value$messages$;

      acc[value.productId] = {
        id: value.productId,
        title: (_value$messages$ = value.messages[0]) === null || _value$messages$ === void 0 ? void 0 : _value$messages$.title
      };
      return acc;
    }, {});
  };

  (0,external_React_.useEffect)(function () {
    setPreviousProdIds(products === null || products === void 0 ? void 0 : products.map(function (product) {
      return product.id;
    }));
    setAvailableSocialProofMessages(getSocialProofingDataPackage());
  }, [products]);
  (0,external_React_.useEffect)(function () {
    if (availableSocialProofMessages.length == 0 || !isSocialProofingProductCardOn) {
      return;
    }

    var fetchedData = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var newSocialProofingMessages, transformedMessages;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetchSocialProofData(availableSocialProofMessages);

              case 3:
                newSocialProofingMessages = _context.sent;
                transformedMessages = transformSocialProofingResponse(newSocialProofingMessages);
                setSocialProofingMessages(SocialProofContext_objectSpread(SocialProofContext_objectSpread({}, socialProofingMessages), transformedMessages));
                setPreviousProdIds(products === null || products === void 0 ? void 0 : products.map(function (product) {
                  return product.id;
                }));
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                console.error('Error fetching data: ', _context.t0);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function fetchedData() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchedData();
  }, [availableSocialProofMessages]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SocialProofContext_Context.Provider, {
    value: socialProofingMessages,
    children: children
  });
};
;// CONCATENATED MODULE: ./src/components/product-grid/ImageOverwrite.jsx
function overwriteImage(_ref) {
  var imageOverwriteFeature = _ref.imageOverwriteFeature,
      path = _ref.path,
      defaultSkuId = _ref.defaultSkuId,
      image = _ref.image;
  return imageOverwriteFeature && path.includes(imageOverwriteFeature.nValue) ? "//johnlewis.scene7.com/is/image/JohnLewis/".concat(defaultSkuId).concat(imageOverwriteFeature.postfix, "?") : image;
}
function overwriteSelectedSwatch(_ref2) {
  var imageOverwriteFeature = _ref2.imageOverwriteFeature,
      path = _ref2.path,
      selectedSwatch = _ref2.selectedSwatch;

  if (imageOverwriteFeature && path.includes(imageOverwriteFeature.nValue)) {
    // eslint-disable-next-line no-param-reassign
    selectedSwatch.imageUrl = "//johnlewis.scene7.com/is/image/JohnLewis/".concat(selectedSwatch.skuId).concat(imageOverwriteFeature.postfix, "?");
  }

  return selectedSwatch;
}
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/components/product-card/ProductCard.js
var ProductCard = __webpack_require__(81118);
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/components/product-card/ALPHA/ProductCardDetailed.js
var ProductCardDetailed = __webpack_require__(58344);
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/components/checkbox/Checkbox.js
var Checkbox = __webpack_require__(4990);
;// CONCATENATED MODULE: ./src/components/compare-checkbox/CompareCheckbox.tsx






var CompareCheckbox = function CompareCheckbox(_ref) {
  var id = _ref.id,
      ariaLabel = _ref.ariaLabel,
      checked = _ref.checked,
      disabled = _ref.disabled,
      onCompareClick = _ref.onCompareClick;
  var compareId = "compare-".concat(id);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox["default"], {
    id: compareId // prettier-ignore
    ,
    label: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["Compare", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "visuallyHidden",
        children: ariaLabel
      })]
    }),
    isControlled: true,
    name: compareId,
    checked: checked,
    onChange: onCompareClick,
    disabled: disabled
  });
};

/* harmony default export */ var compare_checkbox_CompareCheckbox = (/*#__PURE__*/(0,external_React_.memo)(CompareCheckbox));
// EXTERNAL MODULE: ./src/components/non-promo-message/NonPromoMessage.module.scss
var NonPromoMessage_module = __webpack_require__(88501);
var NonPromoMessage_module_default = /*#__PURE__*/__webpack_require__.n(NonPromoMessage_module);
;// CONCATENATED MODULE: ./src/components/non-promo-message/NonPromoMessage.tsx




var NonPromoMessage = function NonPromoMessage(_ref) {
  var message = _ref.message;

  if (!message) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
    className: (NonPromoMessage_module_default()).nonpromomessage,
    "data-test": "non-promo-message",
    children: message
  });
};

/* harmony default export */ var non_promo_message_NonPromoMessage = (/*#__PURE__*/(0,external_React_.memo)(NonPromoMessage));
;// CONCATENATED MODULE: ./src/context/ApplicationSettingsContext.jsx



var ApplicationSettingsContext_Context = /*#__PURE__*/external_React_default().createContext();
var useApplicationSettingsContext = function useApplicationSettingsContext() {
  return (0,external_React_.useContext)(ApplicationSettingsContext_Context);
};
var ApplicationSettingsContext_Provider = function Provider(_ref) {
  var children = _ref.children;

  var _useMemo = (0,external_React_.useMemo)(function () {
    return config_default()();
  }, []),
      publicRuntimeConfig = _useMemo.publicRuntimeConfig;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ApplicationSettingsContext_Context.Provider, {
    value: publicRuntimeConfig,
    children: children
  });
};
;// CONCATENATED MODULE: ./src/components/product-grid/ProductCardContainer.jsx


function ProductCardContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ProductCardContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ProductCardContainer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProductCardContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var useProductCardContainerData = function useProductCardContainerData() {
  var compare = (0,CompareContext/* useCompareContext */.EN)();

  var _useBreadcrumbContext = useBreadcrumbContext(),
      category = _useBreadcrumbContext.category;

  var _useApplicationSettin = useApplicationSettingsContext(),
      basketBFFService = _useApplicationSettin.basketBFFService;

  var _useRouter = (0,next_router.useRouter)(),
      path = _useRouter.asPath;

  var _useExperiencesContex = (0,Experiences/* useExperiencesContext */.Xe)(),
      _useExperiencesContex2 = _useExperiencesContex.atbBlockList,
      atbBlockList = _useExperiencesContex2 === void 0 ? [] : _useExperiencesContex2,
      imageOverwriteFeature = _useExperiencesContex.imageOverwriteFeature,
      isAltImageOnHoverFlagOn = _useExperiencesContex.isAltImageOnHoverFlagOn,
      isHeroAttributesFlagOn = _useExperiencesContex.isHeroAttributesFlagOn,
      isLimitedSwatchesFlagOn = _useExperiencesContex.isLimitedSwatchesFlagOn,
      isListViewOn = _useExperiencesContex.isListViewOn,
      isNowWasFlagOn = _useExperiencesContex.isNowWasFlagOn,
      isPriceReductionFlagOn = _useExperiencesContex.isPriceReductionFlagOn,
      isProductCardCarouselAltStartFeatureFlagOn = _useExperiencesContex.isProductCardCarouselAltStartFeatureFlagOn,
      isProductCardCarouselFeatureFlagOn = _useExperiencesContex.isProductCardCarouselFeatureFlagOn,
      isPromoQuickViewFlagOn = _useExperiencesContex.isPromoQuickViewFlagOn,
      isSocialProofingProductCardOn = _useExperiencesContex.isSocialProofingProductCardOn;

  return {
    compare: compare,
    category: category,
    basketBFFService: basketBFFService,
    path: path,
    experience: {
      atbBlockList: atbBlockList,
      imageOverwriteFeature: imageOverwriteFeature,
      isAltImageOnHoverFlagOn: isAltImageOnHoverFlagOn,
      isHeroAttributesFlagOn: isHeroAttributesFlagOn,
      isLimitedSwatchesFlagOn: isLimitedSwatchesFlagOn,
      isListViewOn: isListViewOn,
      isNowWasFlagOn: isNowWasFlagOn,
      isPriceReductionFlagOn: isPriceReductionFlagOn,
      isProductCardCarouselAltStartFeatureFlagOn: isProductCardCarouselAltStartFeatureFlagOn,
      isProductCardCarouselFeatureFlagOn: isProductCardCarouselFeatureFlagOn,
      isPromoQuickViewFlagOn: isPromoQuickViewFlagOn,
      isSocialProofingProductCardOn: isSocialProofingProductCardOn
    }
  };
};

var ProductCardContainer = function ProductCardContainer(_ref) {
  var _classNames, _socialProofingMessag, _socialProofingMessag2, _socialProofingMessag3, _socialProofingMessag4;

  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      product = _ref.product,
      index = _ref.index,
      imageSize = _ref.imageSize,
      imageWidths = _ref.imageWidths,
      _ref$hasCTAButton = _ref.hasCTAButton,
      hasCTAButton = _ref$hasCTAButton === void 0 ? true : _ref$hasCTAButton,
      _ref$hasQuickViewIcon = _ref.hasQuickViewIcon,
      hasQuickViewIcon = _ref$hasQuickViewIcon === void 0 ? true : _ref$hasQuickViewIcon,
      isLargeCardSize = _ref.isLargeCardSize,
      isMobileBreakpoint = _ref.isMobileBreakpoint,
      isBelowQuickViewBreakpoint = _ref.isBelowQuickViewBreakpoint,
      handleDisplayQuickAdd = _ref.handleDisplayQuickAdd,
      openEnergyDrawer = _ref.openEnergyDrawer,
      handleAddToBasketClick = _ref.handleAddToBasketClick,
      fetchQuickViewData = _ref.fetchQuickViewData,
      handleDisplayM2MProductSelector = _ref.handleDisplayM2MProductSelector,
      socialProofingMessages = _ref.socialProofingMessages,
      pricePrefix = _ref.pricePrefix;

  var _useProductCardContai = useProductCardContainerData(),
      compare = _useProductCardContai.compare,
      category = _useProductCardContai.category,
      basketBFFService = _useProductCardContai.basketBFFService,
      path = _useProductCardContai.path,
      experience = _useProductCardContai.experience;

  var _experience$atbBlockL = experience.atbBlockList,
      atbBlockList = _experience$atbBlockL === void 0 ? [] : _experience$atbBlockL,
      imageOverwriteFeature = experience.imageOverwriteFeature,
      isAltImageOnHoverFlagOn = experience.isAltImageOnHoverFlagOn,
      isHeroAttributesFlagOn = experience.isHeroAttributesFlagOn,
      isLimitedSwatchesFlagOn = experience.isLimitedSwatchesFlagOn,
      isListViewOn = experience.isListViewOn,
      isNowWasFlagOn = experience.isNowWasFlagOn,
      isPriceReductionFlagOn = experience.isPriceReductionFlagOn,
      isProductCardCarouselAltStartFeatureFlagOn = experience.isProductCardCarouselAltStartFeatureFlagOn,
      isProductCardCarouselFeatureFlagOn = experience.isProductCardCarouselFeatureFlagOn,
      isPromoQuickViewFlagOn = experience.isPromoQuickViewFlagOn,
      isSocialProofingProductCardOn = experience.isSocialProofingProductCardOn;
  var adId = product.adId,
      defaultSkuId = product.defaultSkuId,
      defaultVariantId = product.defaultVariantId,
      highlightedAttributes = product.highlightedAttributes,
      id = product.id,
      image = product.image,
      isSponsored = product.isSponsored,
      nonPromoMessages = product.nonPromoMessages,
      price = product.price,
      productId = product.productId,
      promoMessages = product.promoMessages,
      selectedSwatch = product.selectedSwatch,
      title = product.title,
      type = product.type,
      url = product.url;
  var featuresArray = [];
  highlightedAttributes === null || highlightedAttributes === void 0 ? void 0 : highlightedAttributes.forEach(function (feature) {
    var _feature$name;

    featuresArray.push("".concat(feature.hideNameOnHighlight ? '' : ((_feature$name = feature.name) === null || _feature$name === void 0 ? void 0 : _feature$name.concat(':')) || ' ', " ").concat(feature.value || '  '));
  });
  var productEventData = (0,mapProduct/* mapProduct */.S)(product, index);

  var handleCompareClick = function handleCompareClick() {
    compare.toggle(id, category);
    if (isSponsored) (0,analyticsEvents/* dispatchCitrusAnalytics */.fz)(id, adId);
  };

  var hasCompare = product.compare && product.type === 'product' && compare.isAvailable;
  var comparing = compare.products.includes(id || productId);
  var compareProps = hasCompare ? {
    checked: comparing,
    disabled: compare.isDisabled && !comparing,
    onChange: handleCompareClick
  } : {};
  var swatchToUse = selectedSwatch !== null && selectedSwatch !== void 0 && selectedSwatch.isColorOfDefaultVariant ? undefined : selectedSwatch;

  var handleM2MClick = function handleM2MClick(e) {
    e.preventDefault();
    var clickedElement = e.currentTarget;
    var targetHref = clickedElement ? clickedElement.getAttribute('href') : '';
    handleDisplayM2MProductSelector(targetHref);
  };

  var getClickHandlerByType = function getClickHandlerByType(event) {
    switch (type) {
      case 'm2mFabric':
        return handleM2MClick(event);

      default:
        return null;
    }
  };

  var handleClick = function handleClick(event) {
    return getClickHandlerByType(event);
  };

  var singleSkuAtbAnalytics = function singleSkuAtbAnalytics() {
    (0,analyticsEvents/* dispatchImmediateAnalyticsEvent */.gM)(analyticsEvents/* ADD_TO_BASKET */.TR, {
      products: productEventData
    });

    if (adId) {
      (0,analyticsEvents/* dispatchCitrusAnalytics */.fz)(id, adId);
    }
  };

  var handleDisplayPromoModal = function handleDisplayPromoModal() {
    (0,analyticsEvents/* dispatchImmediateAnalyticsEvent */.gM)(analyticsEvents/* GLOBAL_INTERACTION */.sG, {
      type: 'plp',
      subType: 'promotions modal',
      additionalInfo: {},
      properties: {
        promotions: promoMessages
      },
      products: [{
        brand: product.brand,
        sku: defaultSkuId,
        price: price,
        productName: title,
        productId: id
      }]
    });
  };

  var urlToUse = adId ? "".concat(url, "#citrusAdId=").concat(adId) : url; // eslint-disable-next-line no-unused-vars

  var handleAltImageChangeAnalytics = function handleAltImageChangeAnalytics(prodId) {
    return function (defaultSkuId) {
      (0,analyticsEvents/* dispatchImmediateAnalyticsEvent */.gM)(analyticsEvents/* ALTERNATE_IMAGE */.tp, {
        productId: prodId
      });
    };
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    "data-test": "component-grid-column",
    className: classnames_default()(className, (ProductGrid_module_default())["product-grid__product"], (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, (ProductGrid_module_default())["product-grid__product--list-view"], isListViewOn), (0,defineProperty/* default */.Z)(_classNames, (ProductGrid_module_default())["product-grid__product--large"], isLargeCardSize), _classNames)),
    "data-grid-checked": isLargeCardSize ? 'max' : 'min',
    children: isListViewOn ? /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCardDetailed/* default */.Z, {
      product: ProductCardContainer_objectSpread(ProductCardContainer_objectSpread({}, product), {}, {
        additionalMessages: nonPromoMessages,
        colorSwatches: product.type !== 'productSet' && product.colorSwatches || null,
        image: overwriteImage({
          imageOverwriteFeature: imageOverwriteFeature,
          path: path,
          defaultSkuId: product.defaultSkuId,
          image: image
        }),
        promoMessages: promoMessages,
        url: type === 'productSet' && url ? "/browse".concat(url) : urlToUse,
        skuId: defaultSkuId,
        variantId: defaultVariantId
      }),
      handleQuickAddClick: handleDisplayQuickAdd,
      handleQuickViewClick: fetchQuickViewData,
      buttonSettings: {
        hasAddToBasketButton: !atbBlockList.includes(product.defaultSkuId),
        hasEmailMeWhenAvailableButton: true,
        hasMoreInformationButton: true,
        hasNotifyMeButton: true
      },
      hasCompare: hasCompare,
      compareProps: compareProps,
      handleEnergyRatingClick: openEnergyDrawer,
      hasEnergySideDrawer: true,
      hasHeroAttributes: isHeroAttributesFlagOn,
      hasLimitedSwatches: isLimitedSwatchesFlagOn,
      imageSettings: {
        loading: index < 4 ? 'eager' : 'lazy'
      },
      pricePrefix: pricePrefix,
      selectedSwatch: swatchToUse,
      socialProofMessage: isSocialProofingProductCardOn && (_socialProofingMessag = socialProofingMessages[id]) !== null && _socialProofingMessag !== void 0 && _socialProofingMessag.title ? (_socialProofingMessag2 = socialProofingMessages[id]) === null || _socialProofingMessag2 === void 0 ? void 0 : _socialProofingMessag2.title : null,
      sponsoredTitleEnabled: isSponsored,
      atbProps: {
        clientId: 'standard-plp',
        path: basketBFFService,
        onBeforeAdd: function onBeforeAdd() {
          return handleAddToBasketClick(productEventData);
        },
        onSuccess: productEventData.isMultiSku ? undefined : singleSkuAtbAnalytics
      },
      showPriceReduction: isPriceReductionFlagOn,
      hasPromoMessageModal: true,
      handleDisplayPromoModal: handleDisplayPromoModal,
      isPromoQuickViewFlagOn: isPromoQuickViewFlagOn,
      handleSwatchClick: function handleSwatchClick() {
        return isSponsored && (0,analyticsEvents/* dispatchCitrusAnalytics */.fz)(id, adId);
      },
      hasNowWasPricing: isNowWasFlagOn
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(ProductCard/* default */.Z, {
      product: ProductCardContainer_objectSpread(ProductCardContainer_objectSpread({}, product), {}, {
        colorSwatches: product.type !== 'productSet' && product.colorSwatches || null,
        image: overwriteImage({
          imageOverwriteFeature: imageOverwriteFeature,
          path: path,
          defaultSkuId: product.defaultSkuId,
          image: product.image
        }),
        price: price,
        promoMessages: promoMessages,
        skuId: defaultSkuId,
        url: type === 'productSet' && url ? "/browse".concat(url) : urlToUse,
        variantId: defaultVariantId,
        energy: product.energy
      }),
      hasShortCtaText: true,
      className: classnames_default()((ProductGrid_module_default()).product),
      handleQuickAddClick: handleDisplayQuickAdd,
      buttonSettings: {
        hasAddToBasketButton: !atbBlockList.includes(product.defaultSkuId) && hasCTAButton,
        hasEmailMeWhenAvailableButton: hasCTAButton,
        hasMoreInformationButton: hasCTAButton,
        hasNotifyMeButton: hasCTAButton,
        hasQuickViewButton: false
      },
      handleEnergyRatingClick: openEnergyDrawer,
      hasEnergySideDrawer: true,
      handleQuickViewClick: fetchQuickViewData,
      handleClick: handleClick,
      handleImageChange: handleAltImageChangeAnalytics(id),
      hasBrandedTitle: true,
      imageSettings: {
        loading: index < 4 ? 'eager' : 'lazy',
        sizes: imageSize,
        srcSetWidths: imageWidths
      },
      hasImageCarousel: isProductCardCarouselFeatureFlagOn,
      hasCarouselAltStart: isProductCardCarouselAltStartFeatureFlagOn,
      hasAltImageOnHover: !isMobileBreakpoint && isAltImageOnHoverFlagOn,
      isProductBadgingOn: true,
      isQuickViewIcon: hasQuickViewIcon && !isBelowQuickViewBreakpoint,
      isPromoQuickViewFlagOn: isPromoQuickViewFlagOn,
      pricePrefix: pricePrefix,
      selectedSwatch: swatchToUse,
      sponsoredTitleEnabled: isSponsored,
      socialProofMessage: isSocialProofingProductCardOn && (_socialProofingMessag3 = socialProofingMessages[id]) !== null && _socialProofingMessag3 !== void 0 && _socialProofingMessag3.title ? (_socialProofingMessag4 = socialProofingMessages[id]) === null || _socialProofingMessag4 === void 0 ? void 0 : _socialProofingMessag4.title : null,
      atbProps: {
        clientId: 'standard-plp',
        onSuccess: productEventData.isMultiSku ? undefined : singleSkuAtbAnalytics,
        path: basketBFFService,
        onBeforeAdd: function onBeforeAdd() {
          return handleAddToBasketClick(productEventData);
        }
      },
      showPriceReduction: isPriceReductionFlagOn,
      hasPromoMessageModal: true,
      handleDisplayPromoModal: handleDisplayPromoModal,
      handleSwatchClick: function handleSwatchClick() {
        return isSponsored && (0,analyticsEvents/* dispatchCitrusAnalytics */.fz)(id, adId);
      },
      hasNowWasPricing: isNowWasFlagOn,
      children: [hasCompare && /*#__PURE__*/(0,jsx_runtime.jsx)(compare_checkbox_CompareCheckbox, {
        ariaLabel: "Select for product comparison, ".concat(title),
        checked: comparing,
        disabled: compare.isDisabled && !comparing,
        id: "checkbox-".concat(product.id),
        onCompareClick: handleCompareClick
      }), nonPromoMessages && nonPromoMessages.map(function (nonPromoMessage) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(non_promo_message_NonPromoMessage, {
          message: nonPromoMessage
        }, nonPromoMessage);
      })]
    })
  });
};

var comparisonFn = function comparisonFn(prevProps, nextProps) {
  return prevProps.product.id === nextProps.product.id && prevProps.socialProofingMessages === nextProps.socialProofingMessages && prevProps.isLargeCardSize === nextProps.isLargeCardSize;
};

/* harmony default export */ var product_grid_ProductCardContainer = (/*#__PURE__*/external_React_default().memo(ProductCardContainer, comparisonFn));
;// CONCATENATED MODULE: ./src/components/product-grid/ProductGrid.jsx


function ProductGrid_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ProductGrid_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ProductGrid_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProductGrid_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
































var Modal = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 86314));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(86314)];
    }
  }
});

var ProductGrid_getConfig = config_default()(),
    ProductGrid_publicRuntimeConfig = ProductGrid_getConfig.publicRuntimeConfig;

var useProductGridData = function useProductGridData() {
  var _useProductContext = (0,ProductContext/* useProductContext */.$h)(),
      setProductContext = _useProductContext.setProductContext,
      totalNumberOfResults = _useProductContext.totalNumberOfResults,
      products = _useProductContext.products;

  var _useDiscoveryContext = useDiscoveryContext(),
      discoveryRailProducts = _useDiscoveryContext.products,
      discoveryRailTitle = _useDiscoveryContext.title;

  var _useSearchContext = (0,SearchContext/* useSearchContext */.AB)(),
      personalisedPlp = _useSearchContext.personalisedPlp;

  var pageCorrelationId = useRequestContext();

  var _useExperiencesContex = (0,Experiences/* useExperiencesContext */.Xe)(),
      experiences = _useExperiencesContex.experiences,
      isListViewOn = _useExperiencesContex.isListViewOn,
      isPriceReductionFlagOn = _useExperiencesContex.isPriceReductionFlagOn,
      isNowWasImpressionsFlagOn = _useExperiencesContex.isNowWasImpressionsFlagOn,
      isDiscoveryRailWithCTAButtonsFlagOn = _useExperiencesContex.isDiscoveryRailWithCTAButtonsFlagOn,
      monetateId = _useExperiencesContex.monetateId;

  var router = (0,next_router.useRouter)();
  var compare = (0,CompareContext/* useCompareContext */.EN)();
  var socialProofingMessages = useSocialProofContext();

  var _useProductCardSize = useProductCardSize(),
      isLargeCardSize = _useProductCardSize.isLargeCardSize;

  var _useEnergyDrawerData = (0,useEnergyDrawerData/* useEnergyDrawerData */.a)(),
      openEnergyDrawer = _useEnergyDrawerData.openEnergyDrawer;

  var imageSize = isLargeCardSize ? '(max-width: 567px) calc(100vw - 32px), (min-width: 568px) and (max-width:767px) calc(50vw - 24px), (min-width: 768px) and (max-width:1200px) calc(25vw - 30), 282px' : '(max-width: 567px) calc(50vw - 24px), (min-width: 568px) and (max-width:767px) calc(33vw - 21px), (min-width: 768px) and (max-width:1200px) calc(19vw - 32), 205px';
  var imageWidths = ['117', '234', '330', '366', '411', '564', '686'];
  return {
    products: products,
    totalNumberOfResults: totalNumberOfResults,
    setProductContext: setProductContext,
    discoveryRailProducts: discoveryRailProducts,
    discoveryRailTitle: discoveryRailTitle,
    personalisedPlp: personalisedPlp,
    pageCorrelationId: pageCorrelationId,
    socialProofingMessages: socialProofingMessages,
    imageSize: imageSize,
    imageWidths: imageWidths,
    router: router,
    compare: compare,
    isLargeCardSize: isLargeCardSize,
    experience: {
      experiences: experiences,
      isListViewOn: isListViewOn,
      isPriceReductionFlagOn: isPriceReductionFlagOn,
      isNowWasImpressionsFlagOn: isNowWasImpressionsFlagOn,
      isDiscoveryRailWithCTAButtonsFlagOn: isDiscoveryRailWithCTAButtonsFlagOn,
      monetateId: monetateId
    },
    openEnergyDrawer: openEnergyDrawer
  };
};
var ProductGrid = function ProductGrid(_ref) {
  var _ref$chunkSize = _ref.chunkSize,
      chunkSize = _ref$chunkSize === void 0 ? ProductGrid_publicRuntimeConfig.chunkSize : _ref$chunkSize,
      fetchQuickViewData = _ref.fetchQuickViewData,
      handleDisplayM2MProductSelector = _ref.handleDisplayM2MProductSelector,
      handleDisplayQuickAdd = _ref.handleDisplayQuickAdd,
      _ref$pageSize = _ref.pageSize,
      pageSize = _ref$pageSize === void 0 ? ProductGrid_publicRuntimeConfig.pageSize : _ref$pageSize,
      isLoadingChunk = _ref.isLoadingChunk,
      isLoadingPage = _ref.isLoadingPage,
      setIsLoadingChunk = _ref.setIsLoadingChunk,
      isChunkLoadError = _ref.isChunkLoadError,
      setIsChunkLoadError = _ref.setIsChunkLoadError;

  var _useProductGridData = useProductGridData(),
      setProductContext = _useProductGridData.setProductContext,
      totalNumberOfResults = _useProductGridData.totalNumberOfResults,
      products = _useProductGridData.products,
      discoveryRailProducts = _useProductGridData.discoveryRailProducts,
      personalisedPlp = _useProductGridData.personalisedPlp,
      discoveryRailTitle = _useProductGridData.discoveryRailTitle,
      pageCorrelationId = _useProductGridData.pageCorrelationId,
      socialProofingMessages = _useProductGridData.socialProofingMessages,
      isLargeCardSize = _useProductGridData.isLargeCardSize,
      imageSize = _useProductGridData.imageSize,
      imageWidths = _useProductGridData.imageWidths,
      experience = _useProductGridData.experience,
      router = _useProductGridData.router,
      compare = _useProductGridData.compare,
      openEnergyDrawer = _useProductGridData.openEnergyDrawer;

  var experiences = experience.experiences,
      isListViewOn = experience.isListViewOn,
      isNowWasImpressionsFlagOn = experience.isNowWasImpressionsFlagOn,
      isDiscoveryRailWithCTAButtonsFlagOn = experience.isDiscoveryRailWithCTAButtonsFlagOn,
      monetateId = experience.monetateId;
  var _router$query = router.query,
      _router$query$chunk = _router$query.chunk,
      chunk = _router$query$chunk === void 0 ? 1 : _router$query$chunk,
      _router$query$page = _router$query.page,
      page = _router$query$page === void 0 ? 1 : _router$query$page,
      facetId = _router$query.facetId,
      searchTerm = _router$query['search-term'],
      type = _router$query.type,
      _router$query$sortBy = _router$query.sortBy,
      sortBy = _router$query$sortBy === void 0 ? '' : _router$query$sortBy,
      listHead = _router$query.listHead,
      lolcode = _router$query.lolcode,
      price = _router$query.price,
      priceBands = _router$query.priceBands;
  var pageRef = (0,external_React_.useRef)(page);
  var THRESHOLD = 1800; // pixels

  var _useState = (0,external_React_.useState)(false),
      chunkLoadingSentinelInView = _useState[0],
      setChunkLoadingSentinelInView = _useState[1];

  var _useState2 = (0,external_React_.useState)(null),
      addToBasketError = _useState2[0],
      setAddToBasketError = _useState2[1];

  var _useState3 = (0,external_React_.useState)(false),
      isMobileBreakpoint = _useState3[0],
      setIsMobileBreakpoint = _useState3[1];

  var _useState4 = (0,external_React_.useState)(false),
      isBelowQuickViewBreakpoint = _useState4[0],
      setIsBelowQuickViewBreakpoint = _useState4[1];

  var productsToCurrentChunk = (0,external_React_.useMemo)(function () {
    if (chunk == 8 || products.length > totalNumberOfResults && totalNumberOfResults % chunkSize === 0) {
      return products;
    } else {
      return products.slice(0, chunk * chunkSize);
    }
  }, [products]);

  var clearAddToBasketError = function clearAddToBasketError() {
    setAddToBasketError(null);
  };

  var handleAddToBasketClick = function handleAddToBasketClick() {
    return Promise.resolve();
  };

  var handleResize = function handleResize() {
    setIsMobileBreakpoint(window.innerWidth < constants/* default.MOBILE_MAX_WIDTH */.Z.MOBILE_MAX_WIDTH);
    setIsBelowQuickViewBreakpoint(window.innerWidth < constants/* default.QUICK_VIEW_MIN_WIDTH */.Z.QUICK_VIEW_MIN_WIDTH);
  };

  var setChunkNumber = function setChunkNumber(newChunkNumber) {
    router_default().replace({
      query: ProductGrid_objectSpread(ProductGrid_objectSpread({}, router.query), {}, {
        chunk: newChunkNumber
      })
    }, null, {
      shallow: true,
      scroll: false
    });
  };

  var handleChunkLoadAnalytics = function handleChunkLoadAnalytics(chunkNum, chunkProducts) {
    var numberOfProductsToCurrentChunk = (chunkNum - 1) * chunkSize;
    var numberOfAdditionalSponsoredProducts = products.length - numberOfProductsToCurrentChunk;
    (0,analyticsEvents/* dispatchImmediateAnalyticsEvent */.gM)(analyticsEvents/* CHUNK_LOADED */.fv, {
      chunkDetails: {
        chunkOffset: chunkNum - 1,
        products: chunkProducts.map(function (product, i) {
          return (0,mapProduct/* mapProduct */.S)(product, numberOfProductsToCurrentChunk + numberOfAdditionalSponsoredProducts + i);
        }),
        personalisedPlp: personalisedPlp
      }
    });
  };

  (0,external_React_.useEffect)(function () {
    var didCancel = false;

    if (page !== pageRef.current) {
      // There was a issue where the PLP was scrolling to the bottom, and not displaying all chunks,
      // when the back button was used to go from PLP to PLP.  This is because the browser scroll restore
      // happens before the product cards are rendered. This scroll is a lesser evil.(PLP-1059)
      window.scrollTo(0, 0);
      pageRef.current = page; // do not load chunks if this is running as a result of a page change (eg. back button)

      return;
    }

    if (chunk * chunkSize > products.length && (page - 1) * pageSize + products.length < totalNumberOfResults) {
      setIsLoadingChunk(true);
      getProductChunks({
        page: page,
        chunk: chunk,
        term: searchTerm,
        type: type,
        facetId: facetId,
        sortBy: sortBy,
        listHead: listHead,
        lolcode: lolcode,
        price: price,
        priceBands: priceBands
      }, pageCorrelationId).then(function (products) {
        setIsLoadingChunk(false);

        if (!didCancel) {
          setProductContext(products);
          handleChunkLoadAnalytics(chunk, products);
        }
      })["catch"](function () {
        setIsLoadingChunk(false);
        setIsChunkLoadError(true);
        setChunkNumber(chunk - 1);
      });
    }

    return function () {
      didCancel = true;
    };
  }, [chunk, page]);
  (0,external_React_.useEffect)(function () {
    var hasProductWithOffers = productsToCurrentChunk.find(function (p) {
      var _p$promoMessages;

      return (_p$promoMessages = p.promoMessages) === null || _p$promoMessages === void 0 ? void 0 : _p$promoMessages.length;
    });

    if (hasProductWithOffers) {
      (0,Experiences/* dispatchMonetateManagedImpressions */.Te)({
        monetateId: monetateId,
        experiences: experiences,
        monetateFlagName: 'offersBadgeImpressionsEnabled'
      });
    }
  }, [products, chunk]);
  (0,external_React_.useEffect)(function () {
    if (isNowWasImpressionsFlagOn) {
      var hasProductChangedPrice = productsToCurrentChunk.find(function (p) {
        var _p$price;

        return (_p$price = p.price) === null || _p$price === void 0 ? void 0 : _p$price.was;
      });

      if (hasProductChangedPrice) {
        (0,Experiences/* dispatchMonetateManagedImpressions */.Te)({
          monetateId: monetateId,
          experiences: experiences,
          monetateFlagName: 'nowWasImpressionsEnabled'
        });
      }
    }
  }, [products, chunk]);
  (0,external_React_.useEffect)(function () {
    if (personalisedPlp) {
      (0,Experiences/* dispatchMonetateManagedImpressions */.Te)({
        monetateId: monetateId,
        experiences: experiences,
        monetateFlagName: 'discoImpressionsEnabled'
      });
    }
  }, [personalisedPlp]);
  (0,external_React_.useEffect)(function () {
    var didCancel = false;

    if (chunkLoadingSentinelInView && !isLoadingPage && !isLoadingChunk && !isChunkLoadError) {
      var nextChunk = Number(chunk) + 1;

      if ( // have reached the end of this page?
      nextChunk * chunkSize > pageSize || // have we reached the end of the whole result set?
      (page - 1) * pageSize + chunk * chunkSize >= totalNumberOfResults) {
        return;
      }

      if (!didCancel) {
        setChunkNumber(nextChunk);
      }
    }

    return function () {
      didCancel = true;
    };
  }, [chunkLoadingSentinelInView]);
  (0,external_React_.useEffect)(function () {
    var footerEl = document.getElementById('footer-wrapper');
    setChunkLoadingSentinelInView((footerEl === null || footerEl === void 0 ? void 0 : footerEl.getBoundingClientRect().top) < THRESHOLD);
    var destroyobserver = (0,react_intersection_observer_m/* observe */.N7)(footerEl, setChunkLoadingSentinelInView, {
      rootMargin: "".concat(THRESHOLD, "px")
    });
    setIsMobileBreakpoint(window.innerWidth <= constants/* default.MOBILE_MAX_WIDTH */.Z.MOBILE_MAX_WIDTH);
    setIsBelowQuickViewBreakpoint(window.innerWidth < constants/* default.QUICK_VIEW_MIN_WIDTH */.Z.QUICK_VIEW_MIN_WIDTH);
    handleResize();
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
      destroyobserver();
    };
  }, []);

  var handleManualChunkLoad = function handleManualChunkLoad() {
    setIsChunkLoadError(false);
    setChunkNumber(Number(chunk) + 1);
  };

  var getImagePreload = function getImagePreload(imageUrl, imageSize, imageWidths) {
    var srcSetArr = imageWidths.map(function (width) {
      return "".concat(imageUrl.split('?')[0], "?wid=").concat(width, "&hei=").concat(Math.round(width / 0.75), " ").concat(width, "w");
    });
    return /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      as: "image",
      fetchpriority: "high",
      href: srcSetArr[0].split(' ')[0],
      imageSrcSet: srcSetArr.join(', '),
      imageSizes: imageSize
    });
  };

  var AllProductCards = (0,external_React_.useMemo)(function () {
    return productsToCurrentChunk.map(function (product, index) {
      var productId = product.productId,
          image = product.image,
          type = product.type;
      var pricePrefix = type === 'm2mRollerBlind' ? 'Blind price from' : undefined;
      var isLastProductOnPage = index + 1 === ProductGrid_publicRuntimeConfig.pageSize;
      var isMultipleOfViewedProductFrequency = (index + 1) % chunkSize === 0;
      var shouldShowProductCount = !isLastProductOnPage && isMultipleOfViewedProductFrequency;
      var shouldShowDiscoveryRail = (discoveryRailProducts === null || discoveryRailProducts === void 0 ? void 0 : discoveryRailProducts.length) > 4 && totalNumberOfResults >= chunkSize * 2 && index === chunkSize - 5;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)((external_React_default()).Fragment, {
        children: [index === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
          children: getImagePreload(image, imageSize, imageWidths)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(product_grid_ProductCardContainer, {
          product: product,
          index: index,
          isLargeCardSize: isLargeCardSize,
          isMobileBreakpoint: isMobileBreakpoint,
          isBelowQuickViewBreakpoint: isBelowQuickViewBreakpoint,
          openEnergyDrawer: openEnergyDrawer,
          handleAddToBasketClick: handleAddToBasketClick,
          handleDisplayQuickAdd: handleDisplayQuickAdd,
          fetchQuickViewData: fetchQuickViewData,
          imageSize: imageSize,
          imageWidths: imageWidths,
          handleDisplayM2MProductSelector: handleDisplayM2MProductSelector,
          socialProofingMessages: socialProofingMessages,
          pricePrefix: pricePrefix
        }), shouldShowDiscoveryRail && /*#__PURE__*/(0,jsx_runtime.jsx)("aside", {
          "data-test": "discovery-rail",
          className: (ProductGrid_module_default())["discovery-rail"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCardCarousel.BETA_ProductCardCarousel, {
            heading: discoveryRailTitle,
            children: discoveryRailProducts.slice(0, 10).map(function (railProduct, i) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(product_grid_ProductCardContainer, {
                className: (ProductGrid_module_default())["discovery-rail__product"],
                fetchQuickViewData: fetchQuickViewData,
                handleAddToBasketClick: handleAddToBasketClick,
                handleDisplayM2MProductSelector: handleDisplayM2MProductSelector,
                handleDisplayQuickAdd: handleDisplayQuickAdd,
                hasCTAButton: isDiscoveryRailWithCTAButtonsFlagOn,
                hasQuickViewIcon: isDiscoveryRailWithCTAButtonsFlagOn,
                imageSize: imageSize,
                imageWidths: imageWidths,
                index: i,
                isBelowQuickViewBreakpoint: isBelowQuickViewBreakpoint,
                isLargeCardSize: isLargeCardSize,
                isMobileBreakpoint: isMobileBreakpoint,
                openEnergyDrawer: openEnergyDrawer,
                pricePrefix: pricePrefix,
                product: railProduct,
                socialProofingMessages: socialProofingMessages
              }, "discovery-rail-card-".concat(i));
            })
          })
        }), shouldShowProductCount && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "data-test": "component-grid-column",
          className: classnames_default()((ProductGrid_module_default())["product-count"], (0,defineProperty/* default */.Z)({}, (ProductGrid_module_default())["product-count--list-view"], isListViewOn)),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(product_count_ProductCount, {
            positionOnPage: index,
            isListViewOn: isListViewOn
          })
        })]
      }, "".concat(productId));
    });
  }, [products, isLargeCardSize, compare, socialProofingMessages]);

  var structuredData = /*#__PURE__*/(0,jsx_runtime.jsx)(structured_data_StructuredData, {
    children: function children() {
      return {
        '@type': 'ItemList',
        '@context': 'https://schema.org',
        numberOfItems: "(".concat(products.length, ")"),
        itemListElement: products.map(function (product, i) {
          return {
            '@type': 'ListItem',
            url: "https://www.johnlewis.com".concat((0,getProductUrl["default"])(product.title, product.id)),
            position: i + 1
          };
        })
      };
    }
  });

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      "data-test": "component-grid-container",
      "data-test-id": "product-grid",
      "data-monetate": "disruptor-block-identifier",
      className: (ProductGrid_module_default())["product-grid"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "total-number-of-items",
        content: products.length
      }), structuredData, AllProductCards]
    }), isLoadingChunk && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ProductGrid_module_default()).chunkLoadingSpinner,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LoadingSpinner["default"], {})
    }), isChunkLoadError && /*#__PURE__*/(0,jsx_runtime.jsx)(Message.Message, {
      type: "error",
      title: "There has been an error, please try again.",
      buttonText: "Load more products",
      buttonProps: {
        onClick: handleManualChunkLoad
      },
      className: (ProductGrid_module_default()).chunkLoadErrorMessage
    }), addToBasketError && /*#__PURE__*/(0,jsx_runtime.jsx)(Modal, {
      isOpen: true,
      header: "Something went wrong",
      onClose: clearAddToBasketError,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Message.Message, {
        title: addToBasketError.message,
        type: "error"
      })
    })]
  });
};

var ProductGrid_comparisonFn = function comparisonFn(prevProps, nextProps) {
  return nextProps.isLoadingPage === true;
};

/* harmony default export */ var product_grid_ProductGrid = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(ProductGrid, ProductGrid_comparisonFn))));
ProductGrid.displayName = 'ProductGrid';
ProductGrid.defaultProps = {
  category: '',
  fetchQuickViewData: function fetchQuickViewData() {},
  products: [],
  pageSize: 192,
  chunkSize: 24
};
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/elements/select/Select.js
var Select = __webpack_require__(60768);
// EXTERNAL MODULE: ./src/hooks/useAnalyticsData.tsx
var useAnalyticsData = __webpack_require__(36710);
// EXTERNAL MODULE: ./src/hooks/useAnalytics.tsx
var useAnalytics = __webpack_require__(48549);
;// CONCATENATED MODULE: ./src/components/sort/options.js
/* istanbul ignore file */
var sortOptions = [{
  label: 'Sort: Relevance',
  value: 'relevance'
}, {
  label: 'Price high to low',
  value: 'priceHigh'
}, {
  label: 'Price low to high',
  value: 'priceLow'
}, {
  label: 'Newness',
  value: 'new'
}, {
  label: 'Popularity',
  value: 'popularity'
}, {
  label: 'Rating',
  value: 'rating'
}, {
  label: 'Discount % high to low',
  value: 'discount'
}];
// EXTERNAL MODULE: ./src/components/sort/Sort.module.scss
var Sort_module = __webpack_require__(40443);
var Sort_module_default = /*#__PURE__*/__webpack_require__.n(Sort_module);
;// CONCATENATED MODULE: ./src/components/sort/Sort.jsx



function Sort_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Sort_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Sort_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Sort_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var Sort = function Sort(_ref) {
  var sort = _ref.sort;

  var _useState = (0,external_React_.useState)(false),
      isInteractive = _useState[0],
      setIsInteractive = _useState[1];

  var _useAnalyticsData = (0,useAnalyticsData/* useAnalyticsData */.I)(),
      pageType = _useAnalyticsData.pageType;

  var sortByEvent = (0,useAnalytics/* useAnalytics */.z)(analyticsEvents/* SORT_OPTION_CHANGED */.OG, {
    pagetype: pageType
  });
  var router = (0,next_router.useRouter)();
  var filteredParams = Object.entries(router.query).filter(function (_ref2) {
    var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),
        key = _ref3[0],
        val = _ref3[1];

    return !['page', 'sortBy'].includes(key) && val;
  });
  var actionUrl = router.asPath;

  var handleSort = function handleSort(e) {
    e.preventDefault();
    var sortBy = e.target.value;
    sortByEvent({
      sort: sortBy
    });
    var href = router.pathname,
        query = router.query;
    var facetId = query.facetId,
        type = query.type;

    if (type === 's') {
      query['search-term'] = facetId[0].replace(/-/g, ' ');
      query.type = 'search';
      delete query.facetId;
    }

    var pathname = type === 's' ? "/search" : document.location.pathname;
    var url = {
      pathname: href,
      query: (0,StatefulLink/* getQueryParams */.vl)(Sort_objectSpread(Sort_objectSpread({}, query), {}, {
        page: '',
        sortBy: sortBy
      }), (0,StatefulLink/* facetsFilter */.xK)())
    };
    var as = "".concat(pathname, "?").concat((0,StatefulLink/* getQueryString */.Wz)(url.query));
    router.push(url, as);
    window.scrollTo(0, 0);
  };

  (0,external_React_.useEffect)(function () {
    setIsInteractive(true);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)((external_React_default()).Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Sort_module_default()).sort,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
        action: actionUrl,
        method: "GET",
        className: (Sort_module_default()).sort__form,
        children: [filteredParams.map(function (_ref4) {
          var _ref5 = (0,slicedToArray/* default */.Z)(_ref4, 2),
              name = _ref5[0],
              value = _ref5[1];

          return /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            name: name,
            value: value,
            type: "hidden"
          }, name);
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: classnames_default()((Sort_module_default()).sort__select),
          "data-test": "sort-by",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            className: (Sort_module_default()).visuallyHidden,
            htmlFor: "sortBy",
            children: "Sort by"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Select["default"], {
            id: "sortBy",
            name: "sortBy",
            value: sort,
            onChange: handleSort,
            options: sortOptions
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button.PrimaryButton, {
          type: "submit",
          className: classnames_default()((Sort_module_default()).sort__submit, (0,defineProperty/* default */.Z)({}, (Sort_module_default())["sort__submit--visible"], !isInteractive)),
          children: "Go"
        })]
      })
    })
  });
};

Sort.defaultProps = {
  sort: ''
};
/* harmony default export */ var sort_Sort = (/*#__PURE__*/(0,external_React_.memo)(Sort));
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/ChevronLeft24PxOutlined.js
var ChevronLeft24PxOutlined = __webpack_require__(11209);
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/ChevronRight24PxOutlined.js
var ChevronRight24PxOutlined = __webpack_require__(35204);
// EXTERNAL MODULE: ./src/components/pagination/Pagination.module.scss
var Pagination_module = __webpack_require__(650);
var Pagination_module_default = /*#__PURE__*/__webpack_require__.n(Pagination_module);
;// CONCATENATED MODULE: ./src/components/pagination/Pagination.jsx


var Pagination_excluded = ["pages", "current", "className", "isFooter"];

function Pagination_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Pagination_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Pagination_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Pagination_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











/**
 * Create Page array
 * @param totalPages
 * @param activePage
 * @returns {number[]|Array}
 */



var getPages = function getPages(totalPages, activePage) {
  if (totalPages <= 7) {
    return [1, 2, 3, 4, 5, 6, 7].slice(0, totalPages);
  }

  var pages = [];
  var start = activePage - 2;
  var end = activePage + 2;

  if (start < 2) {
    var diff = 2 - start;
    end += diff;
    start += diff;
  }

  if (end > totalPages - 1) {
    var _diff = end - (totalPages - 1);

    end -= _diff;
    start -= _diff;
  }

  var startEllipsis = activePage > 3;
  var endEllipsis = activePage < totalPages - 2;
  pages.push(1);
  pages.push(startEllipsis ? '...' : start);

  for (var i = start + 1; i <= end - 1; i += 1) {
    pages.push(i);
  }

  pages.push(endEllipsis ? '...' : end);
  pages.push(totalPages);
  return pages;
};
var Pagination = function Pagination(_ref) {
  var pages = _ref.pages,
      current = _ref.current,
      className = _ref.className,
      isFooter = _ref.isFooter,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Pagination_excluded);

  var totalPages = pages;
  var activePage = current || 1;

  var _useAnalyticsData = (0,useAnalyticsData/* useAnalyticsData */.I)(),
      pageType = _useAnalyticsData.pageType;

  var paginationEvent = (0,useAnalytics/* useAnalytics */.z)(analyticsEvents/* PAGINATION */.Xg);

  var onSelect = function onSelect(pageNum) {
    return paginationEvent({
      pagetype: pageType,
      pageNum: pageNum
    });
  };

  if (totalPages < 2) {
    return null;
  }

  var paginationPages = getPages(totalPages, activePage);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("nav", Pagination_objectSpread(Pagination_objectSpread({
    className: classnames_default()((Pagination_module_default())["c-pagination"], className, "".concat(isFooter ? (Pagination_module_default())["c-pagination--footer"] : (Pagination_module_default())["c-pagination--header"]))
  }, rest), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      className: classnames_default()((Pagination_module_default())["c-pagination__list"]),
      "data-test": isFooter ? 'pagination-footer' : 'pagination',
      children: [activePage > 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: classnames_default()([(Pagination_module_default())["c-pagination__prev"], (Pagination_module_default())["c-pagination__item"]]),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StatefulLink/* default */.ZP, {
          query: {
            page: activePage - 1
          },
          queryOpts: {
            filter: (0,StatefulLink/* facetsFilter */.xK)()
          },
          "aria-label": "Previous",
          onClick: function onClick(event) {
            return onSelect(activePage - 1, event);
          },
          "data-test": "prev-btn",
          className: classnames_default()([(Pagination_module_default())["c-pagination__btn"], (Pagination_module_default())["c-pagination__prev-btn"]]),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ChevronLeft24PxOutlined["default"], {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Button.UnderlinedButton, {
            tag: "span",
            className: (Pagination_module_default())["c-pagination__prev-text"],
            children: "Previous"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: classnames_default()([(Pagination_module_default())["c-pagination__pages"], (Pagination_module_default())["c-pagination__item"]]),
        children: paginationPages.map(function (page, index) {
          switch (page) {
            case '...':
              return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (Pagination_module_default())["c-pagination__ellipsis"],
                "data-test": "ellipsis",
                children: "..."
              }, index === 1 ? 'e1' : 'e2');

            case activePage:
              return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                "data-test": "page-active",
                className: classnames_default()([(Pagination_module_default())["c-pagination__btn"], (Pagination_module_default())["c-pagination__active"], (Pagination_module_default())["c-pagination__active-underline"]]),
                children: page
              }, page);

            default:
              return /*#__PURE__*/(0,jsx_runtime.jsx)(StatefulLink/* default */.ZP, {
                query: {
                  page: page
                },
                queryOpts: {
                  filter: (0,StatefulLink/* facetsFilter */.xK)()
                },
                onClick: function onClick(event) {
                  return onSelect(page, event);
                },
                "data-test": "page-btn",
                className: classnames_default()([(Pagination_module_default())["c-pagination__btn"], (0,defineProperty/* default */.Z)({}, (Pagination_module_default())["c-pagination__active"], activePage === page)]),
                children: page
              }, page);
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: classnames_default()([(Pagination_module_default())["c-pagination__next"], (Pagination_module_default())["c-pagination__item"]]),
        children: activePage < totalPages && /*#__PURE__*/(0,jsx_runtime.jsxs)(StatefulLink/* default */.ZP, {
          query: {
            page: activePage + 1
          },
          queryOpts: {
            filter: (0,StatefulLink/* facetsFilter */.xK)()
          },
          role: "button",
          "aria-label": "Next",
          className: classnames_default()([(Pagination_module_default())["c-pagination__btn"], (Pagination_module_default())["c-pagination__next-btn"]]),
          "data-test": "next-btn",
          onClick: function onClick(event) {
            return onSelect(activePage + 1, event);
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button.UnderlinedButton, {
            tag: "span",
            className: (Pagination_module_default())["c-pagination__next-text"],
            children: "Next"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ChevronRight24PxOutlined/* default */.ZP, {})]
        })
      })]
    })
  }));
};
Pagination.defaultProps = {
  pages: undefined,
  current: undefined,
  isFooter: false
};
/* harmony default export */ var pagination_Pagination = (/*#__PURE__*/(0,external_React_.memo)(Pagination));
// EXTERNAL MODULE: ./src/components/sticky-controls/controls/Controls.module.scss
var Controls_module = __webpack_require__(23350);
var Controls_module_default = /*#__PURE__*/__webpack_require__.n(Controls_module);
;// CONCATENATED MODULE: ./src/context/AnchorCardContext.jsx


var AnchorCardContext_Context = /*#__PURE__*/external_React_default().createContext();
var useAnchorCardContext = function useAnchorCardContext() {
  return (0,external_React_.useContext)(AnchorCardContext_Context);
};
var AnchorCardContext_Provider = function Provider(_ref) {
  var children = _ref.children;

  var _useState = (0,external_React_.useState)(null),
      anchorCard = _useState[0],
      setAnchorCard = _useState[1];

  var value = {
    anchorCard: anchorCard,
    setAnchorCard: setAnchorCard
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AnchorCardContext_Context.Provider, {
    value: value,
    children: children
  });
};
// EXTERNAL MODULE: ./src/components/sticky-controls/controls/ProductCardToggles.module.scss
var ProductCardToggles_module = __webpack_require__(62013);
var ProductCardToggles_module_default = /*#__PURE__*/__webpack_require__.n(ProductCardToggles_module);
;// CONCATENATED MODULE: ./src/components/sticky-controls/controls/ProductCardToggles.jsx












var ProductCardToggles = function ProductCardToggles() {
  var _useProductCardSize = useProductCardSize(),
      isLargeCardSize = _useProductCardSize.isLargeCardSize,
      largeCardUrl = _useProductCardSize.largeCardUrl,
      standardCardUrl = _useProductCardSize.standardCardUrl;

  var _useAnchorCardContext = useAnchorCardContext(),
      setAnchorCard = _useAnchorCardContext.setAnchorCard;

  var router = (0,next_router.useRouter)();

  var handleClick = function handleClick() {
    var topOfControls = document.querySelector('[data-test="component-sticky-controls"]').getBoundingClientRect().top;
    var productCards = document.querySelectorAll('[data-test="product-card"]');
    var firstCardInView = Array.from(productCards).find(function (el) {
      return el.getBoundingClientRect().top >= topOfControls;
    });
    var firstCardPid = firstCardInView.dataset.productId;
    var toggleUrl = isLargeCardSize ? standardCardUrl : largeCardUrl;
    router.push(toggleUrl.href, toggleUrl.as, {
      scroll: false
    });
    (0,analyticsEvents/* dispatchImmediateAnalyticsEvent */.gM)(analyticsEvents/* GLOBAL_INTERACTION */.sG, {
      action: analyticsEvents/* GLOBAL_INTERACTION */.sG,
      type: 'plp',
      subType: 'card size toggle',
      additionalInfo: {
        size: !isLargeCardSize ? 'large' : 'small'
      },
      properties: {},
      products: [{}]
    });

    if (window.scrollY) {
      setAnchorCard(firstCardPid);
    } else {
      setAnchorCard(null);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    "data-test": "product-card-toggle-form",
    className: classnames_default()((ProductCardToggles_module_default()).form),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: classnames_default()((ProductCardToggles_module_default()).formLabel),
      children: "Image Size"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Button.SecondaryButton, {
      role: "switch",
      "aria-checked": isLargeCardSize,
      "aria-label": "Larger product images",
      className: classnames_default()((ProductCardToggles_module_default()).toggleButton),
      onClick: handleClick,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ToggleOption, {
        option: "small",
        selected: !isLargeCardSize
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ToggleOption, {
        option: "large",
        selected: isLargeCardSize
      })]
    })]
  });
};
var SizeIcon = function SizeIcon(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'small' : _ref$type;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    className: classnames_default()((ProductCardToggles_module_default()).sizeIcon, (0,defineProperty/* default */.Z)({}, (ProductCardToggles_module_default())["icon-".concat(type)], true))
  });
};
var ToggleOption = function ToggleOption(_ref2) {
  var _classNames2;

  var option = _ref2.option,
      selected = _ref2.selected;
  var displayName = {
    small: 'Small',
    large: 'Large'
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      "data-test": "product-card-toggle-button-".concat(option),
      className: classnames_default()((ProductCardToggles_module_default()).toggleOption, (_classNames2 = {}, (0,defineProperty/* default */.Z)(_classNames2, (ProductCardToggles_module_default())["option-".concat(option)], true), (0,defineProperty/* default */.Z)(_classNames2, (ProductCardToggles_module_default()).selected, selected), _classNames2)),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SizeIcon, {
        type: option
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()((ProductCardToggles_module_default()).toggleOptionText),
        children: displayName[option]
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/components/sticky-controls/controls/Controls.jsx












var Controls = function Controls(_ref) {
  var handleSelect = _ref.handleSelect,
      sortBy = _ref.sortBy,
      pages = _ref.pages,
      current = _ref.current,
      handleFilterDrawerClick = _ref.handleFilterDrawerClick;

  var _useExperiencesContex = (0,Experiences/* useExperiencesContext */.Xe)(),
      isProductCardSizeFlagOn = _useExperiencesContex.isProductCardSizeFlagOn,
      isListViewOn = _useExperiencesContex.isListViewOn;

  var _useFacetContext = (0,FacetContext/* useFacetContext */.gv)(),
      isMoreFiltersButton = _useFacetContext.isPrimaryFacetInDiscoResponse;

  var testId = isMoreFiltersButton ? 'more-filters-button' : 'filters-button';
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button.SecondaryButton, {
      className: (Controls_module_default())["filter-drawer-button"],
      "data-test": testId,
      onClick: handleFilterDrawerClick,
      children: "Filter"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(sort_Sort, {
      onSelect: handleSelect,
      sort: sortBy
    }), isProductCardSizeFlagOn && !isListViewOn && /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCardToggles, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Controls_module_default())["align-right"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(pagination_Pagination, {
        current: parseInt(current, 10),
        pages: pages,
        "aria-label": "Product listing page pagination"
      })
    })]
  });
};

Controls.defaultProps = {
  sortBy: '',
  pages: 1,
  current: '1',
  handleFilterDrawerClick: function handleFilterDrawerClick() {}
};
/* harmony default export */ var controls_Controls = (/*#__PURE__*/(0,external_React_.memo)(Controls));
// EXTERNAL MODULE: ./src/components/sticky-controls/StickyControls.module.scss
var StickyControls_module = __webpack_require__(1635);
var StickyControls_module_default = /*#__PURE__*/__webpack_require__.n(StickyControls_module);
;// CONCATENATED MODULE: ./src/components/sticky-controls/StickyControls.jsx


var StickyControls_excluded = ["isHeaderPeeping"];

function StickyControls_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function StickyControls_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? StickyControls_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : StickyControls_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var StickyControls = function StickyControls(_ref) {
  var isHeaderPeeping = _ref.isHeaderPeeping,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, StickyControls_excluded);

  var _useExperiencesContex = (0,Experiences/* useExperiencesContext */.Xe)(),
      isProductCardSizeFlagOn = _useExperiencesContex.isProductCardSizeFlagOn;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(react_intersection_observer_m/* InView */.df, {
    initialInView: true,
    children: function children(_ref2) {
      var _classNames, _classNames2;

      var inView = _ref2.inView,
          ref = _ref2.ref;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          ref: ref,
          className: (StickyControls_module_default())["sticky-sentinel"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()((StickyControls_module_default())["sticky-controls"], (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, (StickyControls_module_default()).isHeaderPeeping, isHeaderPeeping), (0,defineProperty/* default */.Z)(_classNames, (StickyControls_module_default())["sticky-controls--isStuck"], !inView), _classNames)),
          "data-test": "component-sticky-controls",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: classnames_default()((StickyControls_module_default())["sticky-controls__controls"], (_classNames2 = {}, (0,defineProperty/* default */.Z)(_classNames2, (StickyControls_module_default())["sticky-controls__controls--change-card-size"], isProductCardSizeFlagOn), (0,defineProperty/* default */.Z)(_classNames2, (StickyControls_module_default())["sticky-controls__controls--isStuck"], !inView), _classNames2)),
            "data-test": "component-controls-container",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(controls_Controls, StickyControls_objectSpread({}, props))
          })
        })]
      });
    }
  });
};

StickyControls.defaultProps = {
  current: '1',
  isHeaderPeeping: false,
  pages: 1,
  sortBy: ''
};
/* harmony default export */ var sticky_controls_StickyControls = (StickyControls);
// EXTERNAL MODULE: ./src/components/loading/Loading.tsx
var Loading = __webpack_require__(23824);
// EXTERNAL MODULE: ./src/components/facets/applied-filters/AppliedFilters.jsx
var AppliedFilters = __webpack_require__(26180);
// EXTERNAL MODULE: ./src/components/facets/facet-context/index.jsx
var facet_context = __webpack_require__(22418);
// EXTERNAL MODULE: ./src/components/product-listing/ProductListing.module.scss
var ProductListing_module = __webpack_require__(97997);
var ProductListing_module_default = /*#__PURE__*/__webpack_require__.n(ProductListing_module);
;// CONCATENATED MODULE: ./src/components/product-listing/ProductListing.jsx

















var ProductListing_getCategory = function getCategory(breadcrumbs) {
  if (breadcrumbs && breadcrumbs[breadcrumbs.length - 1]) {
    var _breadcrumbs;

    return ((_breadcrumbs = breadcrumbs[breadcrumbs.length - 1]) === null || _breadcrumbs === void 0 ? void 0 : _breadcrumbs.displayName) || '';
  }

  return '';
};
var useProductListingData = function useProductListingData() {
  var _useAnchorCardContext = useAnchorCardContext(),
      anchorCard = _useAnchorCardContext.anchorCard;

  var facetContext = (0,FacetContext/* useFacetContext */.gv)();

  var _useProductContext = (0,ProductContext/* useProductContext */.$h)(),
      pagesAvailable = _useProductContext.pagesAvailable;

  var router = (0,next_router.useRouter)();
  return {
    anchorCard: anchorCard,
    facetContext: facetContext,
    pagesAvailable: pagesAvailable,
    router: router
  };
};
var ProductListing = /*#__PURE__*/(0,external_React_.memo)(function (props) {
  var _useState = (0,external_React_.useState)(false),
      isLoadingPage = _useState[0],
      setIsLoadingPage = _useState[1];

  var _useState2 = (0,external_React_.useState)(false),
      isLoadingChunk = _useState2[0],
      setIsLoadingChunk = _useState2[1];

  var _useState3 = (0,external_React_.useState)(false),
      isChunkLoadError = _useState3[0],
      setIsChunkLoadError = _useState3[1];

  var _useProductCardSize = useProductCardSize(),
      isLargeCardSize = _useProductCardSize.isLargeCardSize;

  var _useProductListingDat = useProductListingData(),
      anchorCard = _useProductListingDat.anchorCard,
      facetContext = _useProductListingDat.facetContext,
      pagesAvailable = _useProductListingDat.pagesAvailable,
      router = _useProductListingDat.router;

  var _getConfig = config_default()(),
      features = _getConfig.publicRuntimeConfig;

  var baseFacetId = facetContext.baseFacetId,
      applied = facetContext.applied,
      isPrimaryFacetInDiscoResponse = facetContext.isPrimaryFacetInDiscoResponse,
      primaryFacet = facetContext.primaryFacet;
  var sharedFacetContext = {
    filterCombination: applied.filterCombination,
    filterCombinationNvals: applied.filterCombinationNvals
  };
  var _router$query = router.query,
      sortBy = _router$query.sortBy,
      page = _router$query.page;
  (0,external_React_.useEffect)(function () {
    router.beforePopState(function (_ref) {
      var as = _ref.as;
      // For all URLs except /search, the page or chunk are the first parameter.
      // For /search, it's the 2nd parameter onwards (the first being `search-term`)
      var splitOnCharacter = as.startsWith('/search') ? '&' : '?';
      var currentPath = as.split(splitOnCharacter)[0];
      var previousPath = router.asPath.split(splitOnCharacter)[0];

      if (currentPath === previousPath) {
        // SSR reload for back button when the urls are the same
        router.replace(as);
      }

      return true; // allow the popstate
    });
    var events = router.events;

    var handleRouteChangeStart = function handleRouteChangeStart(url, _ref2) {
      var shallow = _ref2.shallow;

      if (!shallow) {
        setIsLoadingPage(true);
      }
    };

    var handleRouteChangeComplete = function handleRouteChangeComplete(url, _ref3) {
      var shallow = _ref3.shallow;

      if (!shallow) {
        setIsLoadingPage(false);
      }
    };

    events.on('routeChangeStart', handleRouteChangeStart);
    events.on('routeChangeComplete', handleRouteChangeComplete);
    return function () {
      events.off('routeChangeStart', handleRouteChangeStart);
      events.off('routeChangeComplete', handleRouteChangeComplete);
    };
  });
  (0,external_React_.useEffect)(function () {
    if (anchorCard) {
      document.querySelector("[data-product-id=\"".concat(anchorCard, "\"]")).scrollIntoView();
    }
  }, [anchorCard, isLargeCardSize]);
  var country = props.country,
      currency = props.currency,
      handlePrimaryFacetClick = props.handlePrimaryFacetClick,
      handleDisplayM2MProductSelector = props.handleDisplayM2MProductSelector,
      handleDisplayQuickAdd = props.handleDisplayQuickAdd,
      handleFilterDrawerClick = props.handleFilterDrawerClick,
      isHeaderPeeping = props.isHeaderPeeping,
      onFetchQuickViewData = props.onFetchQuickViewData;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((external_React_default()).Fragment, {
    children: [isLoadingPage && /*#__PURE__*/(0,jsx_runtime.jsx)(Loading/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(facet_context/* Context.Provider */._y.Provider, {
      value: sharedFacetContext,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(AppliedFilters/* default */.Z, {
        baseFacetId: baseFacetId,
        className: 'mobile-facets',
        grid: true,
        mobile: true,
        numberOfFiltersToShowClear: features.numberOfFiltersToShowClear
      })
    }), isPrimaryFacetInDiscoResponse ? /*#__PURE__*/(0,jsx_runtime.jsx)(Button.SecondaryButton, {
      "data-test": "filters-button",
      className: (ProductListing_module_default()).primaryFacet,
      onClick: handlePrimaryFacetClick,
      children: primaryFacet.displayName
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(sticky_controls_StickyControls, {
      current: page,
      isHeaderPeeping: isHeaderPeeping,
      pages: pagesAvailable,
      sortBy: sortBy,
      handleFilterDrawerClick: handleFilterDrawerClick
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      id: "main-content" // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      ,
      tabIndex: "0",
      "aria-label": "Product listing page results",
      className: (ProductListing_module_default()).mainContent,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductGrid, {
        country: country,
        currency: currency,
        fetchQuickViewData: onFetchQuickViewData,
        handleDisplayM2MProductSelector: handleDisplayM2MProductSelector,
        handleDisplayQuickAdd: handleDisplayQuickAdd,
        isLoadingChunk: isLoadingChunk,
        isLoadingPage: isLoadingPage,
        setIsLoadingChunk: setIsLoadingChunk,
        isChunkLoadError: isChunkLoadError,
        setIsChunkLoadError: setIsChunkLoadError
      })
    }), !isLoadingChunk && !isChunkLoadError && /*#__PURE__*/(0,jsx_runtime.jsx)(pagination_Pagination, {
      className: "c-pagination--bottom",
      current: parseInt(page, 10),
      isFooter: true,
      pages: pagesAvailable
    })]
  });
});
ProductListing.displayName = 'ProductListing';
ProductListing.defaultProps = {
  country: 'GB',
  currency: 'gbp',
  onFetchQuickViewData: function onFetchQuickViewData() {
    return null;
  }
};
/* harmony default export */ var product_listing_ProductListing = (ProductListing);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/mixins/animate-scroll.js
var animate_scroll = __webpack_require__(53200);
// EXTERNAL MODULE: ./src/components/back-to-top/BackToTop.module.scss
var BackToTop_module = __webpack_require__(76616);
var BackToTop_module_default = /*#__PURE__*/__webpack_require__.n(BackToTop_module);
;// CONCATENATED MODULE: ./src/components/back-to-top/BackToTop.tsx






/**
 * Product Item Height - TODO:: This may be refactored at a later date.
 * @type {number}
 */



var productItemHeight = 400;
var backToTopThreshold = productItemHeight * 3;

var BackToTop = function BackToTop(_ref) {
  var _classNames;

  var _ref$initialScroll = _ref.initialScroll,
      initialScroll = _ref$initialScroll === void 0 ? 0 : _ref$initialScroll;

  var _useState = (0,external_React_.useState)(initialScroll),
      scrollTop = _useState[0],
      setScrollTop = _useState[1];

  var _useCompareContext = (0,CompareContext/* useCompareContext */.EN)(),
      products = _useCompareContext.products;

  var isActive = scrollTop >= backToTopThreshold;
  var isComparing = products.length > 0;
  var className = classnames_default()((_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, (BackToTop_module_default())["back-to-top"], true), (0,defineProperty/* default */.Z)(_classNames, (BackToTop_module_default())["back-to-top--active"], isActive), (0,defineProperty/* default */.Z)(_classNames, (BackToTop_module_default())["back-to-top--compare-active"], isComparing), _classNames));

  var setScrollPosition = function setScrollPosition() {
    return setScrollTop(window.pageYOffset);
  };

  var handleClick = function handleClick() {
    animate_scroll/* default.scrollToTop */.Z.scrollToTop(); // Focus is set to prevent screen readers "getting lost" when the button is activated

    var element = document.querySelector('[data-test="heading-term"]');

    if (element) {
      element.focus();
    }
  };

  (0,external_React_.useEffect)(function () {
    window.addEventListener('scroll', setScrollPosition);
    return function () {
      window.removeEventListener('scroll', setScrollPosition);
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    "data-test": "component-back-to-top",
    className: className,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (BackToTop_module_default())["back-to-top__container"],
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
        className: (BackToTop_module_default())["back-to-top__button"],
        type: "button",
        "data-test": "back-to-top-button",
        "aria-label": "Back to top",
        onClick: handleClick,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (BackToTop_module_default())["back-to-top__text"],
          children: "Back to top button"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
          "data-test": "back-to-top-icon",
          className: (BackToTop_module_default())["back-to-top__icon"],
          "aria-labelledby": "backToTopBtnTitle backToTopBtnDesc",
          viewBox: "0 0 48 48",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
            id: "BackToTopLargeIconTitle",
            children: "Back to top icon"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("desc", {
            id: "BackToTopLargeIconDesc",
            children: "An icon with an upward arrow inside a circle"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M24 48C10.8 48 0 37.2 0 24S10.8 0 24 0s24 10.8 24 24-10.8 24-24 24zm0-46.8C11.5 1.2 1.2 11.5 1.2 24S11.5 46.8 24 46.8 46.8 36.5 46.8 24 36.5 1.2 24 1.2z M32.7 22.9L24 14.1l-.7-.7-.7.7h-.1l-8.7 8.8.9.8 7.7-7.9v18H24v-18l7.9 7.9.8-.8z"
          })]
        })]
      })
    })
  });
};

/* harmony default export */ var back_to_top_BackToTop = (/*#__PURE__*/(0,external_React_.memo)(BackToTop));
// EXTERNAL MODULE: ./src/views/PLP.module.scss
var PLP_module = __webpack_require__(55399);
var PLP_module_default = /*#__PURE__*/__webpack_require__.n(PLP_module);
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/pecr-util/dist/index.js
var dist = __webpack_require__(46760);
;// CONCATENATED MODULE: ./src/storageManifest.json
var storageManifest_namespaceObject = JSON.parse('{"cookie":{},"localStorage":{"compare:data":"Functional"},"sessionStorage":{"persistScrollPosition":"Functional"}}');
;// CONCATENATED MODULE: ./src/utils/storage/index.js


function storage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function storage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? storage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : storage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var _constants$STORAGE_TY = constants/* default.STORAGE_TYPES */.Z.STORAGE_TYPES,
    COOKIES = _constants$STORAGE_TY.COOKIES,
    LOCAL_STORAGE = _constants$STORAGE_TY.LOCAL_STORAGE,
    SESSION_STORAGE = _constants$STORAGE_TY.SESSION_STORAGE;
var isLocalStorageAvailable = function isLocalStorageAvailable() {
  var isAvailable;

  try {
    localStorage.setItem('storage', '');
    localStorage.removeItem('storage');
    isAvailable = true;
  } catch (err) {
    isAvailable = false;
  }

  return isAvailable;
};
function storageCanBeSet(_ref) {
  var _ref$storageType = _ref.storageType,
      storageType = _ref$storageType === void 0 ? '' : _ref$storageType,
      _ref$storageKey = _ref.storageKey,
      storageKey = _ref$storageKey === void 0 ? '' : _ref$storageKey,
      cookies = _ref.cookies,
      manifest = _ref.manifest;
  var storageManifest = manifest || storageManifest_namespaceObject;
  var acceptedStorageTypes = [COOKIES, LOCAL_STORAGE, SESSION_STORAGE];
  var manifestUrl = '/src/storageManifest.json';
  var isTestEnv = false;

  if (storageType === LOCAL_STORAGE && !isLocalStorageAvailable()) {
    return false;
  }

  if (!storageManifest) {
    if (!isTestEnv) {
      console.group('🍪  Cookies 🍪');
      console.warn('Storage manifest file does not exist');
      console.warn("Check ".concat(manifestUrl, " exists, if not create it"));
      console.groupEnd();
    }

    return false;
  }

  if (!acceptedStorageTypes.includes(storageType)) {
    if (!isTestEnv) {
      console.group('🍪  Cookies 🍪');
      console.warn("Wrong storage type requested: ".concat(storageType));
      console.warn("It needs to be one of ".concat(acceptedStorageTypes.toString()));
      console.groupEnd();
    }

    return false;
  }

  if (!storageManifest[storageType][storageKey]) {
    if (!isTestEnv) {
      console.group('🍪  Cookies 🍪');
      console.warn("".concat(storageType, ".").concat(storageKey, " doesn't exist in the Storage Manifest: ").concat(manifestUrl));
      console.groupEnd();
    }

    return false;
  }

  var _storageManifest$stor = storageManifest[storageType][storageKey],
      foundStorageKey = _storageManifest$stor === void 0 ? undefined : _storageManifest$stor;
  if (!foundStorageKey) return false;
  var canPecrStorageBeSet = (0,dist.storageCanBeSet)(foundStorageKey, cookies);
  if (!canPecrStorageBeSet) return false;
  return true;
}
var parseCookies = function parseCookies(cookieString) {
  var _cookieString$split;

  if (!cookieString) return {};
  return cookieString === null || cookieString === void 0 ? void 0 : (_cookieString$split = cookieString.split(/; */)) === null || _cookieString$split === void 0 ? void 0 : _cookieString$split.reduce(function (obj, str) {
    if (str === '') return obj;

    var newObj = storage_objectSpread({}, obj);

    var eq = str.indexOf('=');
    var key = eq > 0 ? str.slice(0, eq) : str;
    var val = eq > 0 ? str.slice(eq + 1) : null;

    if (val != null) {
      try {
        val = decodeURIComponent(val);
      } catch (ex) {
        /* pass */
      }
    }

    newObj[key] = val;
    return newObj;
  }, {});
};
;// CONCATENATED MODULE: ./src/utils/auth.ts
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];



var delay = function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

var retryCount = 0;

var getAccessToken = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var auth0;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            auth0 = window.__auth0__ || window.auth0;

            if (!auth0) {
              _context.next = 7;
              break;
            }

            _context.next = 4;
            return auth0.getTokenIfAuthenticated();

          case 4:
            return _context.abrupt("return", _context.sent);

          case 7:
            if (!(retryCount === 5)) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return");

          case 11:
            _context.next = 13;
            return delay(200);

          case 13:
            retryCount += 1;
            _context.next = 16;
            return getAccessToken();

          case 16:
            return _context.abrupt("return", _context.sent);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getAccessToken() {
    return _ref.apply(this, arguments);
  };
}();

var getAuthUserData = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
    var accessToken, parsedTokenData;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getAccessToken();

          case 2:
            accessToken = _context2.sent;

            if (accessToken) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", null);

          case 5:
            _context2.prev = 5;
            parsedTokenData = JSON.parse(Buffer.from(accessToken.split('.')[1], 'base64').toString());
            return _context2.abrupt("return", {
              customerId: parsedTokenData['https://www.johnlewis.com/auth/customerId'],
              email: parsedTokenData['https://www.johnlewis.com/auth/email']
            });

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](5);
            return _context2.abrupt("return", null);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[5, 10]]);
  }));

  return function getAuthUserData() {
    return _ref2.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ./src/context/ErrorContext.jsx
var ErrorContext = __webpack_require__(90542);
;// CONCATENATED MODULE: ./src/api/quick-view/index.js


var quick_view_getConfig = config_default()(),
    quick_view_features = quick_view_getConfig.publicRuntimeConfig; // Client side


var quick_view_stdPLPFetcher = function stdPLPFetcher() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return fetch.apply(void 0, args).then(function (r) {
    if (r.ok) {
      return r.json();
    }

    if (r.status === 404) {
      return {
        error: 404
      };
    }

    console.error("Quick View fetch: An unexpected response ".concat(r.status, " has occurred ").concat(args[0]));
    throw new Error('An unexpected response has occurred');
  })["catch"](function (e) {
    console.error("Quick View fetch: An unexpected error has occurred", e);
    throw new Error(e);
  });
};

var PATH_QUICK_VIEW = "".concat(quick_view_features.applicationPrefix, "/api/quick-view");
var fetchQuickView = function fetchQuickView(id) {
  return quick_view_stdPLPFetcher("".concat(PATH_QUICK_VIEW, "/").concat(id));
};
// EXTERNAL MODULE: ./src/components/analytics/events.js
var events = __webpack_require__(34386);
;// CONCATENATED MODULE: ./src/hooks/usePageLoadReady.jsx


 // This tests for the presence of Ensighten Bootstrap code before triggering analytics. see ESI tag in _document.jsx

var analyticsReady = function analyticsReady() {
  return window && window.Bootstrapper && window.Bootstrapper.dataStateChangeReady;
};

var usePageLoadReady = function usePageLoadReady() {
  (0,external_React_.useEffect)(function () {
    if (analyticsReady()) {
      (0,analyticsEvents/* dispatchImmediateAnalyticsEvent */.gM)(events/* PAGE_LOAD */.oZ);
    } else {
      document.body.addEventListener('EnsightenReady', function () {
        return (0,analyticsEvents/* dispatchImmediateAnalyticsEvent */.gM)(events/* PAGE_LOAD */.oZ);
      }, {
        once: true
      });
    }
  }, []);
};
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/assets/logos/dior.svg
var dior = __webpack_require__(84562);
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/assets/logos/dior-backstage.svg
var dior_backstage = __webpack_require__(12511);
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/assets/logos/chanel.svg
var chanel = __webpack_require__(62631);
// EXTERNAL MODULE: ./src/components/brand-banner/BrandBanner.module.scss
var BrandBanner_module = __webpack_require__(83557);
var BrandBanner_module_default = /*#__PURE__*/__webpack_require__.n(BrandBanner_module);
;// CONCATENATED MODULE: ./src/components/brand-banner/BrandBanner.tsx
/* provided dependency */ var process = __webpack_require__(34155);







var DIOR_BACKSTAGE_INT_FACET_ID = '1z13ybrZ1yzergh';
var DIOR_BACKSTAGE_PROD_FACET_ID = 'oix5Z1yzervp';

var getBannerDetails = function getBannerDetails(banner) {
  var DIOR_BACKSTAGE_FACET_ID = process.env.APP_ENV === 'integration' ? DIOR_BACKSTAGE_INT_FACET_ID : DIOR_BACKSTAGE_PROD_FACET_ID;

  switch (banner) {
    case 'back-stage':
      return {
        bannerHref: "/brand/dior/dior-backstage/_/N-".concat(DIOR_BACKSTAGE_FACET_ID),
        bannerImage: dior_backstage,
        bannerAlt: 'DIOR Backstage',
        bannerStyles: [(BrandBanner_module_default()).banner, (BrandBanner_module_default()).backStage].join(' ')
      };

    case 'dior':
      return {
        bannerHref: '/beauty/dior/c600002684',
        bannerImage: dior,
        bannerAlt: 'DIOR',
        bannerStyles: (BrandBanner_module_default()).banner
      };

    case 'chanel':
      return {
        bannerHref: '/beauty/chanel/c7000370531',
        bannerImage: chanel,
        bannerAlt: 'CHANEL',
        bannerStyles: [(BrandBanner_module_default()).banner, (BrandBanner_module_default()).chanel].join(' ')
      };

    default:
      return null;
  }
};

var getBrandBanner = function getBrandBanner(crumbs, appliedFacetId) {
  var DIOR_BACKSTAGE_FACET_ID = process.env.APP_ENV === 'integration' ? DIOR_BACKSTAGE_INT_FACET_ID : DIOR_BACKSTAGE_PROD_FACET_ID;
  if (!crumbs || crumbs.length < 2) return null;
  if (crumbs[0].displayName === 'Beauty' && crumbs[1].displayName === 'CHANEL') return 'chanel';

  if (['Shop by Brand', 'Beauty'].includes(crumbs[0].displayName) && crumbs[1].displayName.toLowerCase() === 'dior') {
    if (appliedFacetId && appliedFacetId.match(DIOR_BACKSTAGE_FACET_ID)) {
      return 'back-stage';
    }

    return 'dior';
  }

  return null;
};
var BrandBanner = function BrandBanner(_ref) {
  var banner = _ref.banner;
  if (!banner) return null;
  var bannerDetails = getBannerDetails(banner);
  if (!bannerDetails) return null;
  var bannerHref = bannerDetails.bannerHref,
      bannerImage = bannerDetails.bannerImage,
      bannerAlt = bannerDetails.bannerAlt,
      bannerStyles = bannerDetails.bannerStyles;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("aside", {
    "data-test": "brand-banner-container",
    className: (BrandBanner_module_default()).container,
    children: [banner === 'chanel' && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (BrandBanner_module_default()).chanelStripe
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      className: bannerStyles,
      href: bannerHref,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: bannerImage,
        alt: bannerAlt,
        loading: "lazy"
      })
    })]
  });
};
// EXTERNAL MODULE: ./src/components/header/did-you-mean/AlternativeSearchTerms.module.scss
var AlternativeSearchTerms_module = __webpack_require__(16969);
var AlternativeSearchTerms_module_default = /*#__PURE__*/__webpack_require__.n(AlternativeSearchTerms_module);
;// CONCATENATED MODULE: ./src/components/header/did-you-mean/AlternativeSearchTerms.tsx












var AlternateSuggestion = function AlternateSuggestion(_ref) {
  var suggestion = _ref.suggestion;

  var _useAnalyticsData = (0,useAnalyticsData/* useAnalyticsData */.I)(),
      pageType = _useAnalyticsData.pageType;

  var search = (0,SearchContext/* useSearchContext */.AB)();
  var alsoSearchedEvent = (0,useAnalytics/* useAnalytics */.z)(analyticsEvents/* ALSO_SEARCHED */.G$, {
    pagetype: pageType
  });

  var handleClick = function handleClick(searchTerm) {
    search.setAlsoSearched(true);
    alsoSearchedEvent({
      term: searchTerm
    });
    var altSearchData = {
      searchData: {
        type: 'similar search',
        term: search.term,
        // original typed term
        suggestion: searchTerm // suggested term

      }
    };
    (0,analyticsEvents/* dispatchAnalyticsEvent */.$j)(analyticsEvents/* GLOBAL_SEARCH_INTERACTION */.l7, altSearchData);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StatefulLink/* default */.ZP, {
    className: classnames_default()((AlternativeSearchTerms_module_default())["alternative-search-terms__link"]),
    query: {
      'search-term': suggestion
    },
    facetId: "" // facets might not be available for alt suggestions
    ,
    onClick: function onClick() {
      return handleClick(suggestion);
    },
    "data-test": "alternative-search-terms__suggestion__link",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button.UnderlinedButton, {
      tag: "span",
      className: classnames_default()((AlternativeSearchTerms_module_default())["alternative-search-terms__suggestion"], (0,defineProperty/* default */.Z)({}, (AlternativeSearchTerms_module_default())["alternative-search-terms__suggestion--also-searched"], true)),
      "data-test": "alternative-search-terms__suggestion",
      children: suggestion
    })
  });
};
var AlternativeSearchTerms = function AlternativeSearchTerms(_ref2) {
  var alternativeSearchSuggestions = _ref2.alternativeSearchSuggestions;
  var MAX_SEARCH_SUGGESTIONS = 5;
  if (!alternativeSearchSuggestions || !Array.isArray(alternativeSearchSuggestions) || alternativeSearchSuggestions.length === 0) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    "data-test": "alternative-search-terms",
    className: classnames_default()((AlternativeSearchTerms_module_default())["alternative-search-terms"], (AlternativeSearchTerms_module_default())["alternative-search-terms--also-searched"]),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ['Similar searches:', alternativeSearchSuggestions.map(function (suggestion, i) {
        if (i >= MAX_SEARCH_SUGGESTIONS) {
          return null;
        }

        return /*#__PURE__*/(0,jsx_runtime.jsx)(AlternateSuggestion, {
          suggestion: suggestion.searchTerm
        }, suggestion.searchTerm);
      })]
    })
  });
};
// EXTERNAL MODULE: ./src/utils/index.js
var utils = __webpack_require__(68243);
;// CONCATENATED MODULE: ./src/api/online/onlineStockForQvCallback.js



var onlineStockForQvCallback_getConfig = config_default()(),
    onlineStockForQvCallback_features = onlineStockForQvCallback_getConfig.publicRuntimeConfig;

var onlineStockForQvCallback_fetcher = function fetcher() {
  return fetch_default().apply(void 0, arguments).then(function (r) {
    if (r.ok) {
      return r.json();
    }

    throw new Error("Received error fetching online stock data for quickview callback: ".concat(r.status));
  })["catch"](function (e) {
    throw new Error(e);
  });
};

var onlineStockForQvCallback_PATH = "".concat(onlineStockForQvCallback_features.applicationPrefix, "/api/quick-view-stock");
var fetchOnlineStockDataForQvCallback = function fetchOnlineStockDataForQvCallback(products) {
  return onlineStockForQvCallback_fetcher("".concat(onlineStockForQvCallback_PATH, "/").concat(products));
};
;// CONCATENATED MODULE: ./src/components/banners/CitrusBanner.tsx








var CitrusBrowseBanner = /*#__PURE__*/(0,external_React_.memo)(function (_ref) {
  var isBrandFilterApplied = _ref.isBrandFilterApplied,
      pathname = _ref.pathname;

  var _useApplicationSettin = useApplicationSettingsContext(),
      citrusBannerService = _useApplicationSettin.citrusBannerService;

  var _useBreadcrumbContext = useBreadcrumbContext(),
      breadcrumbs = _useBreadcrumbContext.breadcrumbs;

  if (!Array.isArray(breadcrumbs) || !(breadcrumbs !== null && breadcrumbs !== void 0 && breadcrumbs.length)) return null;
  var formattedBreadcrumbs = encodeURIComponent(breadcrumbs.map(function (b) {
    return b.displayName;
  }).join('|'));
  var brandFilterAppliedString = isBrandFilterApplied ? '&brandFilterApplied=true' : ''; // pathname is an arbitrary string used to trigger new ad impressions in the ESI

  var pathnameString = pathname ? "&pathname=".concat(pathname) : '';
  return /*#__PURE__*/(0,jsx_runtime.jsx)("aside", {
    "data-test": "banner-container",
    className: classnames_default()((Banner_module_default()).container, (Banner_module_default()).citrusbanners),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* default */.Z, {
      src: "".concat(citrusBannerService, "/browse?browsePageHierarchy=").concat(formattedBreadcrumbs).concat(brandFilterAppliedString).concat(pathnameString),
      id: "esiCitrusBanner"
    })
  });
});
CitrusBrowseBanner.displayName = 'CitrusBrowseBanner';
var CitrusSearchBanner = /*#__PURE__*/(0,external_React_.memo)(function (_ref2) {
  var searchTerm = _ref2.searchTerm,
      isFilterApplied = _ref2.isFilterApplied,
      pathname = _ref2.pathname;

  var _useApplicationSettin2 = useApplicationSettingsContext(),
      citrusBannerService = _useApplicationSettin2.citrusBannerService;

  if (!searchTerm) return null;
  var isFilterAppliedString = isFilterApplied ? '&filterApplied=true' : ''; // pathname is an arbitrary string used to trigger new ad impressions in the ESI

  var pathnameString = pathname ? "&pathname=".concat(pathname) : '';
  return /*#__PURE__*/(0,jsx_runtime.jsx)("aside", {
    "data-test": "banner-container",
    className: classnames_default()((Banner_module_default()).container, (Banner_module_default()).citrusbanners),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* default */.Z, {
      src: "".concat(citrusBannerService, "/search?searchTerm=").concat(encodeURIComponent(searchTerm)).concat(isFilterAppliedString).concat(pathnameString),
      id: "esiCitrusBanner"
    })
  });
});
CitrusSearchBanner.displayName = 'CitrusSearchBanner';
var CitrusBanner = /*#__PURE__*/(0,external_React_.memo)(function (_ref3) {
  var isBrandFilterApplied = _ref3.isBrandFilterApplied,
      isFilterApplied = _ref3.isFilterApplied,
      pathname = _ref3.pathname;
  var router = (0,next_router.useRouter)();
  var _router$query = router.query,
      type = _router$query.type,
      searchTerm = _router$query['search-term'];

  if (type === 'browse') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(CitrusBrowseBanner, {
      isBrandFilterApplied: isBrandFilterApplied,
      pathname: pathname
    });
  }

  if ((type === 's' || type === 'search') && typeof searchTerm == 'string') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(CitrusSearchBanner, {
      searchTerm: searchTerm,
      isFilterApplied: isFilterApplied,
      pathname: pathname
    });
  }

  return null;
});
CitrusBanner.displayName = 'CitrusBanner';
// EXTERNAL MODULE: ./src/components/facets/Facets.jsx + 12 modules
var Facets = __webpack_require__(47550);
;// CONCATENATED MODULE: ./src/components/facets/LeftNavFacets.jsx




var LeftNavFacets = /*#__PURE__*/(0,external_React_.memo)(function () {
  var _useErrorContext = (0,ErrorContext/* useErrorContext */.kc)(),
      _useErrorContext$hasF = _useErrorContext.hasFacetsError,
      hasFacetsError = _useErrorContext$hasF === void 0 ? false : _useErrorContext$hasF;

  if (hasFacetsError) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Facets/* default */.Z, {});
});
LeftNavFacets.displayName = 'LeftNavFacets';
;// CONCATENATED MODULE: ./src/views/PLP.jsx




function PLP_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PLP_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PLP_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PLP_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





 // eslint-disable-next-line import/no-unresolved





































var COMPARE_LOCAL_STORAGE_KEY = constants/* default.COMPARE_LOCAL_STORAGE_KEY */.Z.COMPARE_LOCAL_STORAGE_KEY,
    PLP_LOCAL_STORAGE = constants/* default.STORAGE_TYPES.LOCAL_STORAGE */.Z.STORAGE_TYPES.LOCAL_STORAGE;
var Compare = dynamic_default()(function () {
  return __webpack_require__.e(/* import() | compareComponent */ 707).then(__webpack_require__.bind(__webpack_require__, 17586));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(17586)];
    }
  }
});

var importEnergyDrawer = function importEnergyDrawer() {
  return Promise.all(/* import() | energyDrawerComponent */[__webpack_require__.e(238), __webpack_require__.e(125)]).then(__webpack_require__.bind(__webpack_require__, 54873));
};

var importFilterDrawer = function importFilterDrawer() {
  return Promise.all(/* import() | filterDrawerComponent */[__webpack_require__.e(238), __webpack_require__.e(947)]).then(__webpack_require__.bind(__webpack_require__, 34389));
};

var importQuickAdd = function importQuickAdd() {
  return Promise.all(/* import() | quickAddComponent */[__webpack_require__.e(288), __webpack_require__.e(796), __webpack_require__.e(821)]).then(__webpack_require__.bind(__webpack_require__, 11796));
};

var importQuickView = function importQuickView() {
  return Promise.all(/* import() | quickViewContainerComponent */[__webpack_require__.e(288), __webpack_require__.e(680)]).then(__webpack_require__.bind(__webpack_require__, 47473));
};

var FilterDrawer = dynamic_default()(importFilterDrawer, {
  ssr: false
});
var EnergyDrawer = dynamic_default()(importEnergyDrawer, {
  ssr: false
});
var M2MProductSelector = dynamic_default()(function () {
  return __webpack_require__.e(/* import() | m2mProductSelectorComponent */ 709).then(__webpack_require__.bind(__webpack_require__, 28021));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(28021)];
    }
  }
});
var QuickAdd = dynamic_default()(importQuickAdd, {
  ssr: false
});
var QuickViewContainer = dynamic_default()(importQuickView, {
  ssr: false
});
var SocialProofMessagesQuickView = /*#__PURE__*/(0,external_React_.memo)(function (_ref) {
  var html = _ref.html,
      productId = _ref.productId,
      brand = _ref.brand,
      availableToOrder = _ref.availableToOrder;
  var wrapper = (0,external_React_.useRef)(null);
  var container = document.createElement('div');

  if (html) {
    container.insertAdjacentHTML('afterbegin', html.replace(/_productId_/g, productId).replace(/_brand_/g, brand).replace(/_availableToOrder_/g, availableToOrder));
  }

  var scripts = container.querySelectorAll("script[src*='social-proof-messaging']");
  (0,external_React_.useEffect)(function () {
    scripts.forEach(function (script) {
      var _wrapper$current;

      var validScript = document.createElement('script');
      validScript.setAttribute('type', 'text/javascript');
      validScript.setAttribute('defer', true);
      validScript.setAttribute('src', script.getAttribute('src'));
      (_wrapper$current = wrapper.current) === null || _wrapper$current === void 0 ? void 0 : _wrapper$current.appendChild(validScript);
      script.parentNode.removeChild(script);
    });
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    ref: wrapper,
    dangerouslySetInnerHTML: {
      __html: container.innerHTML
    }
  });
});
SocialProofMessagesQuickView.displayName = 'SocialProofMessagesQuickView';
var usePlpViewData = function usePlpViewData() {
  var _useProductContext = (0,ProductContext/* useProductContext */.$h)(),
      totalNumberOfResults = _useProductContext.totalNumberOfResults;

  var compare = (0,CompareContext/* useCompareContext */.EN)();
  var router = (0,next_router.useRouter)();

  var _useFacetContext = (0,FacetContext/* useFacetContext */.gv)(),
      applied = _useFacetContext.applied,
      isPrimaryFacetInDiscoResponse = _useFacetContext.isPrimaryFacetInDiscoResponse,
      primaryFacet = _useFacetContext.primaryFacet;

  var _useApplicationSettin = useApplicationSettingsContext(),
      applicationPrefix = _useApplicationSettin.applicationPrefix,
      basketBFFService = _useApplicationSettin.basketBFFService,
      quickViewSocialProofAppId = _useApplicationSettin.quickViewSocialProofAppId,
      socialProofESIService = _useApplicationSettin.socialProofESIService;

  var _useSearchContext = (0,SearchContext/* useSearchContext */.AB)(),
      _useSearchContext$cor = _useSearchContext.correctedSearchTerm,
      correctedSearchTerm = _useSearchContext$cor === void 0 ? undefined : _useSearchContext$cor,
      alternativeSearchSuggestions = _useSearchContext.alternativeSearchSuggestions,
      term = _useSearchContext.term,
      correctionType = _useSearchContext.correctionType,
      sortBy = _useSearchContext.sortBy;

  var _useExperiencesContex = (0,Experiences/* useExperiencesContext */.Xe)(),
      isHybridBannerFeatureFlagOn = _useExperiencesContex.isHybridBannerFeatureFlagOn,
      isFilterSuggestionsFlagOn = _useExperiencesContex.isFilterSuggestionsFlagOn,
      isSocialProofingQuickViewOn = _useExperiencesContex.isSocialProofingQuickViewOn,
      isNowWasFlagOn = _useExperiencesContex.isNowWasFlagOn,
      isTopSeoBannerFlagOn = _useExperiencesContex.isTopSeoBannerFlagOn;

  var _useErrorContext = (0,ErrorContext/* useErrorContext */.kc)(),
      _useErrorContext$hasF = _useErrorContext.hasFacetsError,
      hasFacetsError = _useErrorContext$hasF === void 0 ? false : _useErrorContext$hasF,
      _useErrorContext$hasP = _useErrorContext.hasProductListError,
      hasProductListError = _useErrorContext$hasP === void 0 ? false : _useErrorContext$hasP;

  return {
    totalNumberOfResults: totalNumberOfResults,
    compare: compare,
    router: router,
    applicationSettings: {
      applicationPrefix: applicationPrefix,
      basketBFFService: basketBFFService,
      quickViewSocialProofAppId: quickViewSocialProofAppId,
      socialProofESIService: socialProofESIService
    },
    experience: {
      isHybridBannerFeatureFlagOn: isHybridBannerFeatureFlagOn,
      isFilterSuggestionsFlagOn: isFilterSuggestionsFlagOn,
      isSocialProofingQuickViewOn: isSocialProofingQuickViewOn,
      isNowWasFlagOn: isNowWasFlagOn,
      isTopSeoBannerFlagOn: isTopSeoBannerFlagOn
    },
    searchContext: {
      correctedSearchTerm: correctedSearchTerm,
      alternativeSearchSuggestions: alternativeSearchSuggestions,
      term: term,
      correctionType: correctionType,
      sortBy: sortBy
    },
    errorContext: {
      hasFacetsError: hasFacetsError,
      hasProductListError: hasProductListError
    },
    facetContext: {
      applied: applied,
      isPrimaryFacetInDiscoResponse: isPrimaryFacetInDiscoResponse,
      primaryFacet: primaryFacet
    }
  };
};
var PlpView = function PlpView(props) {
  var _sortOptions$find;

  var heading = props.heading,
      subHeading = props.subHeading,
      cookies = props.cookies;

  var _usePlpViewData = usePlpViewData(),
      totalNumberOfResults = _usePlpViewData.totalNumberOfResults,
      compare = _usePlpViewData.compare,
      router = _usePlpViewData.router,
      applicationSettings = _usePlpViewData.applicationSettings,
      searchContext = _usePlpViewData.searchContext,
      experience = _usePlpViewData.experience,
      errorContext = _usePlpViewData.errorContext,
      facetContext = _usePlpViewData.facetContext;

  var applicationPrefix = applicationSettings.applicationPrefix,
      basketBFFService = applicationSettings.basketBFFService,
      quickViewSocialProofAppId = applicationSettings.quickViewSocialProofAppId,
      socialProofESIService = applicationSettings.socialProofESIService;
  var EMAIL_ME_PATH = "".concat(applicationPrefix, "/api/quick-view-email-me");
  var _router$query = router.query,
      type = _router$query.type,
      _router$query$page = _router$query.page,
      page = _router$query$page === void 0 ? '1' : _router$query$page,
      listHead = _router$query.listHead;
  var isSearch = type === 'search' || type === 's';
  var _searchContext$correc = searchContext.correctedSearchTerm,
      correctedSearchTerm = _searchContext$correc === void 0 ? undefined : _searchContext$correc,
      alternativeSearchSuggestions = searchContext.alternativeSearchSuggestions,
      term = searchContext.term,
      correctionType = searchContext.correctionType,
      sortBy = searchContext.sortBy;
  var isHybridBannerFeatureFlagOn = experience.isHybridBannerFeatureFlagOn,
      isFilterSuggestionsFlagOn = experience.isFilterSuggestionsFlagOn,
      isSocialProofingQuickViewOn = experience.isSocialProofingQuickViewOn,
      isNowWasFlagOn = experience.isNowWasFlagOn,
      isTopSeoBannerFlagOn = experience.isTopSeoBannerFlagOn;
  var _errorContext$hasFace = errorContext.hasFacetsError,
      hasFacetsError = _errorContext$hasFace === void 0 ? false : _errorContext$hasFace,
      _errorContext$hasProd = errorContext.hasProductListError,
      hasProductListError = _errorContext$hasProd === void 0 ? false : _errorContext$hasProd;

  var _useState = (0,external_React_.useState)(false),
      displayFilterDrawer = _useState[0],
      setDisplayFilterDrawer = _useState[1];

  var _useState2 = (0,external_React_.useState)(false),
      displayM2MProductSelector = _useState2[0],
      setDisplayM2MProductSelector = _useState2[1];

  var _useState3 = (0,external_React_.useState)(false),
      displayQuickAdd = _useState3[0],
      setDisplayQuickAdd = _useState3[1];

  var _useState4 = (0,external_React_.useState)(false),
      isHeaderPeeping = _useState4[0],
      setIsHeaderPeeping = _useState4[1];

  var _useState5 = (0,external_React_.useState)(null),
      quickAddData = _useState5[0],
      setQuickAddData = _useState5[1];

  var _useState6 = (0,external_React_.useState)(null),
      quickAddError = _useState6[0],
      setQuickAddError = _useState6[1];

  var _useState7 = (0,external_React_.useState)(null),
      quickViewData = _useState7[0],
      setQuickViewData = _useState7[1];

  var _useState8 = (0,external_React_.useState)({
    product: {},
    event: {}
  }),
      analyticsData = _useState8[0],
      setAnalyticsData = _useState8[1];

  var _useState9 = (0,external_React_.useState)(false),
      renderFilterDrawer = _useState9[0],
      setRenderFilterDrawer = _useState9[1];

  var _useState10 = (0,external_React_.useState)(true),
      renderSkipFilters = _useState10[0],
      setRenderSkipFilters = _useState10[1];

  var _useState11 = (0,external_React_.useState)({
    targetHref: null
  }),
      m2mProductSelectorDetails = _useState11[0],
      setM2MProductSelectorDetails = _useState11[1];

  var _useState12 = (0,external_React_.useState)(false),
      filterDrawerOpenedByPrimaryFacet = _useState12[0],
      setFilterDrawerOpenedByPrimaryFacet = _useState12[1];

  var _useState13 = (0,external_React_.useState)(null),
      socialProofMessagesSkeleton = _useState13[0],
      setSocialProofMessagesSkeleton = _useState13[1];

  var sortByLabel = (_sortOptions$find = sortOptions.find(function (sortOption) {
    return sortOption.value === sortBy;
  })) === null || _sortOptions$find === void 0 ? void 0 : _sortOptions$find.label;
  var applied = facetContext.applied,
      isPrimaryFacetInDiscoResponse = facetContext.isPrimaryFacetInDiscoResponse,
      primaryFacet = facetContext.primaryFacet;
  var individualFilters = applied !== null && applied !== void 0 && applied.filterCombination ? applied.filterCombination.split('|') : [];
  var screenReaderFilters = individualFilters.length === 0 ? 'No filters are applied' : 'Your applied filters are, ';
  individualFilters.forEach(function (filter) {
    var _filter$split = filter.split(':'),
        _filter$split2 = (0,slicedToArray/* default */.Z)(_filter$split, 2),
        filterName = _filter$split2[0],
        filterValue = _filter$split2[1];

    var filterValueToRead = (0,utils/* getAriaTextIfPriceRange */.DU)(filterValue) || filterValue;
    screenReaderFilters += "".concat(filterName, " ").concat(filterValueToRead, ", ");
  });
  var fetchQuickViewData = (0,external_React_.useCallback)(fetchQuickView, []);

  var fetchSocialProofMessagesComponentForQuickViewSkeleton = function fetchSocialProofMessagesComponentForQuickViewSkeleton(_ref2) {
    var productId = _ref2.productId,
        brand = _ref2.brand,
        availableToOrder = _ref2.availableToOrder;

    if (false) {}

    return /*#__PURE__*/(0,jsx_runtime.jsx)(SocialProofMessagesQuickView, {
      html: socialProofMessagesSkeleton,
      productId: productId,
      brand: brand,
      availableToOrder: availableToOrder
    });
  };

  var fetchOnlineStockForSkusForSelectedColour = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(skuIds) {
      var stockInfo;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetchOnlineStockDataForQvCallback(skuIds);

            case 2:
              stockInfo = _context.sent;
              return _context.abrupt("return", stockInfo);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchOnlineStockForSkusForSelectedColour(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var updateCitrusAdAnalyticsData = function updateCitrusAdAnalyticsData(adId, productId) {
    var analyticsData = {
      product: {},
      event: {}
    };

    if (adId) {
      analyticsData.product.citrusAdId = adId;
      (0,analyticsEvents/* dispatchCitrusAnalytics */.fz)(productId, adId);
    }

    setAnalyticsData(analyticsData);
  };

  var getSkuIdsForSelectedColour = function getSkuIdsForSelectedColour(skus, colour) {
    return skus.filter(function (sku) {
      return sku.colour === colour;
    }).map(function (_ref4) {
      var id = _ref4.id;
      return id;
    });
  }; // Returns an array of skuIds matching the specified colour


  var getSkusWithStockForColour = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(skus, colour) {
      var skuIdsForSelectedColour, stockInfo;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              skuIdsForSelectedColour = getSkuIdsForSelectedColour(skus, colour);
              _context2.next = 3;
              return fetchOnlineStockDataForQvCallback(skuIdsForSelectedColour);

            case 3:
              stockInfo = _context2.sent;
              return _context2.abrupt("return", skus.map(function (currentSku) {
                if (!skuIdsForSelectedColour.includes(currentSku.id)) {
                  return PLP_objectSpread({}, currentSku);
                } else {
                  var matchedStockValue = stockInfo.stocks.find(function (_ref6) {
                    var skuId = _ref6.skuId;
                    return skuId === currentSku.id;
                  });
                  return PLP_objectSpread(PLP_objectSpread({}, currentSku), {}, {
                    stockLevel: matchedStockValue && matchedStockValue.status ? matchedStockValue.status : 0,
                    preorderMessage: matchedStockValue && matchedStockValue.preOrderMessage ? matchedStockValue.preOrderMessage : ''
                  });
                }
              }));

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getSkusWithStockForColour(_x2, _x3) {
      return _ref5.apply(this, arguments);
    };
  }();

  var handleQuickAddColourChange = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(colour) {
      var _quickAddData$data$sk, skus, skusWithStock;

      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _quickAddData$data$sk = quickAddData.data.skus, skus = _quickAddData$data$sk === void 0 ? [] : _quickAddData$data$sk;
              _context3.next = 3;
              return getSkusWithStockForColour(skus, colour);

            case 3:
              skusWithStock = _context3.sent;
              setQuickAddData(PLP_objectSpread(PLP_objectSpread({}, quickAddData), {}, {
                data: PLP_objectSpread(PLP_objectSpread({}, quickAddData.data), {}, {
                  skus: skusWithStock
                })
              }));

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleQuickAddColourChange(_x4) {
      return _ref7.apply(this, arguments);
    };
  }();

  var handleQuickAddDisplay = (0,external_React_.useCallback)( /*#__PURE__*/function () {
    var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(id, productUrl, swatchOrder, preselectedColour, adId) {
      var response, _response$skus, skus, _response$colours, colours, isPartialStockInfo, skusWithStock, data;

      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setDisplayQuickAdd(true);
              updateCitrusAdAnalyticsData(adId, id);
              _context4.prev = 2;
              _context4.next = 5;
              return fetchQuickViewData(id);

            case 5:
              response = _context4.sent;
              _response$skus = response.skus, skus = _response$skus === void 0 ? [] : _response$skus, _response$colours = response.colours, colours = _response$colours === void 0 ? [] : _response$colours, isPartialStockInfo = response.isPartialStockInfo;

              if (!(isPartialStockInfo && colours.length > 0)) {
                _context4.next = 11;
                break;
              }

              _context4.next = 10;
              return getSkusWithStockForColour(skus, preselectedColour || colours[0]);

            case 10:
              skusWithStock = _context4.sent;

            case 11:
              data = skusWithStock ? PLP_objectSpread(PLP_objectSpread({}, response), {}, {
                skus: skusWithStock
              }) : PLP_objectSpread({}, response);
              setQuickAddData({
                data: data,
                swatchOrder: swatchOrder,
                preselectedColour: preselectedColour
              });
              _context4.next = 18;
              break;

            case 15:
              _context4.prev = 15;
              _context4.t0 = _context4["catch"](2);
              setQuickAddError({
                productUrl: productUrl,
                retry: function retry() {
                  setQuickAddError(null);
                  handleQuickAddDisplay(id, productUrl);
                }
              });

            case 18:
              return _context4.abrupt("return", Promise.resolve());

            case 19:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[2, 15]]);
    }));

    return function (_x5, _x6, _x7, _x8, _x9) {
      return _ref8.apply(this, arguments);
    };
  }(), []);

  var handleQuickAddClose = function handleQuickAddClose() {
    setQuickAddData(null);
    setDisplayQuickAdd(false);
    setQuickAddError(null);
  };

  var handleFilterDrawerClick = (0,external_React_.useCallback)(function () {
    setRenderFilterDrawer(true);
    setDisplayFilterDrawer(true);
    setFilterDrawerOpenedByPrimaryFacet(false);
  }, []);

  var handlePrimaryFacetClick = function handlePrimaryFacetClick() {
    setRenderFilterDrawer(true);
    setDisplayFilterDrawer(true);
    setFilterDrawerOpenedByPrimaryFacet(true);
  };

  var handleFilterDrawerOpen = function handleFilterDrawerOpen() {
    var primaryFacetAccordionName = "accordion-summary-".concat(primaryFacet.name.toLowerCase().replace(/ /g, '-'));
    var primaryFacetElement = document.getElementById(primaryFacetAccordionName);

    if (primaryFacetElement) {
      primaryFacetElement.scrollIntoView();
    }
  };

  var handleFilterDrawerClose = (0,external_React_.useCallback)(function () {
    setDisplayFilterDrawer(false);
  }, []);
  var onFetchQuickViewData = (0,external_React_.useCallback)(function (id, selectedProductUrl, swatchOrder, selectedSwatch, adId) {
    var shouldScrollToPromoMsgs = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    return new Promise(function (resolve) {
      updateCitrusAdAnalyticsData(adId, id);
      setQuickViewData({
        id: id,
        selectedProductUrl: selectedProductUrl,
        swatchOrder: swatchOrder,
        preselectedColour: selectedSwatch,
        onClose: resolve,
        shouldScrollToPromoMsgs: shouldScrollToPromoMsgs
      });
    });
  }, []);

  var onCloseQuickView = function onCloseQuickView() {
    quickViewData.onClose();
    return setQuickViewData(null);
  };

  var handleM2MProductSelectorClick = (0,external_React_.useCallback)(function (targetHref) {
    setM2MProductSelectorDetails({
      targetHref: targetHref
    });
    setDisplayM2MProductSelector(true);
  }, []);

  var onCloseM2MProductSelector = function onCloseM2MProductSelector() {
    setDisplayM2MProductSelector(false);
    setM2MProductSelectorDetails({
      targetHref: null
    });
  };

  var handleBackButtonClick = function handleBackButtonClick() {
    setQuickViewData(null);
  };

  var fetchEmailOutOfStock = /*#__PURE__*/function () {
    var _ref10 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(_ref9) {
      var email, skuId, productId, _ref9$customerNotifia, customerNotifiableEvents, loggedInUserData;

      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              email = _ref9.email, skuId = _ref9.skuId, productId = _ref9.productId, _ref9$customerNotifia = _ref9.customerNotifiableEvents, customerNotifiableEvents = _ref9$customerNotifia === void 0 ? {} : _ref9$customerNotifia;
              _context5.next = 3;
              return getAuthUserData();

            case 3:
              loggedInUserData = _context5.sent;
              return _context5.abrupt("return", fetch(EMAIL_ME_PATH, {
                method: 'POST',
                body: JSON.stringify({
                  productId: productId,
                  skuId: skuId,
                  email: email,
                  customerNotifiableEvents: customerNotifiableEvents,
                  customerId: loggedInUserData === null || loggedInUserData === void 0 ? void 0 : loggedInUserData.customerId
                })
              }));

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function fetchEmailOutOfStock(_x10) {
      return _ref10.apply(this, arguments);
    };
  }();

  usePageLoadReady();

  var toggleFilterDrawer = function toggleFilterDrawer() {
    if (window.innerWidth >= constants/* default.MOBILE_MAX_WIDTH */.Z.MOBILE_MAX_WIDTH) {
      handleFilterDrawerClose();
      setRenderSkipFilters(true);
    } else {
      setRenderSkipFilters(false);
    }
  };

  (0,external_React_.useEffect)(function () {
    window.addEventListener('jl-events.browser.mobileHeaderPeepUpdated', function (_ref11) {
      var _ref11$detail$peeped = _ref11.detail.peeped,
          peeped = _ref11$detail$peeped === void 0 ? false : _ref11$detail$peeped;
      setIsHeaderPeeping(peeped);
    });

    var importQuickAction = function importQuickAction() {
      if (window.innerWidth < 768) {
        importQuickAdd();
      } else {
        importQuickView();
      }
    };

    setRenderSkipFilters(window.innerWidth >= constants/* default.MOBILE_MAX_WIDTH */.Z.MOBILE_MAX_WIDTH);

    if (window.requestIdleCallback) {
      window.requestIdleCallback(function () {
        importQuickAction();
        importFilterDrawer();
        importEnergyDrawer();
      });
    } else {
      importQuickAction();
      importFilterDrawer();
      importEnergyDrawer();
    }

    window.addEventListener('resize', toggleFilterDrawer);

    if (isSocialProofingQuickViewOn) {
      var socialProofUrl = "".concat(socialProofESIService, "?").concat(new URLSearchParams({
        productId: '_productId_',
        appId: quickViewSocialProofAppId,
        brand: '_brand_',
        availableToOrder: '_availableToOrder_',
        withClose: 'false'
      }).toString());
      fetch(socialProofUrl).then(function (response) {
        return response.text();
      }).then(setSocialProofMessagesSkeleton)["catch"](function (err) {
        console.log("PLP: Error fetching QV social proof skeleton", err);
      });
    }

    return function () {
      window.removeEventListener('jl-events.browser.mobileHeaderPeepUpdated', function () {});
      window.removeEventListener('resize', toggleFilterDrawer);
    };
  }, []);
  var storageType = PLP_LOCAL_STORAGE;
  var storageKey = COMPARE_LOCAL_STORAGE_KEY;
  compare.setAvailability(storageCanBeSet({
    storageType: storageType,
    storageKey: storageKey,
    cookies: cookies === null || cookies === void 0 ? void 0 : cookies.current
  }));

  if (totalNumberOfResults === 0) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)((external_React_default()).Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(grid_GridRow, {
        id: "js-plp-header",
        className: (PLP_module_default()).plp__header,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(GridColumn/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(header_Header, {
            heading: heading,
            subHeading: subHeading,
            showNumberOfResults: false,
            pageType: type
          })
        }, "search-header")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(grid_GridRow, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(GridColumn/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(sub_copy_SubCopy, {})
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* default */.Z, {
        src: "/content-renderer/no-results?includeCoreCss=false&includeCoreJS=false&includePolyfills=false",
        id: "plp-no-results"
      })]
    });
  }

  var screenReaderUpdates = totalNumberOfResults !== 1 ? "There are ".concat(totalNumberOfResults, " results, ") : "There is 1 result, ";

  if (sortByLabel) {
    screenReaderUpdates += "Results are sorted by ".concat(sortByLabel, ", ");
  }

  if (screenReaderFilters) {
    screenReaderUpdates += screenReaderFilters;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((external_React_default()).Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(grid_GridRow, {
      id: "js-plp-header",
      className: (PLP_module_default()).plp__header,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(GridColumn/* default */.Z, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(header_Header, {
          heading: isSearch && listHead ? listHead : heading,
          subHeading: subHeading,
          showNumberOfResults: true,
          totalNumberOfResults: correctedSearchTerm ? 0 : totalNumberOfResults,
          alternativeSearchSuggestions: alternativeSearchSuggestions && alternativeSearchSuggestions.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(AlternativeSearchTerms, {
            alternativeSearchSuggestions: alternativeSearchSuggestions
          }) : null,
          correctedSearchTerm: isSearch ? /*#__PURE__*/(0,jsx_runtime.jsx)(CorrectedSearchTerm, {
            correctedSearchTerm: correctedSearchTerm,
            totalNumberOfResults: totalNumberOfResults,
            originalSearchTerm: term,
            correctionType: correctionType
          }) : null
        }), page === '1' && isTopSeoBannerFlagOn && /*#__PURE__*/(0,jsx_runtime.jsx)(Banner, {
          bannerId: "seoTopBannerId",
          className: "seobanners-top"
        }), screenReaderUpdates && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          id: "screen-reader-updates",
          className: (PLP_module_default()).visuallyHidden,
          "aria-live": "assertive",
          children: screenReaderUpdates
        })]
      }, "search-header"), isFilterSuggestionsFlagOn && /*#__PURE__*/(0,jsx_runtime.jsx)(filter_suggestions_FilterSuggestions, {
        pageType: type
      })]
    }), renderSkipFilters && /*#__PURE__*/(0,jsx_runtime.jsx)(Button.SecondaryButton, {
      "data-test": "skip-filters-link",
      tag: "a",
      href: "#main-content",
      className: classnames_default()((PLP_module_default()).visuallyHidden, (PLP_module_default()).visibleOnFocus),
      children: "Skip Filters"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(grid_GridRow, {
      id: "js-plp-body",
      className: (PLP_module_default()).plp__body,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LeftNavFacets, {}), renderFilterDrawer && /*#__PURE__*/(0,jsx_runtime.jsx)(FilterDrawer, {
        openFilterDrawer: displayFilterDrawer,
        closeFilterDrawer: handleFilterDrawerClose,
        totalNumberOfResults: totalNumberOfResults,
        isPrimaryFacetMainFacet: filterDrawerOpenedByPrimaryFacet,
        onAfterOpen: filterDrawerOpenedByPrimaryFacet ? handleFilterDrawerOpen : undefined,
        isMoreFiltersButton: !filterDrawerOpenedByPrimaryFacet
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(EnergyDrawer, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(GridColumn/* default */.Z, {
        colSm: 12,
        colMd: 12,
        colLg: 9,
        colXl: 9,
        className: classnames_default()((PLP_module_default()).plp__productGridCol, (0,defineProperty/* default */.Z)({
          productListFullWidth: hasProductListError || hasFacetsError
        }, (PLP_module_default())["plp__productGridCol--header-peeping"], isHeaderPeeping)),
        children: [isHybridBannerFeatureFlagOn && /*#__PURE__*/(0,jsx_runtime.jsx)(Banner, {
          bannerId: "blockBannerId",
          className: "hybridbanners"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(product_listing_ProductListing, {
          isHeaderPeeping: isHeaderPeeping,
          handleDisplayM2MProductSelector: handleM2MProductSelectorClick,
          handleDisplayQuickAdd: handleQuickAddDisplay,
          onFetchQuickViewData: onFetchQuickViewData,
          handleFilterDrawerClick: handleFilterDrawerClick,
          handlePrimaryFacetClick: isPrimaryFacetInDiscoResponse ? handlePrimaryFacetClick : undefined
        }), page === '1' && /*#__PURE__*/(0,jsx_runtime.jsx)(Banner, {
          bannerId: "seoBottomBannerId",
          className: "seobanners"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Compare, {}), quickViewData && /*#__PURE__*/(0,jsx_runtime.jsx)(QuickViewContainer, PLP_objectSpread(PLP_objectSpread({
        analyticsData: analyticsData,
        fetchEmailOutOfStock: fetchEmailOutOfStock,
        fetchOnlineStockForSkusForSelectedColour: fetchOnlineStockForSkusForSelectedColour,
        fetchQuickViewData: fetchQuickViewData,
        fetchSocialProofMessagingComponent: isSocialProofingQuickViewOn && socialProofMessagesSkeleton ? fetchSocialProofMessagesComponentForQuickViewSkeleton : undefined,
        handleBackButtonClick: handleBackButtonClick,
        hasShortCtaText: true,
        isAnydayEnabled: true,
        isEmailMeFeatureEnabled: true,
        isEnergyRatingEnabled: true,
        isMiniBasketEnabled: true,
        isPromoIndicatorsEnabled: true,
        isUsingCustomerNotifiableEventsData: true,
        isUsingVariantCanonicalUrls: true,
        onCloseQuickView: onCloseQuickView,
        rootId: "page-root"
      }, quickViewData), {}, {
        atbProps: {
          clientId: 'standard-plp',
          path: basketBFFService
        },
        hasNowWasPricing: isNowWasFlagOn
      })), displayQuickAdd && /*#__PURE__*/(0,jsx_runtime.jsx)(QuickAdd, PLP_objectSpread(PLP_objectSpread({}, quickAddData), {}, {
        analyticsData: analyticsData,
        onRequestClose: handleQuickAddClose,
        fetchEmailOutOfStock: fetchEmailOutOfStock,
        handleColourChangeAction: handleQuickAddColourChange,
        show: displayQuickAdd,
        rootId: "page-root",
        error: quickAddError,
        isMiniBasketEnabled: true,
        hasShortCtaText: true,
        isUsingCustomerNotifiableEventsData: true,
        atbProps: {
          clientId: 'standard-plp',
          path: basketBFFService
        }
      })), displayM2MProductSelector && /*#__PURE__*/(0,jsx_runtime.jsx)(M2MProductSelector, {
        isOpen: displayM2MProductSelector,
        onClose: onCloseM2MProductSelector,
        pdpUrl: m2mProductSelectorDetails.targetHref,
        rootId: "page-root"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(back_to_top_BackToTop, {})]
    })]
  });
};
var BannerViewer = /*#__PURE__*/(0,external_React_.memo)(function (_ref12) {
  var breadcrumbs = _ref12.breadcrumbs,
      applied = _ref12.applied,
      isTopBannerFeatureFlagOn = _ref12.isTopBannerFeatureFlagOn,
      isSearchSponsoredBannersFlagOn = _ref12.isSearchSponsoredBannersFlagOn;
  var props = {};
  var router = (0,next_router.useRouter)();
  var _router$query2 = router.query,
      type = _router$query2.type,
      sortBy = _router$query2.sortBy,
      facetId = _router$query2.facetId,
      _router$query2$page = _router$query2.page,
      page = _router$query2$page === void 0 ? '1' : _router$query2$page;

  var _useBannerContext = useBannerContext(),
      topBannerId = _useBannerContext.topBannerId;

  var banner = getBrandBanner(breadcrumbs, applied === null || applied === void 0 ? void 0 : applied.facetId);
  var displayCitrusBanner = type === 'browse' || isSearchSponsoredBannersFlagOn && ['s', 'search'].includes(type) && !topBannerId;
  var hideCitrusBanner = !displayCitrusBanner && isTopBannerFeatureFlagOn;

  if (displayCitrusBanner) {
    var facetIdString = facetId ? encodeURIComponent(facetId.join('/')) : '';
    var pageString = "".concat(facetIdString ? '/' : '', "page/").concat(page);
    var sortByString = sortBy ? "".concat(facetIdString || pageString ? '/' : '', "sortBy/").concat(sortBy) : '';
    props = {
      isBrandFilterApplied: applied === null || applied === void 0 ? void 0 : applied.isBrandFilterApplied,
      isFilterApplied: Boolean(facetId),
      pathname: "".concat(facetIdString).concat(pageString).concat(sortByString)
    };
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((external_React_default()).Fragment, {
    children: [banner && /*#__PURE__*/(0,jsx_runtime.jsx)(BrandBanner, {
      banner: banner
    }), displayCitrusBanner && /*#__PURE__*/(0,jsx_runtime.jsx)(CitrusBanner, PLP_objectSpread({}, props)), hideCitrusBanner && /*#__PURE__*/(0,jsx_runtime.jsx)(Banner, {
      bannerId: "topBannerId",
      className: "banners"
    })]
  });
});
BannerViewer.displayName = 'BannerViewer';
var PLP = function PLP(props) {
  /* istanbul ignore next */
  var _useExperiencesContex2 = (0,Experiences/* useExperiencesContext */.Xe)(),
      isTopBannerFeatureFlagOn = _useExperiencesContex2.isTopBannerFeatureFlagOn,
      isSearchSponsoredBannersFlagOn = _useExperiencesContex2.isSearchSponsoredBannersFlagOn;

  var _useBreadcrumbContext = useBreadcrumbContext(),
      breadcrumbs = _useBreadcrumbContext.breadcrumbs;

  var _useFacetContext2 = (0,FacetContext/* useFacetContext */.gv)(),
      applied = _useFacetContext2.applied;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((external_React_default()).Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BannerViewer, {
      breadcrumbs: breadcrumbs,
      applied: applied,
      isTopBannerFeatureFlagOn: isTopBannerFeatureFlagOn,
      isSearchSponsoredBannersFlagOn: isSearchSponsoredBannersFlagOn
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (PLP_module_default()).plp,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PlpView, PLP_objectSpread({}, props))
    })]
  });
};
PLP.defaultProps = {
  cookies: {}
};
/* harmony default export */ var views_PLP = (PLP);
;// CONCATENATED MODULE: ./src/components/meta/Static.jsx




var isLocalDev = false;
var Static = function Static() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      charSet: "utf-8"
    }), !isLocalDev && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "manifest",
      href: "/static/assets/favicon/manifest.json"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      httpEquiv: "X-UA-Compatible",
      content: "IE=edge, chrome=1"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      httpEquiv: "content-type",
      content: "text/html; charset=utf-8"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "viewport",
      content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "theme-color",
      content: "#ffffff"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "msapplication-TileColor",
      content: "#da532c"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "msapplication-TileImage",
      content: "https://www.johnlewis.com/static/assets/favicon/mstile-144x144.png"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "twitter:card",
      content: "summary_large_image"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "twitter:site",
      content: "@JLandPartners"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "apple-itunes-app",
      content: "app-id=486502369, app-argument=m.johnlewis.com"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "apple-mobile-web-app-capable",
      content: "yes"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "apple-mobile-web-app-title",
      content: "Standard PLP"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "apple-mobile-web-app-status-bar-style",
      content: "default"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "mask-icon",
      href: "https://www.johnlewis.com/static/assets/favicon.svg",
      color: "#000000"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "shortcut icon",
      type: "image/x-icon",
      href: "https://www.johnlewis.com/static/assets/favicon/favicon.ico"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "apple-touch-icon",
      href: "https://www.johnlewis.com/static/assets/favicon/apple-touch-icon.png",
      sizes: "180x180"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "icon",
      href: "https://www.johnlewis.com/static/assets/favicon/favicon-16x16.png",
      sizes: "16x16"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "icon",
      href: "https://www.johnlewis.com/static/assets/favicon/favicon-32x32.png",
      sizes: "32x32"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "icon",
      href: "https://www.johnlewis.com/static/assets/favicon/android-chrome-36x36.png",
      sizes: "36x36"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "icon",
      href: "https://www.johnlewis.com/static/assets/favicon/android-chrome-48x48.png",
      sizes: "48x48"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "icon",
      href: "https://www.johnlewis.com/static/assets/favicon/android-chrome-72x72.png",
      sizes: "72x72"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "icon",
      href: "https://www.johnlewis.com/static/assets/favicon/android-chrome-96x96.png",
      sizes: "96x96"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "icon",
      href: "https://www.johnlewis.com/static/assets/favicon/android-chrome-144x144.png",
      sizes: "144x144"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "icon",
      href: "https://www.johnlewis.com/static/assets/favicon/android-chrome-192x192.png",
      sizes: "192x192"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "icon",
      href: "https://www.johnlewis.com/static/assets/favicon/android-chrome-256x256.png",
      sizes: "256x256"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "icon",
      href: "https://www.johnlewis.com/static/assets/favicon/android-chrome-384x384.png",
      sizes: "384x384"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "icon",
      href: "https://www.johnlewis.com/static/assets/favicon/android-chrome-512x512.png",
      sizes: "512x512"
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/meta/Meta.jsx








var Meta = function Meta(_ref) {
  var title = _ref.title,
      description = _ref.description,
      pages = _ref.pages,
      indexable = _ref.indexable,
      crawlable = _ref.crawlable,
      canonicalUrl = _ref.canonicalUrl,
      images = _ref.images,
      showFollow = _ref.showFollow;

  var _useRouter = (0,next_router.useRouter)(),
      _useRouter$query = _useRouter.query,
      query = _useRouter$query === void 0 ? {} : _useRouter$query,
      _useRouter$asPath = _useRouter.asPath,
      asPath = _useRouter$asPath === void 0 ? '' : _useRouter$asPath;

  var type = query.type;
  var isSearchQuery = type === 'search'; // Don't include /s queries in this

  var page = parseInt(query.page || 1, 10);
  var currentPageText = "?page=".concat(page);
  var prevPageText = "?page=".concat(page - 1);
  var nextPageText = "?page=".concat(page + 1);
  var queryPos = asPath.indexOf('?');
  var asPathWithNoQueryParms = queryPos > -1 ? asPath.slice(0, queryPos) : asPath;
  var canonical = type === 's' ? "https://www.johnlewis.com".concat(asPathWithNoQueryParms) : "https://www.johnlewis.com/".concat(canonicalUrl.replace(/^\//, ''));
  var currentPageCanonical = "".concat(canonical).concat(page > 1 ? currentPageText : '');
  var robots = [];

  if (!indexable) {
    robots.push('noindex');
  }

  if (!crawlable) {
    robots.push('nofollow');
  } else if (crawlable && showFollow) {
    robots.push('follow');
  }

  var robotsMetaContent = robots.length > 0 && robots.join(', ');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      children: title
    }), robotsMetaContent && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "robots",
      content: robotsMetaContent
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "description",
      content: description
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:site_name",
      content: "John Lewis & Partners"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:url",
      content: currentPageCanonical
    }), images.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [images.map(function (image) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          property: "og:image",
          content: image
        }, image);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image:type",
        content: "image/jpeg"
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://johnlewis.scene7.com/is/image/JohnLewis/ogFeatureImage-johnLewisPartners-040918"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image:type",
        content: "image/png"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:type",
      content: "website"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:locale",
      content: "en_GB"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:title",
      content: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:description",
      content: description
    }), !isSearchQuery && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: currentPageCanonical
      }), page < pages && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "next",
        href: "".concat(canonical).concat(nextPageText)
      }), page > 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "prev",
        href: "".concat(canonical).concat(page > 2 ? "".concat(prevPageText) : '')
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Static, {})]
  });
};

Meta.defaultProps = {
  indexable: false,
  crawlable: false,
  canonicalUrl: '/',
  images: [],
  showFollow: false
};
/* harmony default export */ var meta_Meta = (Meta);
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/utils/basket/cachedBasket.js
var cachedBasket = __webpack_require__(45384);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
;// CONCATENATED MODULE: ./src/components/analytics/setJLBasketData.js




function setJLBasketData_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function setJLBasketData_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? setJLBasketData_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : setJLBasketData_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var BASKET_COOKIE = /(?:^|; ?)cached_basket=([^;]+)/;

var mapServiceItems = function mapServiceItems(services) {
  var _services$split = services.split('-'),
      _services$split2 = (0,slicedToArray/* default */.Z)(_services$split, 5),
      productId = _services$split2[1],
      sku = _services$split2[2],
      itemPrice = _services$split2[3],
      qty = _services$split2[4];

  return {
    itemPrice: itemPrice,
    productId: productId,
    qty: qty,
    sku: sku
  };
};

var mapBasketItems = function mapBasketItems(item) {
  var _item$split = item.split('|'),
      _item$split2 = (0,slicedToArray/* default */.Z)(_item$split, 7),
      productId = _item$split2[1],
      sku = _item$split2[3],
      itemPrice = _item$split2[4],
      qty = _item$split2[5],
      additionalServices = _item$split2[6];

  var services = [];

  if (additionalServices) {
    // TODO: what if there are more than 1 "addons"?
    // I could only find an instance where there is 1 additional addon
    services.push.apply(services, (0,toConsumableArray/* default */.Z)([additionalServices].map(mapServiceItems)));
  }

  return {
    itemPrice: itemPrice,
    productId: productId,
    services: services,
    qty: qty,
    sku: sku
  };
};

var setJLBasketData = function setJLBasketData() {
  var _ref = document.cookie.match(BASKET_COOKIE) || [],
      _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
      basketCookie = _ref2[1];

  if (!basketCookie) {
    return {};
  } // split all items in the cookie string


  var basket = basketCookie.split(/\|?\^/); // retrieve the totals (appear to ALAWYS be last two elements)

  var totals = basket.splice(basket.length - 2); // reduce the totals array and build an object of keys and values

  var information = totals.reduce(function (obj, info) {
    var _info$split = info.split('='),
        _info$split2 = (0,slicedToArray/* default */.Z)(_info$split, 2),
        key = _info$split2[0],
        value = _info$split2[1];

    return Object.assign(obj, (0,defineProperty/* default */.Z)({}, key, value));
  }, {});
  var products = basket.map(mapBasketItems);
  return setJLBasketData_objectSpread({
    product: products
  }, information);
};
;// CONCATENATED MODULE: ./src/components/analytics/setJLData.js


function setJLData_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function setJLData_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? setJLData_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : setJLData_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var overwriteMerge = function overwriteMerge(_dest, source) {
  return source;
};

var isCompareEvent = function isCompareEvent(analytics) {
  var _analytics$data, _analytics$data$compa;

  return Boolean((analytics === null || analytics === void 0 ? void 0 : (_analytics$data = analytics.data) === null || _analytics$data === void 0 ? void 0 : (_analytics$data$compa = _analytics$data.compare) === null || _analytics$data$compa === void 0 ? void 0 : _analytics$data$compa.product) && analytics.data.compare.product.length > 0);
};
var getPageType = function getPageType(type) {
  var isComparing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$totalResults = _ref.totalResults,
      totalResults = _ref$totalResults === void 0 ? 0 : _ref$totalResults;

  if (isComparing) {
    return 'comparison overlay';
  }

  switch (type) {
    case 's':
    case 'search':
      {
        if (totalResults > 0) {
          return 'search results';
        }

        return 'no search results';
      }

    case 'brand':
    case 'browse':
      {
        return 'product list page grid';
      }

    default:
      {
        return 'unknown';
      }
  }
};
var getPageName = function getPageName(type) {
  var isComparing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      breadcrumbs = _ref2.breadcrumbs;

  if (isComparing) {
    return 'jl:comparison page';
  }

  switch (type) {
    case 's':
    case 'search':
      {
        return 'jl:search';
      }

    case 'brand':
    case 'browse':
      {
        var displayNames = breadcrumbs.map(function (_ref3) {
          var displayName = _ref3.displayName;
          return displayName;
        });
        var crumbs = displayNames.join(':').toLowerCase();
        return "jl:".concat(crumbs, ":grid");
      }

    default:
      {
        return 'jl:unknown';
      }
  }
};
var getBreadcrumbData = function getBreadcrumbData(breadcrumbs) {
  return breadcrumbs.map(function (crumb) {
    return {
      value: crumb.displayName,
      clickable: crumb.clickable ? 1 : 0
    };
  });
};
var stripTagsFromSearch = function stripTagsFromSearch(searchTerm) {
  if (!searchTerm) return '';
  var tags = ['#_search_suggestion_referral'];
  var cleanSearchTerm = searchTerm;
  tags.forEach(function (tag) {
    cleanSearchTerm = searchTerm.replace(tag, '');
  });
  return cleanSearchTerm;
};
var getSearchData = function getSearchData(search, breadcrumbs) {
  var searchTerms = stripTagsFromSearch(search.term);

  if (searchTerms.length === 0 && search.isSuggestionLink && (breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length) > 0) {
    searchTerms = breadcrumbs[breadcrumbs.length - 1].displayName;
  }

  return {
    searchMethod: search !== null && search !== void 0 && search.alsoSearched ? 'Also searched' : 'typed search',
    sort: (search === null || search === void 0 ? void 0 : search.sortBy) || 'default: relevance',
    pageNum: "page ".concat(search.page),
    searchTerms: searchTerms,
    preSelectedFilter: ''
  };
};
var getPageSearch = function getPageSearch(type, analytics, search, breadcrumbs) {
  if (['search', 's'].includes(type) || search.isSuggestionLink) {
    var _analytics$data2, _analytics$data3, _analytics$data4;

    return {
      page: {
        search: setJLData_objectSpread(setJLData_objectSpread({
          filter: analytics === null || analytics === void 0 ? void 0 : (_analytics$data2 = analytics.data) === null || _analytics$data2 === void 0 ? void 0 : _analytics$data2.filter,
          filterNvals: analytics === null || analytics === void 0 ? void 0 : (_analytics$data3 = analytics.data) === null || _analytics$data3 === void 0 ? void 0 : _analytics$data3.filterNvals
        }, analytics === null || analytics === void 0 ? void 0 : (_analytics$data4 = analytics.data) === null || _analytics$data4 === void 0 ? void 0 : _analytics$data4.search), getSearchData(search, breadcrumbs, type))
      }
    };
  }

  var originalSearchTerm = search.originalSearchTerm;

  if (originalSearchTerm) {
    return {
      page: {
        search: {
          searchMethod: 'search redirect',
          searchTerms: stripTagsFromSearch(decodeURIComponent(originalSearchTerm))
        }
      }
    };
  }

  return {};
};
var setJLData = function setJLData(breadcrumbs, analytics, search, page) {
  var _analytics$data5, _analytics$data5$sear, _analytics$data6, _analytics$data9, _analytics$data10, _analytics$data10$spo, _sponsoredProducts$ci, _window$jlData;

  var isComparing = isCompareEvent(analytics);
  var totalResults = analytics === null || analytics === void 0 ? void 0 : (_analytics$data5 = analytics.data) === null || _analytics$data5 === void 0 ? void 0 : (_analytics$data5$sear = _analytics$data5.search) === null || _analytics$data5$sear === void 0 ? void 0 : _analytics$data5$sear.totalNumberOfResults;
  var type = page.type;
  var basketData = {
    basket: setJLBasketData()
  };
  var pageData = {
    page: {
      locale: {
        country: 'uk',
        currency: 'gbp',
        language: 'en-gb'
      },
      pageInfo: {
        pageName: getPageName(type, isComparing, {
          breadcrumbs: breadcrumbs
        }),
        pageType: getPageType(type, isComparing, {
          totalResults: totalResults
        }),
        pageCanonicalURL: window.location.href,
        site: 'm.johnlewis.com'
      },
      productPages: {
        products: analytics === null || analytics === void 0 ? void 0 : (_analytics$data6 = analytics.data) === null || _analytics$data6 === void 0 ? void 0 : _analytics$data6.products
      }
    }
  };
  var brandData = {};

  if (type === 'brand') {
    var _ref4 = breadcrumbs.length > 0 ? breadcrumbs[breadcrumbs.length - 1] : {
      displayName: ''
    },
        displayName = _ref4.displayName;

    var brandName = displayName.toLowerCase();
    brandData = {
      page: {
        productPages: {
          products: {
            brand: brandName
          }
        }
      }
    };
  }

  if (type === 'brand' || type === 'browse') {
    var _analytics$data7, _analytics$data8;

    var _getSearchData = getSearchData(search, breadcrumbs),
        sort = _getSearchData.sort,
        pageNum = _getSearchData.pageNum;

    pageData.page.productPages.products.sort = sort;
    pageData.page.productPages.products.pageNum = pageNum;
    pageData.page.productPages.products.filter = analytics === null || analytics === void 0 ? void 0 : (_analytics$data7 = analytics.data) === null || _analytics$data7 === void 0 ? void 0 : _analytics$data7.filter;
    pageData.page.productPages.products.filterNvals = analytics === null || analytics === void 0 ? void 0 : (_analytics$data8 = analytics.data) === null || _analytics$data8 === void 0 ? void 0 : _analytics$data8.filterNvals;
  }

  var breadcrumbData = {
    page: {
      pageInfo: {
        breadCrumb: getBreadcrumbData(breadcrumbs)
      }
    }
  };
  var compareData = {};

  if (analytics !== null && analytics !== void 0 && (_analytics$data9 = analytics.data) !== null && _analytics$data9 !== void 0 && _analytics$data9.compare) {
    compareData = {
      compare: analytics.data.compare
    };
  }

  var searchData = getPageSearch(type, analytics, search, breadcrumbs);
  var sponsoredProducts = {};

  if ((analytics === null || analytics === void 0 ? void 0 : (_analytics$data10 = analytics.data) === null || _analytics$data10 === void 0 ? void 0 : (_analytics$data10$spo = _analytics$data10.sponsoredProducts) === null || _analytics$data10$spo === void 0 ? void 0 : _analytics$data10$spo.length) > 0) {
    sponsoredProducts = {
      citrusProductAds: analytics.data.sponsoredProducts.filter(function (ad) {
        return ad.type === 'sponsoredProduct';
      })
    };
  }

  var components = [basketData, searchData, pageData, breadcrumbData, brandData, compareData, sponsoredProducts];
  window.jlData = cjs_default().all([window.jlData || {}].concat(components), {
    arrayMerge: overwriteMerge
  }); // merge doesnt overwrite if source object is empty so this removes any sponsoredProduct ads that should no longer be there

  if (!((_sponsoredProducts$ci = sponsoredProducts.citrusProductAds) !== null && _sponsoredProducts$ci !== void 0 && _sponsoredProducts$ci.length) && (_window$jlData = window.jlData) !== null && _window$jlData !== void 0 && _window$jlData.citrusProductAds) {
    delete window.jlData.citrusProductAds;
  }

  return window.jlData;
};
;// CONCATENATED MODULE: ./src/components/analytics/utils/transformations.js


function transformations_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function transformations_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? transformations_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : transformations_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var transformations_getConfig = config_default()(),
    transformations_publicRuntimeConfig = transformations_getConfig.publicRuntimeConfig;

var chunkSize = transformations_publicRuntimeConfig.chunkSize;
/**
 * @typedef {Object} breadcrumb
 * @property {String} clickable
 * @property {String} displayName
 *
 * Convert field names within breadcrumb objects to those used by Analytics
 * @param {Object[]} breadcrumbs
 * @returns {Object[]}
 */

var convertBreadcrumbs = function convertBreadcrumbs(breadcrumbs) {
  return breadcrumbs ? breadcrumbs.map(function (breadcrumb) {
    var clickable = breadcrumb.clickable,
        displayName = breadcrumb.displayName;
    return {
      value: displayName.toLowerCase(),
      clickable: clickable
    };
  }) : [];
};
/**
 * Convert delivery type codes into the abbreviated format used by Analytics
 * @param {String} deliveryTypeCode
 * @returns {String}
 */

var getDeliveryType = function getDeliveryType(deliveryTypeCode) {
  switch (deliveryTypeCode) {
    case 'UK_DELIVERY':
      return 'uk';

    case 'CLICK_AND_COLLECT':
      return 'cc';

    case 'COLLECT_PLUS':
      return 'cp';

    case 'INTERNATIONAL':
      return 'int';

    default:
      return deliveryTypeCode.toLowerCase();
  }
};
/**
 * @typedef { deliveryTypes } deliveryInformation
 * @property { deliveryType[] } deliveryTypes
 *
 * @typedef { { deliveryTypeCode: string } } deliveryType
 *
 * Create an {ANALYTICS_SEPARATOR}-delimited list of delivery options (in Analytics format) that apply to this sku
 * @param {Object} deliveryInformation
 * @returns {String}
 */


var extractDeliveryOptions = function extractDeliveryOptions(deliveryInformation) {
  return deliveryInformation !== null && deliveryInformation !== void 0 && deliveryInformation.deliveryTypes ? deliveryInformation.deliveryTypes.map(function (deliveryType) {
    return getDeliveryType(deliveryType.deliveryTypeCode);
  }).join(ANALYTICS_SEPARATOR) : '';
};
var getCompareProductDetails = function getCompareProductDetails(products, open, sponsoredProducts) {
  return products && open ? products.map(function (product) {
    var productId = product.productId,
        skuId = product.skuId,
        _product$price = product.price,
        price = _product$price === void 0 ? '' : _product$price;
    var compareProduct = {
      sku: skuId,
      productId: productId,
      itemPrice: price ? price.replace('£', '') : ''
    };
    var sponsoredProduct = sponsoredProducts.find(function (product) {
      return product.productId === compareProduct.productId;
    });
    if (sponsoredProduct) compareProduct.citrusAdId = sponsoredProduct.adId;
    return compareProduct;
  }) : [];
};
/**
 * @typedef {Object} sku
 * @property {Integer} stockLevel
 * @property {String} id
 *
 * Create an {ANALYTICS_SEPARATOR}-delimited list of skuIds that are out of stock at the moment
 * @param {Object[]} skus
 * @returns {String}
 *
 * e.g. [{id: 1111, stockLevel: 1}, {id: 2222, stockLevel: 0}, {id: 3333, stockLevel: 3}, {id: 4444, stockLevel: 0}]
 *      becomes "2222|4444"
 */

var getOutOfStockSkus = function getOutOfStockSkus(skus) {
  return skus ? skus.filter(function (sku) {
    return sku.stockLevel === 0;
  }).map(function (sku) {
    return sku.id;
  }).join(ANALYTICS_SEPARATOR) : '';
};
var extractAlternativeSearchSuggestions = function extractAlternativeSearchSuggestions(search) {
  return search && search.alternativeSearchSuggestions ? search.alternativeSearchSuggestions.map(function (_ref) {
    var searchTerm = _ref.searchTerm;
    return searchTerm;
  }).join(events/* ANALYTICS_SEPARATOR */.x8) : '';
};
var extractProducts = function extractProducts(_ref2) {
  var _ref2$productData = _ref2.productData,
      productData = _ref2$productData === void 0 ? {} : _ref2$productData,
      _ref2$search = _ref2.search,
      search = _ref2$search === void 0 ? {} : _ref2$search,
      chunk = _ref2.chunk;
  var prods = productData.products;
  var personalisedPlp = search.personalisedPlp;

  if (prods) {
    //TODO: This check worries me. products should not be undefined.
    var slicedProducts = prods.slice(0, chunkSize);
    var productIds = slicedProducts.map(function (product) {
      return product.id;
    });
    var first6Products = prods === null || prods === void 0 ? void 0 : prods.slice(0, 6);
    var first6OutOfStock = first6Products.map(function (product) {
      return product.outOfStock ? 'outofstock' : 'instock';
    }).join(events/* ANALYTICS_SEPARATOR */.x8);
    var first6ProductIDs = first6Products.map(function (product) {
      return product.id;
    }).join(events/* ANALYTICS_SEPARATOR */.x8);
    var first6Reviews = first6Products.map(function (product) {
      var _product$rating;

      return (_product$rating = product.rating) === null || _product$rating === void 0 ? void 0 : _product$rating.reviews;
    }).join(events/* ANALYTICS_SEPARATOR */.x8);
    var first6StarRatings = first6Products.map(function (product) {
      var _product$rating2;

      return (_product$rating2 = product.rating) === null || _product$rating2 === void 0 ? void 0 : _product$rating2.averageRating;
    }).join(events/* ANALYTICS_SEPARATOR */.x8);
    var first6Promotions = first6Products.map(function (product) {
      var _product$promoMessage;

      return ((_product$promoMessage = product.promoMessages) === null || _product$promoMessage === void 0 ? void 0 : _product$promoMessage.length) > 0 ? product.promoMessages[0] : '';
    }).join(events/* ANALYTICS_SEPARATOR */.x8);
    var results = {
      displayNum: slicedProducts.length,
      pagination: productData.pagesAvailable,
      totalNumberOfResults: productData.totalNumberOfResults,
      pageNum: productData.pageNumber,
      first6OutOfStock: first6OutOfStock,
      first6ProductIDs: first6ProductIDs,
      first6Promotions: first6Promotions,
      first6Reviews: first6Reviews,
      first6StarRatings: first6StarRatings,
      productIds: productIds
    };
    return {
      products: {
        chunkDetails: {
          chunkOffset: 0,
          products: chunk == 8 || prods.length > productData.totalNumberOfResults && productData.totalNumberOfResults % chunkSize === 0 ? prods.map(mapProduct/* mapProduct */.S) : prods.slice(0, Number(chunk, 10) * chunkSize).map(mapProduct/* mapProduct */.S),
          personalisedPlp: personalisedPlp
        }
      },
      results: results
    };
  }

  return {
    //TODO: This should never run in production: ProductContext should provide an empty array ( ([]) !== undefined )
    products: {},
    search: {}
  };
};
/**
 * @param {Object[]} breadcrumbs
 * @param {String} productId
 * @returns {String}
 */

var transformations_getPageName = function getPageName(breadcrumbs, productId) {
  return ['jl'].concat(breadcrumbs ? breadcrumbs.map(function (breadcrumb) {
    return breadcrumb.displayName;
  }) : []).concat(productId || []).join(':').toLowerCase();
};

var extractSponsoredProducts = function extractSponsoredProducts(products) {
  if (products) {
    //TODO: Remove this once ProductContext defaults are discussed
    return products.filter(function (product) {
      return 'adId' in product;
    }).map(function (product) {
      return {
        adId: product.adId,
        productId: product.id,
        type: 'sponsoredProduct'
      };
    });
  }

  return [];
};

var getAnalyticsData = function getAnalyticsData(_ref3) {
  var chunk = _ref3.chunk,
      compare = _ref3.compare,
      facets = _ref3.facets,
      page = _ref3.page,
      productData = _ref3.productData,
      search = _ref3.search;
  var extractedProductInformation = extractProducts({
    productData: productData,
    search: search,
    chunk: chunk
  });
  var sponsoredProducts = extractSponsoredProducts(productData.products);
  var alternativeSearchSuggestions = extractAlternativeSearchSuggestions(search);
  var applied = facets.applied;
  var filterCombination = applied.filterCombination,
      filterCombinationNvals = applied.filterCombinationNvals;
  var data = {
    filter: filterCombination,
    filterNvals: filterCombinationNvals,
    compare: {
      product: getCompareProductDetails(compare.data, compare.isOpen, sponsoredProducts)
    },
    products: extractedProductInformation.products,
    search: transformations_objectSpread({}, extractedProductInformation.results),
    sponsoredProducts: sponsoredProducts
  };
  var type = page.type;

  switch (type) {
    case 's':
    case 'search':
      {
        data.search = transformations_objectSpread(transformations_objectSpread(transformations_objectSpread({}, data.search), extractedProductInformation.results), {}, {
          searchTermDidYouMean: alternativeSearchSuggestions,
          searchTermRecommended: (search === null || search === void 0 ? void 0 : search.correctedSearchTerm) || '',
          redirectType: (search === null || search === void 0 ? void 0 : search.redirectType) || 'no redirect'
        });
        break;
      }

    case 'brand':
    case 'browse':
      {
        data.products = transformations_objectSpread(transformations_objectSpread({}, data.products), extractedProductInformation.results);
        break;
      }

    default:
      {
        break;
      }
  }

  return {
    data: data
  };
};
// EXTERNAL MODULE: ./src/components/debug/Debug.jsx
var Debug = __webpack_require__(74906);
;// CONCATENATED MODULE: ./src/context/AnalyticsContext.jsx


var AnalyticsContext_Context = /*#__PURE__*/external_React_default().createContext();
var useAnalyticsContext = function useAnalyticsContext() {
  return (0,external_React_.useContext)(AnalyticsContext_Context);
};
var AnalyticsContext_Provider = function Provider(_ref) {
  var children = _ref.children;

  var _useState = (0,external_React_.useState)(),
      lastUpdatedTimestamp = _useState[0],
      setTimestamp = _useState[1];

  var updateTimestamp = function updateTimestamp() {
    return setTimestamp(Number(new Date()));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(AnalyticsContext_Context.Provider, {
    value: [lastUpdatedTimestamp, updateTimestamp],
    children: children
  });
};
;// CONCATENATED MODULE: ./src/components/analytics/update-hooks/useAnalyticsCompareUpdate.tsx


var useAnalyticsCompareUpdate = function useAnalyticsCompareUpdate() {
  var _useCompareContext = (0,CompareContext/* useCompareContext */.EN)(),
      isCompareOpen = _useCompareContext.isOpen;

  var _useState = (0,external_React_.useState)(isCompareOpen),
      compareIsOpen = _useState[0],
      setCompareIsOpen = _useState[1];

  (0,external_React_.useEffect)(function () {
    setCompareIsOpen(isCompareOpen);
  }, [isCompareOpen]);
  return {
    compareIsOpen: compareIsOpen
  };
};
;// CONCATENATED MODULE: ./src/components/analytics/update-hooks/useAnalyticsProductUpdate.tsx


var useAnalyticsProductUpdate = function useAnalyticsProductUpdate() {
  var _useProductContext = (0,ProductContext/* useProductContext */.$h)(),
      allProducts = _useProductContext.products;

  var _useState = (0,external_React_.useState)(allProducts),
      products = _useState[0],
      setProducts = _useState[1];

  (0,external_React_.useEffect)(function () {
    if (JSON.stringify(products) !== JSON.stringify(allProducts)) {
      setProducts(allProducts);
    }
  }, [allProducts]);
  return {
    products: products
  };
};
;// CONCATENATED MODULE: ./src/components/analytics/update-hooks/useAnalyticsProductCardViewUpdate.tsx


var useAnalyticsProductCardViewUpdate = function useAnalyticsProductCardViewUpdate() {
  var _useProductCardSize = useProductCardSize(),
      isLargeCardSize = _useProductCardSize.isLargeCardSize;

  var _useState = (0,external_React_.useState)(isLargeCardSize),
      isLargeCardsEnabled = _useState[0],
      setIsLargeCardsEnabled = _useState[1];

  (0,external_React_.useEffect)(function () {
    setIsLargeCardsEnabled(isLargeCardSize);
  }, [isLargeCardSize]);
  return {
    isLargeCardsEnabled: isLargeCardsEnabled
  };
};
;// CONCATENATED MODULE: ./src/components/analytics/Analytics.jsx













var debug = (0,Debug/* createDebugger */.JJ)('analytics');




var Analytics = function Analytics(_ref) {
  var page = _ref.page;

  var _useAnalyticsContext = useAnalyticsContext(),
      _useAnalyticsContext2 = (0,slicedToArray/* default */.Z)(_useAnalyticsContext, 2),
      updateTimestamp = _useAnalyticsContext2[1];

  var compare = (0,CompareContext/* useCompareContext */.EN)();
  var search = (0,SearchContext/* useSearchContext */.AB)();

  var _useBreadcrumbContext = useBreadcrumbContext(),
      breadcrumbs = _useBreadcrumbContext.breadcrumbs;

  var facets = (0,FacetContext/* useFacetContext */.gv)();
  var productData = (0,ProductContext/* useProductContext */.$h)();

  var _useRouter = (0,next_router.useRouter)(),
      query = _useRouter.query;

  var _query$chunk = query.chunk,
      chunk = _query$chunk === void 0 ? '1' : _query$chunk;

  var serialiseDependencies = function serialiseDependencies(value) {
    return JSON.stringify(value);
  };

  var compareUpdates = useAnalyticsCompareUpdate();
  var productUpdates = useAnalyticsProductUpdate();
  var productCardViewUpdates = useAnalyticsProductCardViewUpdate();
  var basketUpdates = (0,cachedBasket.useCachedBasketData)();
  var dependencies = [serialiseDependencies(compareUpdates), serialiseDependencies(productUpdates), serialiseDependencies(productCardViewUpdates), serialiseDependencies(basketUpdates)];
  (0,external_React_.useEffect)(function () {
    var analytics = getAnalyticsData({
      compare: compare,
      facets: facets,
      page: page,
      productData: productData,
      search: search,
      chunk: chunk
    });
    setJLData(breadcrumbs, analytics, search, page);
    updateTimestamp();
    debug("dispatching event \"".concat(events/* ANALYTICS_JLDATA_UPDATED */.jU, "\""));
    document.body.dispatchEvent(new CustomEvent(events/* ANALYTICS_JLDATA_UPDATED */.jU)); // // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
  return null;
};
// EXTERNAL MODULE: ./src/context/EnergyDrawerContext.tsx
var EnergyDrawerContext = __webpack_require__(88613);
;// CONCATENATED MODULE: ./src/context/RootContext.jsx
















var RootContext = function RootContext(_ref) {
  var children = _ref.children,
      providerData = _ref.providerData;

  var _JSON$parse = JSON.parse(providerData),
      banners = _JSON$parse.banners,
      breadcrumbs = _JSON$parse.breadcrumbs,
      discovery = _JSON$parse.discovery,
      facets = _JSON$parse.facets,
      filterSuggestions = _JSON$parse.filterSuggestions,
      pageCorrelationId = _JSON$parse.pageCorrelationId,
      products = _JSON$parse.products,
      search = _JSON$parse.search;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ApplicationSettingsContext_Provider, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(RequestContext_Provider, {
      pageCorrelationId: pageCorrelationId,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductContext/* Provider */.zt, {
        products: products,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DiscoveryContext_Provider, {
          discovery: discovery,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SocialProofContext_Provider, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FacetContext/* Provider */.zt, {
              facets: facets,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Provider, {
                filterSuggestions: filterSuggestions,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(SearchContext/* Provider */.zt, {
                  search: search,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(CompareContext/* Provider */.zt, {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbContext_Provider, {
                      breadcrumbs: breadcrumbs,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(AnalyticsContext_Provider, {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(AnchorCardContext_Provider, {
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(BannerContext_Provider, {
                            banners: banners,
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)(EnergyDrawerContext/* Provider */.zt, {
                              children: children
                            })
                          })
                        })
                      })
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  });
};
// EXTERNAL MODULE: ./pages/[type]/search.module.scss
var search_module = __webpack_require__(99380);
var search_module_default = /*#__PURE__*/__webpack_require__.n(search_module);
;// CONCATENATED MODULE: ./pages/[type]/[[...facetId]].jsx


var _facetId_excluded = ["meta", "providerData", "cookies"];

function _facetId_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _facetId_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _facetId_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : _facetId_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var Index = function Index(_ref) {
  var _plpCookies$current;

  var meta = _ref.meta,
      providerData = _ref.providerData,
      cookies = _ref.cookies,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _facetId_excluded);

  var _useRouter = (0,next_router.useRouter)(),
      query = _useRouter.query;

  var heading = meta.heading,
      subHeading = meta.subHeading;
  var type = query.type;
  var plpCookies = (0,external_React_.useRef)(cookies);
  var monetateId = (0,external_React_.useRef)((_plpCookies$current = plpCookies.current) === null || _plpCookies$current === void 0 ? void 0 : _plpCookies$current['mt.v']);
  (0,external_React_.useEffect)(function () {
    if (!monetateId.current) {
      var _plpCookies$current2;

      plpCookies.current = parseCookies(window.document.cookie);
      monetateId.current = (_plpCookies$current2 = plpCookies.current) === null || _plpCookies$current2 === void 0 ? void 0 : _plpCookies$current2['mt.v'];
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Experiences/* ExperiencesProvider */.iB, _facetId_objectSpread(_facetId_objectSpread({
    monetateId: monetateId
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(RootContext, {
      providerData: providerData,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Analytics, {
        page: {
          type: type
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(meta_Meta, _facetId_objectSpread({}, meta)), /*#__PURE__*/(0,jsx_runtime.jsx)("main", {
        id: "main",
        tabIndex: "-1",
        "data-test": "component-plp",
        className: (search_module_default()).primaryMain,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(views_PLP, {
          cookies: plpCookies,
          heading: heading,
          subHeading: subHeading
        })
      })]
    })
  }));
};

var __N_SSP = true;
/* harmony default export */ var _facetId_ = (Index);

/***/ }),

/***/ 85576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$j": function() { return /* binding */ dispatchAnalyticsEvent; },
/* harmony export */   "B2": function() { return /* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_2__.B2; },
/* harmony export */   "G$": function() { return /* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_2__.G$; },
/* harmony export */   "OG": function() { return /* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_2__.OG; },
/* harmony export */   "TR": function() { return /* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_2__.TR; },
/* harmony export */   "Xg": function() { return /* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_2__.Xg; },
/* harmony export */   "fv": function() { return /* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_2__.fv; },
/* harmony export */   "fz": function() { return /* binding */ dispatchCitrusAnalytics; },
/* harmony export */   "gM": function() { return /* binding */ dispatchImmediateAnalyticsEvent; },
/* harmony export */   "l7": function() { return /* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_2__.l7; },
/* harmony export */   "pg": function() { return /* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_2__.pg; },
/* harmony export */   "sG": function() { return /* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_2__.sG; },
/* harmony export */   "tp": function() { return /* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_2__.tp; },
/* harmony export */   "wQ": function() { return /* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_2__.wQ; },
/* harmony export */   "yc": function() { return /* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_2__.yc; }
/* harmony export */ });
/* harmony import */ var _builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34386);
/* harmony import */ var _debug_Debug__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74906);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var debug = (0,_debug_Debug__WEBPACK_IMPORTED_MODULE_1__/* .createDebugger */ .JJ)('analytics');

var dispatchAnalyticsEvent = function dispatchAnalyticsEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 10000 : _ref$timeout,
      _ref$predecessorEvent = _ref.predecessorEventName,
      predecessorEventName = _ref$predecessorEvent === void 0 ? _events__WEBPACK_IMPORTED_MODULE_2__/* .ANALYTICS_JLDATA_UPDATED */ .jU : _ref$predecessorEvent;

  var event = new CustomEvent('dataStateChange', {
    detail: _objectSpread({
      action: eventName
    }, data)
  });
  debug("waiting to dispatch \"".concat(eventName, "\": %O"), data);
  var deferredDispatchPromise = new Promise(function (resolve, reject) {
    // it's reassigned after initialized.
    var wait;

    var listener = function listener() {
      document.body.dispatchEvent(event);
      debug("dispatched \"".concat(eventName, "\": %O"), data);
      document.body.removeEventListener(predecessorEventName, listener);
      clearTimeout(wait);
      resolve(event);
    };

    debug("adding listener for \"".concat(predecessorEventName, "\" event"));
    document.body.addEventListener(predecessorEventName, listener, {
      once: true
    });
    wait = setTimeout(function () {
      debug("timed out waiting to dispatch \"".concat(eventName, "\": %O"), data);
      document.body.removeEventListener(predecessorEventName, listener);
      reject();
    }, timeout);
  });
  return deferredDispatchPromise["catch"](function () {
    debug("WARNING: expected \"".concat(eventName, "\" to trigger but it did not."), event);
  });
};
var dispatchImmediateAnalyticsEvent = function dispatchImmediateAnalyticsEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new Promise(function (resolve) {
    var event = new CustomEvent('dataStateChange', {
      bubbles: true,
      detail: _objectSpread({
        action: eventName
      }, data)
    });
    document.body.dispatchEvent(event);
    debug("dispatched immediate \"".concat(eventName, "\": %O"), data);
    resolve(event);
  });
};
var dispatchCitrusAnalytics = function dispatchCitrusAnalytics(productId, adId) {
  dispatchImmediateAnalyticsEvent(_events__WEBPACK_IMPORTED_MODULE_2__/* .CITRUS_AD_CLICK */ .By, {
    productId: productId,
    adId: adId,
    type: 'sponsoredProduct'
  });
};

/***/ }),

/***/ 34386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B2": function() { return /* binding */ FILTER_REMOVED; },
/* harmony export */   "By": function() { return /* binding */ CITRUS_AD_CLICK; },
/* harmony export */   "G$": function() { return /* binding */ ALSO_SEARCHED; },
/* harmony export */   "OG": function() { return /* binding */ SORT_OPTION_CHANGED; },
/* harmony export */   "TR": function() { return /* binding */ ADD_TO_BASKET; },
/* harmony export */   "Xg": function() { return /* binding */ PAGINATION; },
/* harmony export */   "_h": function() { return /* binding */ MANAGED_IMPRESSION; },
/* harmony export */   "fv": function() { return /* binding */ CHUNK_LOADED; },
/* harmony export */   "jU": function() { return /* binding */ ANALYTICS_JLDATA_UPDATED; },
/* harmony export */   "l7": function() { return /* binding */ GLOBAL_SEARCH_INTERACTION; },
/* harmony export */   "oZ": function() { return /* binding */ PAGE_LOAD; },
/* harmony export */   "pg": function() { return /* binding */ FILTER_APPLIED; },
/* harmony export */   "sG": function() { return /* binding */ GLOBAL_INTERACTION; },
/* harmony export */   "tp": function() { return /* binding */ ALTERNATE_IMAGE; },
/* harmony export */   "wQ": function() { return /* binding */ FILTER_INTERACTION; },
/* harmony export */   "x8": function() { return /* binding */ ANALYTICS_SEPARATOR; },
/* harmony export */   "yc": function() { return /* binding */ COMPARE_PRODUCTS; }
/* harmony export */ });
/* unused harmony exports COLOUR_SELECTED, PRODUCT_CARD_TOGGLE_CHANGED, COMPARE_DATA_UPDATED */
var ADD_TO_BASKET = 'plp.addToBasket';
var ALSO_SEARCHED = 'plp.alsoSearched';
var ALTERNATE_IMAGE = 'plp.imageAlternate';
var ANALYTICS_SEPARATOR = '|';
var CHUNK_LOADED = 'plp.chunkLoad';
var COLOUR_SELECTED = 'plp.colourSelected';
var COMPARE_PRODUCTS = 'plp.compareClicked';
var FILTER_APPLIED = 'plp.filterApplied';
var FILTER_INTERACTION = 'plp.filterInteraction';
var FILTER_REMOVED = 'plp.filterRemoved';
var GLOBAL_INTERACTION = 'global.interaction';
var GLOBAL_SEARCH_INTERACTION = 'global.searchInteraction';
var MANAGED_IMPRESSION = 'managedImpression';
var PAGE_LOAD = 'pageload';
var PAGINATION = 'plp.changePageNum';
var PRODUCT_CARD_TOGGLE_CHANGED = 'plp.productCardToggle';
var SORT_OPTION_CHANGED = 'plp.changeSortOption';
var CITRUS_AD_CLICK = 'citrusAd.clicked';
var ANALYTICS_JLDATA_UPDATED = 'JlDataUpdateComplete';
var COMPARE_DATA_UPDATED = 'compareDataUpdateComplete';

/***/ }),

/***/ 36524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ mapProduct; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./src/components/analytics/utils/specialMessage.js
// String Constants that describe the `displaySpecialOffer` field
var IS_JL_EXCLUSIVE = 'exclusive to john lewis & partners';
var IS_PRICE_MATCH = 'price match';
var IS_REDUCED_TO_CLEAR = 'reduced to clear';
var isJLExclusive = function isJLExclusive(specialOfferMessage) {
  return specialOfferMessage ? specialOfferMessage.toLowerCase() === IS_JL_EXCLUSIVE : false;
};
var isPriceMatch = function isPriceMatch(specialOfferMessage) {
  return specialOfferMessage ? specialOfferMessage.toLowerCase() === IS_PRICE_MATCH : false;
};
var isReducedToClear = function isReducedToClear(specialOfferMessage) {
  return specialOfferMessage ? specialOfferMessage.toLowerCase() === IS_REDUCED_TO_CLEAR : false;
};
;// CONCATENATED MODULE: ./src/components/analytics/utils/mapProduct.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var formatThenPrice = function formatThenPrice(price) {
  if (!price.then2) {
    return (price.then1 || '').toString();
  }

  if (!price.then1) {
    return '';
  }

  return "".concat(price.then1, ", ").concat(price.then2);
};

var mapProduct = function mapProduct(product, index) {
  var data = {};
  var id = product.id,
      productId = product.productId,
      priceRange = product.priceRange,
      _product$price = product.price,
      priceValue = _product$price === void 0 ? {
    currency: '',
    now: '',
    then1: '',
    then2: '',
    was: ''
  } : _product$price,
      _product$displaySpeci = product.displaySpecialOffer,
      displaySpecialOffer = _product$displaySpeci === void 0 ? '' : _product$displaySpeci,
      _product$outOfStock = product.outOfStock,
      outOfStock = _product$outOfStock === void 0 ? '' : _product$outOfStock,
      _product$colorSwatche = product.colorSwatches,
      colorSwatches = _product$colorSwatche === void 0 ? [] : _product$colorSwatche,
      _product$rating = product.rating,
      rating = _product$rating === void 0 ? {
    averageRating: '',
    reviews: ''
  } : _product$rating,
      defaultSkuId = product.defaultSkuId,
      isMultiSku = product.isMultiSku,
      adId = product.adId,
      promoClassifications = product.promoClassifications;
  var price = priceRange || priceValue;
  var _price$now = price.now,
      priceNow = _price$now === void 0 ? '' : _price$now,
      _price$was = price.was,
      priceWas = _price$was === void 0 ? '' : _price$was;
  var priceThen = formatThenPrice(price);

  if (index > -1) {
    data.listPosition = index + 1;
  }

  data.productId = id || productId;

  if (adId) {
    data.citrusAdId = adId;
  }

  if (promoClassifications !== null && promoClassifications !== void 0 && promoClassifications.length) {
    data.promotionClassifications = promoClassifications;
  }

  return _objectSpread(_objectSpread({
    currency: 'gbp'
  }, data), {}, {
    sku: defaultSkuId,
    hasSpecialOfferText: displaySpecialOffer !== '',
    isJLExclusive: isJLExclusive(displaySpecialOffer),
    isOutOfStock: outOfStock,
    isPriceMatch: isPriceMatch(displaySpecialOffer),
    isReducedToClear: isReducedToClear(displaySpecialOffer),
    numColourSwatches: colorSwatches === null || colorSwatches === void 0 ? void 0 : colorSwatches.length,
    numReviews: rating === null || rating === void 0 ? void 0 : rating.reviews,
    rating: rating === null || rating === void 0 ? void 0 : rating.averageRating,
    priceNow: priceNow,
    priceThen: priceThen,
    priceWas: priceWas,
    isMultiSku: isMultiSku
  });
};

/***/ }),

/***/ 74906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JJ": function() { return /* binding */ createDebugger; }
/* harmony export */ });
/* unused harmony exports useDebugger, Provider */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var debug__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11227);
/* harmony import */ var debug__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(debug__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
/* istanbul ignore file */



(debug__WEBPACK_IMPORTED_MODULE_1___default().log) = console.info.bind(console);
var NAMESPACE = 'jlp:plp';
var Context = /*#__PURE__*/(/* unused pure expression or super */ null && (React.createContext()));
var instance = debug__WEBPACK_IMPORTED_MODULE_1___default()(NAMESPACE);
var createDebugger = function createDebugger(name) {
  return instance.extend(name);
};
var useDebugger = function useDebugger() {
  return useContext(Context);
};
var Provider = function Provider(_ref) {
  var children = _ref.children,
      name = _ref.name,
      localDebug = _ref.debug;
  var value = localDebug || createDebugger(name);
  return /*#__PURE__*/_jsx(Context.Provider, {
    value: value,
    children: children
  });
};

/***/ }),

/***/ 77554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useEnergyDrawerData; }
/* harmony export */ });
/* harmony import */ var _context_EnergyDrawerContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88613);
/* harmony import */ var _analytics_analyticsEvents__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85576);


var useEnergyDrawerData = function useEnergyDrawerData() {
  var _useEnergyDrawerConte = (0,_context_EnergyDrawerContext__WEBPACK_IMPORTED_MODULE_0__/* .useEnergyDrawerContext */ .YP)(),
      energyDrawerData = _useEnergyDrawerConte.energyDrawerData,
      energyDrawerIsOpen = _useEnergyDrawerConte.energyDrawerIsOpen,
      setEnergyDrawerData = _useEnergyDrawerConte.setEnergyDrawerData,
      setEnergyDrawerIsOpen = _useEnergyDrawerConte.setEnergyDrawerIsOpen;

  var openEnergyDrawer = function openEnergyDrawer(altText, energyRating, energyLabel, energyInformationSheet, adId, productId) {
    setEnergyDrawerData({
      imageSrc: energyLabel,
      altText: altText,
      energyRating: energyRating,
      energyInformationSheet: energyInformationSheet
    });
    setEnergyDrawerIsOpen(true);
    (0,_analytics_analyticsEvents__WEBPACK_IMPORTED_MODULE_1__/* .dispatchCitrusAnalytics */ .fz)(productId, adId);
  };

  var closeEnergyDrawer = function closeEnergyDrawer() {
    setEnergyDrawerIsOpen(false);
  };

  return {
    energyDrawerData: energyDrawerData,
    isOpen: energyDrawerIsOpen,
    openEnergyDrawer: openEnergyDrawer,
    closeEnergyDrawer: closeEnergyDrawer
  };
};

/***/ }),

/***/ 91576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iB": function() { return /* binding */ ExperiencesProvider; },
  "Te": function() { return /* binding */ dispatchMonetateManagedImpressions; },
  "Xe": function() { return /* binding */ useExperiencesContext; }
});

// UNUSED EXPORTS: ExperiencesContext, dispatchMonetateManagedImpression, getExperiences, getExperiencesConfig, getFeatureValue, getFilteredExperiencesConfig, getFlagSettings, getFlagValue, getMergedProperties, getVariantLabel

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: external "React"
var external_React_ = __webpack_require__(37667);
var external_React_default = /*#__PURE__*/__webpack_require__.n(external_React_);
// EXTERNAL MODULE: ./src/components/debug/Debug.jsx
var Debug = __webpack_require__(74906);
// EXTERNAL MODULE: ./src/components/analytics/analyticsEvents.js
var analyticsEvents = __webpack_require__(85576);
// EXTERNAL MODULE: ./src/components/analytics/events.js
var events = __webpack_require__(34386);
;// CONCATENATED MODULE: ./src/components/experiences/experienceSettings.json
var experienceSettings_namespaceObject = JSON.parse('{"isTopBannerFeatureFlagOn":["topBanner",true],"isHybridBannerFeatureFlagOn":["hybridBanner",true],"isProductCardSizeFlagOn":["productCardSize"],"isProductCardSizeOverrideOn":["productCardSizeOverride"],"isListViewOn":["listViewEnabled"],"isListViewAdditionalDetails":["listViewAdditionalDetailsEnabled"],"isProductCardCarouselFeatureFlagOn":["productCardCarouselEnabled"],"isProductCardCarouselAltStartFeatureFlagOn":["productCardCarouselAltStartEnabled"],"isFilterSuggestionsFlagOn":["filterSuggestionsEnabled"],"isPriceReductionFlagOn":["showPriceReductionEnabled"],"isSponsoredTitleFlagOn":["sponsoredTitleEnabled",true],"isPromoQuickViewFlagOn":["promoQuickViewTestEnabled"],"isSponsoredProductsOn":["sponsoredProductsEnabled",true],"isDiscoImpressionsFlagOn":["discoImpressionsEnabled"],"isLargeCardSizeFlagOn":["largeCardSizeEnabled"],"isAltImageOnHoverFlagOn":["altImageHoverEnabled",true],"isDiscoveryRailFlagOn":["discoveryRailEnabled"],"isDiscoveryRailWithCTAButtonsFlagOn":["discoveryRailCTAButtonsEnabled"],"isNowWasFlagOn":["nowWasEnabled"],"isNowWasImpressionsFlagOn":["nowWasImpressionsEnabled"],"isFacetLimitOn":["facetLimitEnabled"],"isTaggstarFlagOn":["taggstarEnabled"],"isBrowseSponsoredProductsOn":["browseSponsoredProductsEnabled",true],"isSocialProofingQuickViewOn":["socialProofingQuickViewEnabled",true],"isSocialProofingProductCardOn":["socialProofingProductCardEnabled",true],"isOldPromoMsgsFlagOn":["oldPromoMsgsEnabled"],"isSearchSponsoredBannersFlagOn":["searchSponsoredBannersEnabled"],"isWiderScrollbarFlagOn":["widerScrollbarEnabled",true],"isTopSeoBannerFlagOn":["isTopSeoBannerEnabled"],"isHeroAttributesFlagOn":["heroAttributesEnabled"],"isPromoIndicatorsFlagOn":["promoIndicatorsEnabled"],"isLimitedSwatchesFlagOn":["limitedSwatchesEnabled"]}');
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/experiences/Experiences.jsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable no-console */




 // {FlagNameInCode: [flagNameInMonetate, defaultValue]}



var debug = (0,Debug/* createDebugger */.JJ)('monetate');
var ExperiencesContext = /*#__PURE__*/external_React_default().createContext();
var ATB_BLOCKED_SKU_LIST = 'blockedATBList';
var getExperiences = function getExperiences(experiences, featureFlagName) {
  if (!experiences) {
    return [];
  }

  return experiences.filter(function (exp) {
    var parameters = exp.parameters || {};
    return Object.keys(parameters).includes(featureFlagName) && parameters[featureFlagName] === 'on';
  });
};
var dispatchMonetateManagedImpression = function dispatchMonetateManagedImpression(_ref) {
  var _ref$monetateId = _ref.monetateId,
      monetateId = _ref$monetateId === void 0 ? null : _ref$monetateId,
      _ref$impressionIds = _ref.impressionIds,
      impressionIds = _ref$impressionIds === void 0 ? [] : _ref$impressionIds;

  if (impressionIds && Array.isArray(impressionIds) && impressionIds.length > 0) {
    var monetateAPI = 'https://engine.monetate.net/api/engine/v1/decide/JohnLewis';
    var impressionRecord = {
      channel: window.location.host === 'www.johnlewis.com' ? 'a-76ca7dd3/p/johnlewis.com' : 'a-76ca7dd3/d/dev-johnlewis.com',
      monetateId: monetateId,
      events: [{
        eventType: 'monetate:record:Impressions',
        impressionIds: impressionIds
      }]
    };

    try {
      fetch(monetateAPI, {
        method: 'POST',
        body: JSON.stringify(impressionRecord)
      });
      debug("posted to Monetate channel \"".concat(impressionRecord.channel, "\" with impressionIds \"").concat(impressionIds, "\""));
    } catch (error) {
      console.error('dispatchMonetateManagedImpression', error);
    }
  }
};
var dispatchMonetateManagedImpressions = function dispatchMonetateManagedImpressions(_ref2) {
  var monetateId = _ref2.monetateId,
      experiences = _ref2.experiences,
      monetateFlagName = _ref2.monetateFlagName;
  var matchingExperiences = getExperiences(experiences, monetateFlagName).filter(function (exp) {
    return exp.impressionId;
  });
  var impressionIds = matchingExperiences.map(function (exp) {
    return exp.impressionId;
  });

  if (impressionIds.length > 0) {
    try {
      var managedImpressionMonetateId = monetateId === null || monetateId === void 0 ? void 0 : monetateId.current;
      dispatchMonetateManagedImpression({
        monetateId: managedImpressionMonetateId,
        impressionIds: impressionIds
      });
    } catch (error) {
      console.error("Error dispatching Monetate managed impressions for ".concat(monetateFlagName, " and ").concat(impressionIds, ": ").concat(JSON.stringify(error)));
    }

    (0,analyticsEvents/* dispatchImmediateAnalyticsEvent */.gM)(events/* MANAGED_IMPRESSION */._h, {
      campaigns: matchingExperiences.map(function (exp) {
        return {
          id: exp.impressionId,
          key: exp.experienceName,
          reports: [],
          split: exp.variantLabel
        };
      })
    });
  }
};
var getExperiencesConfig = function getExperiencesConfig(req) {
  var _req$headers;

  var experiencesHeader = req === null || req === void 0 ? void 0 : (_req$headers = req.headers) === null || _req$headers === void 0 ? void 0 : _req$headers['x-experiences-json'];

  if (!experiencesHeader) {
    return null;
  }

  return decode(experiencesHeader);
};
var getFilteredExperiencesConfig = function getFilteredExperiencesConfig(experiencesConfig, serviceKeys) {
  if (!experiencesConfig || !serviceKeys) {
    return null;
  }

  return JSON.parse(experiencesConfig).filter(function (experiences) {
    var _experiences$paramete;

    return serviceKeys.includes((_experiences$paramete = experiences.parameters) === null || _experiences$paramete === void 0 ? void 0 : _experiences$paramete.service);
  });
};
var useExperiencesContext = function useExperiencesContext() {
  return (0,external_React_.useContext)(ExperiencesContext);
};
var getMergedProperties = function getMergedProperties(experiences) {
  if (!experiences) return [];
  var allParams = [];
  experiences.forEach(function (experience) {
    var params = experience === null || experience === void 0 ? void 0 : experience.parameters;

    if (params) {
      var experienceParams = Object.keys(params).map(function (name) {
        var alreadySetBy = allParams.find(function (param) {
          return param.name === name;
        });

        if (alreadySetBy) {
          // eslint-disable-next-line no-console
          console.debug("".concat(alreadySetBy.name, " - ").concat(alreadySetBy.value, " : already set by : ").concat(alreadySetBy.experienceName, " skipping ").concat(experience.experienceName));
          return undefined;
        }

        return {
          name: name,
          value: params[name],
          experienceName: experience.experienceName,
          impressionId: experience.impressionId || 'null',
          variantLabel: experience.variantLabel
        };
      });
      allParams = allParams.concat(experienceParams.filter(Boolean));
    }
  });
  return allParams;
};
var getFeatureValue = function getFeatureValue(mergedProperties, featureName) {
  var defaultReturn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var feature = mergedProperties.find(function (property) {
    return property.name === featureName;
  });
  return feature && feature.value || defaultReturn;
};
var getFlagValue = function getFlagValue(mergedProperties, featureName) {
  var defaultReturn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var featureValue = getFeatureValue(mergedProperties, featureName);
  return featureValue ? featureValue === 'on' : defaultReturn;
};
var getFlagSettings = function getFlagSettings(experiences) {
  var mergedProperties = getMergedProperties(experiences);
  var allFeatureFlagValues = Object.entries(experienceSettings_namespaceObject).reduce(function (acc, _ref3) {
    var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
        flagNameInCode = _ref4[0],
        _ref4$ = (0,slicedToArray/* default */.Z)(_ref4[1], 2),
        flagNameInMonetate = _ref4$[0],
        _ref4$$ = _ref4$[1],
        defaultValue = _ref4$$ === void 0 ? false : _ref4$$;

    return _objectSpread(_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, flagNameInCode, getFlagValue(mergedProperties, flagNameInMonetate, defaultValue)));
  }, {});
  return _objectSpread({}, allFeatureFlagValues);
};
var getVariantLabel = function getVariantLabel(_ref5) {
  var experiences = _ref5.experiences,
      monetateFlagName = _ref5.monetateFlagName;
  var matchingExperiences = getExperiences(experiences, monetateFlagName).map(function (exp) {
    return exp.variantLabel;
  });
  return matchingExperiences.length === 1 ? matchingExperiences[0] : '';
};
var ExperiencesProvider = function ExperiencesProvider(_ref6) {
  var monetateId = _ref6.monetateId,
      children = _ref6.children,
      experiencesConfig = _ref6.experiencesConfig;
  var experiences = (0,external_React_.useMemo)(function () {
    return experiencesConfig ? JSON.parse(experiencesConfig) : null;
  }, [experiencesConfig]);
  var mergedProperties = (0,external_React_.useMemo)(function () {
    return getMergedProperties(experiences);
  }, [experiences]);
  var getFeature = (0,external_React_.useCallback)(function (featureName) {
    var defaultReturn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return getFeatureValue(mergedProperties, featureName, defaultReturn);
  }, [mergedProperties]);
  var contextValue = (0,external_React_.useMemo)(function () {
    var flagSettings = getFlagSettings(experiences);

    var getImageOverwriteFeature = function getImageOverwriteFeature() {
      var nValue = getFeature('nValue');
      var postfix = getFeature('postfix') || '';
      return nValue && {
        nValue: nValue,
        postfix: postfix
      } || undefined;
    };

    var unsanitizedAtbBlockList = getFeature(ATB_BLOCKED_SKU_LIST) || '';
    var atbBlockList = unsanitizedAtbBlockList.split(',');
    var imageOverwriteFeature = getImageOverwriteFeature();
    return _objectSpread(_objectSpread({}, flagSettings), {}, {
      atbBlockList: atbBlockList,
      experiences: experiences,
      imageOverwriteFeature: imageOverwriteFeature,
      monetateId: monetateId
    });
  }, [getFeature, monetateId, experiences]);
  var listFeatures = (0,external_React_.useCallback)(function () {
    var tableLabel = "'%c\uD83D\uDE80 Monetate Feature Flags',\n    'color:green; font-size: 1.2em'";
    console.group(tableLabel);
    var keys = Object.keys(contextValue).filter(function (key) {
      return key.startsWith('is');
    });
    var features = keys.reduce(function (obj, key) {
      return _objectSpread(_objectSpread({}, obj), {}, (0,defineProperty/* default */.Z)({}, key, contextValue[key]));
    }, {});
    var featureFlags = {};
    mergedProperties.forEach(function (property) {
      featureFlags["".concat(property.name, " [").concat(property.value, "]")] = {
        'Experience Name [Split]': "".concat(property.experienceName, " [").concat(property.variantLabel || '100%', "]"),
        'Impression Id': property.impressionId
      };
    });
    var printExperience = {};

    if (experiences) {
      experiences.forEach(function (experience) {
        printExperience["".concat(experience.experienceName)] = {
          Split: experience.variantLabel || '100%',
          'Impression Id': experience.impressionId,
          Parameters: "".concat(experience.parameters ? JSON.stringify(experience.parameters) : '')
        };
      });
    }

    var enabled = Object.values(features).filter(Boolean).length;
    var label = "".concat(keys.length, " feature flags.");
    console.group(label);
    console.log("".concat(enabled, " feature flags are enabled."));
    console.log("".concat(keys.length - enabled, " are disabled."));

    if (Object.keys(features).length > 0) {
      console.table(features);
    } else {
      console.log('No features found');
    }

    console.groupEnd(label);
    label = "%c\uD83E\uDDEA Experiments used to set flags";
    console.group(label, 'color:orange; font-size: 1.2em');

    if (Object.keys(featureFlags).length > 0) {
      console.table(featureFlags);
    } else {
      console.log('No experiments found');
    }

    console.groupEnd(label);
    label = "%c\uD83E\uDDEA All Experiments on this page";
    console.group(label, 'color:turquoise; font-size: 1.2em');

    if (Object.keys(printExperience).length > 0) {
      console.table(printExperience);
    } else {
      console.log('No experiments found');
    }

    console.groupEnd(label);
    console.groupEnd(tableLabel);
    return '';
  }, [contextValue, experiences, mergedProperties]);
  (0,external_React_.useEffect)(function () {
    debug("attaching \"window.listFeatures()\"");
    window.listFeatures = listFeatures;
    return function () {
      delete window.listFeatures;
    };
  }, [listFeatures]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ExperiencesContext.Provider, {
    value: contextValue,
    children: children
  });
};

/***/ }),

/***/ 47550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ facets_Facets; }
});

// UNUSED EXPORTS: Facets

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: external "React"
var external_React_ = __webpack_require__(37667);
var external_React_default = /*#__PURE__*/__webpack_require__.n(external_React_);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/elements/button/Button.js
var Button = __webpack_require__(73087);
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Plus24PxOutlined.js
var Plus24PxOutlined = __webpack_require__(65649);
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Minus24PxOutlined.js
var Minus24PxOutlined = __webpack_require__(89687);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/components/accordion/Accordion.js
var Accordion = __webpack_require__(53171);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./src/utils/types/facet.js
/* istanbul ignore file */

/* harmony default export */ var facet = ((0,prop_types.shape)({
  dimensionName: prop_types.string,
  label: prop_types.string,
  type: prop_types.string,
  tooltip: prop_types.string,
  values: (0,prop_types.arrayOf)((0,prop_types.shape)({
    name: prop_types.string,
    value: prop_types.string,
    quantity: prop_types.number,
    selected: prop_types.bool
  }))
}));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(20784);
// EXTERNAL MODULE: ./src/components/stateful-link/StatefulLink.jsx
var StatefulLink = __webpack_require__(85852);
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/components/checkbox/Checkbox.js
var Checkbox = __webpack_require__(4990);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/facets/facet-item/checkbox-facet/CheckboxFacet.jsx





var CheckboxFacet = function CheckboxFacet(_ref) {
  var value = _ref.value,
      disabled = _ref.disabled,
      ariaLabel = _ref.ariaLabel,
      name = _ref.name,
      id = _ref.id;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox["default"], {
    label: "".concat(value.label, " (").concat(value.quantity, ")"),
    ariaLabel: ariaLabel,
    isControlled: true,
    name: name,
    id: id,
    checked: value.selected,
    disabled: disabled,
    isRealFormControl: false
  });
};

CheckboxFacet.defaultProps = {
  value: {},
  disabled: false,
  ariaLabel: undefined
};
/* harmony default export */ var checkbox_facet_CheckboxFacet = (/*#__PURE__*/(0,external_React_.memo)(CheckboxFacet));
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Tick24PxOutlined.js
var Tick24PxOutlined = __webpack_require__(77874);
// EXTERNAL MODULE: ./src/components/facets/facet-item/block-facet/BlockFacet.module.scss
var BlockFacet_module = __webpack_require__(86240);
var BlockFacet_module_default = /*#__PURE__*/__webpack_require__.n(BlockFacet_module);
;// CONCATENATED MODULE: ./src/components/facets/facet-item/block-facet/BlockFacet.jsx









var BlockFacet = function BlockFacet(_ref) {
  var _classnames;

  var value = _ref.value,
      disabled = _ref.disabled,
      showColourSwatch = _ref.showColourSwatch,
      mobile = _ref.mobile,
      ariaLabel = _ref.ariaLabel;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()((BlockFacet_module_default()).container, (_classnames = {}, (0,defineProperty/* default */.Z)(_classnames, (BlockFacet_module_default()).container__selected, value.selected), (0,defineProperty/* default */.Z)(_classnames, (BlockFacet_module_default()).disabled, disabled), _classnames)),
    "data-test-swatch": value.label.toLowerCase(),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (BlockFacet_module_default()).info,
      children: [showColourSwatch ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: classnames_default()((BlockFacet_module_default()).swatch, (BlockFacet_module_default())[value.label.toLowerCase()])
      }) : '', /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        "aria-label": ariaLabel,
        children: [value.label, " (", value.quantity, ")"]
      })]
    }), mobile && value.selected && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (BlockFacet_module_default()).tick,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tick24PxOutlined["default"], {})
    })]
  });
};

BlockFacet.defaultProps = {
  ariaLabel: undefined,
  disabled: false,
  mobile: false,
  showColourSwatch: false,
  value: {}
};
/* harmony default export */ var block_facet_BlockFacet = (/*#__PURE__*/(0,external_React_.memo)(BlockFacet));
// EXTERNAL MODULE: ./src/components/facets/facet-item/department-item/DepartmentItem.module.scss
var DepartmentItem_module = __webpack_require__(48906);
var DepartmentItem_module_default = /*#__PURE__*/__webpack_require__.n(DepartmentItem_module);
;// CONCATENATED MODULE: ./src/components/facets/facet-item/department-item/DepartmentItem.jsx




var DepartmentItem = function DepartmentItem(_ref) {
  var value = _ref.value;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
    className: (DepartmentItem_module_default()).item,
    children: [value.label, " (", value.quantity, ")"]
  });
};

/* harmony default export */ var department_item_DepartmentItem = (DepartmentItem);
// EXTERNAL MODULE: ./src/components/facets/facet-item/FacetItem.module.scss
var FacetItem_module = __webpack_require__(12299);
var FacetItem_module_default = /*#__PURE__*/__webpack_require__.n(FacetItem_module);
// EXTERNAL MODULE: ./src/components/facets/facet-context/index.jsx
var facet_context = __webpack_require__(22418);
// EXTERNAL MODULE: ./src/utils/index.js
var utils = __webpack_require__(68243);
;// CONCATENATED MODULE: ./src/components/facets/facet-item/FacetItem.jsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var FacetItem = function FacetItem(props) {
  var _classnames, _classnames2;

  var style = props.style,
      value = props.value,
      dimensionName = props.dimensionName,
      showColourFilterSwatches = props.showColourFilterSwatches,
      _props$initialDisable = props.initialDisabled,
      initialDisabled = _props$initialDisable === void 0 ? false : _props$initialDisable,
      mobile = props.mobile,
      _props$isFilterDrawer = props.isFilterDrawer,
      isFilterDrawer = _props$isFilterDrawer === void 0 ? false : _props$isFilterDrawer,
      _props$onFacetClicked = props.onFacetClicked,
      onFacetClicked = _props$onFacetClicked === void 0 ? function () {} : _props$onFacetClicked,
      _props$listItem = props.listItem,
      listItem = _props$listItem === void 0 ? true : _props$listItem,
      component = props.component,
      className = props.className,
      dataInd = props['data-ind'],
      _props$hidden = props.hidden,
      hidden = _props$hidden === void 0 ? false : _props$hidden,
      _props$last = props.last,
      last = _props$last === void 0 ? false : _props$last,
      _props$divider = props.divider,
      divider = _props$divider === void 0 ? false : _props$divider,
      rel = props.rel;
  var facetId = value.facetId,
      _value$facetName = value.facetName,
      facetName = _value$facetName === void 0 ? '' : _value$facetName,
      facetType = value.facetType,
      selected = value.selected,
      label = value.label;
  var router = (0,next_router.useRouter)();

  var _useFacetContext = (0,facet_context/* useFacetContext */.gv)(),
      isMobile = _useFacetContext.isMobile;

  var triggerAnalyticsEvent = (0,facet_context/* useFacetAnalyticsEvent */.NI)(props);

  var _useState = (0,external_React_.useState)(initialDisabled),
      disabled = _useState[0],
      setDisabled = _useState[1];

  var scrollToTopOfGrid = function scrollToTopOfGrid() {
    var body = document.getElementById('js-plp-body');
    if (body) body.scrollIntoView();
    router.events.off('routeChangeComplete', scrollToTopOfGrid);
  };

  var handleClick = function handleClick() {
    setDisabled(true);

    if (!isMobile) {
      onFacetClicked();
    }

    triggerAnalyticsEvent();
    router.events.on('routeChangeComplete', scrollToTopOfGrid);
  };

  var showColourSwatch = showColourFilterSwatches && (dimensionName === 'skus.basicColor' || dimensionName === 'childSKUs.basicColor');
  (0,external_React_.useEffect)(function () {
    if (disabled && selected) {
      setDisabled(false);
    }
  }, [disabled, selected]);
  var Component = checkbox_facet_CheckboxFacet;

  if (!mobile && dimensionName === constants/* default.DEPARTMENT_DIMENSION_NAME */.Z.DEPARTMENT_DIMENSION_NAME) {
    Component = department_item_DepartmentItem;
  }

  if (showColourSwatch || mobile) {
    Component = block_facet_BlockFacet;
  }

  if (component) {
    Component = component;
  }

  var queryParams = value.query;
  var queryOpts = {
    filter: (0,StatefulLink/* defaultFilter */.f9)()
  };

  if (typeof queryParams === 'string') {
    var _queryOpts$filter;

    queryParams = lib_default().parse(queryParams);

    (_queryOpts$filter = queryOpts.filter).push.apply(_queryOpts$filter, (0,toConsumableArray/* default */.Z)(Object.keys(queryParams)));
  }

  var ariaLabel = (0,utils/* getAriaTextIfPriceRange */.DU)(label);

  var sanitiseString = function sanitiseString(string) {
    return string.replace(/\s/g, '-');
  };

  var facetNameLabel = facetName ? sanitiseString(facetName) + '-' : '';
  var labelId = facetNameLabel + sanitiseString(label);
  var drawerLabel = isFilterDrawer ? 'drawer-' : '';

  var link = /*#__PURE__*/(0,jsx_runtime.jsx)(StatefulLink/* default */.ZP, {
    facetId: facetId,
    facetType: facetType,
    query: _objectSpread(_objectSpread({}, queryParams), {}, {
      page: undefined
    }),
    queryOpts: queryOpts,
    className: classnames_default()(className || (FacetItem_module_default()).link, (_classnames = {}, (0,defineProperty/* default */.Z)(_classnames, (FacetItem_module_default()).active, selected), (0,defineProperty/* default */.Z)(_classnames, (FacetItem_module_default()).disabled, disabled), _classnames)),
    onClick: handleClick,
    "aria-checked": selected,
    disabled: disabled,
    "data-test": label,
    role: "checkbox",
    "data-ind": dataInd,
    rel: rel,
    scroll: false,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      id: drawerLabel + labelId,
      name: labelId,
      value: value,
      ariaLabel: ariaLabel,
      dimensionName: dimensionName,
      disabled: disabled,
      mobile: true,
      showColourSwatch: showColourSwatch
    })
  });

  return listItem ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    style: style,
    className: classnames_default()((FacetItem_module_default()).listItem, (_classnames2 = {}, (0,defineProperty/* default */.Z)(_classnames2, (FacetItem_module_default()).nopadding, mobile), (0,defineProperty/* default */.Z)(_classnames2, (FacetItem_module_default()).bordered, showColourSwatch), (0,defineProperty/* default */.Z)(_classnames2, (FacetItem_module_default()).hidden, hidden), (0,defineProperty/* default */.Z)(_classnames2, (FacetItem_module_default()).last, last), (0,defineProperty/* default */.Z)(_classnames2, (FacetItem_module_default()).divider, divider), _classnames2)),
    visible: hidden ? 'false' : 'true',
    children: link
  }) : link;
};

/* harmony default export */ var facet_item_FacetItem = (FacetItem);
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/elements/input/Input.js
var Input = __webpack_require__(99556);
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Close24PxOutlined.js
var Close24PxOutlined = __webpack_require__(88823);
// EXTERNAL MODULE: ./node_modules/@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Search24PxOutlined.js
var Search24PxOutlined = __webpack_require__(18669);
// EXTERNAL MODULE: ./src/components/facets/facet-search/FacetSearch.module.scss
var FacetSearch_module = __webpack_require__(82189);
var FacetSearch_module_default = /*#__PURE__*/__webpack_require__.n(FacetSearch_module);
;// CONCATENATED MODULE: ./src/components/facets/facet-search/FacetSearch.jsx










var FacetSearch = function FacetSearch(_ref) {
  var _classnames2;

  var label = _ref.label,
      search = _ref.search,
      onClear = _ref.onClear,
      onSearch = _ref.onSearch,
      isFilterDrawer = _ref.isFilterDrawer;
  var hasSearchIconVisible = search.length === 0;
  var hasClearButtonVisible = search.length > 1;

  var handleSearch = function handleSearch(evt) {
    var newValue = evt.target.value;
    onSearch(newValue);
  };

  var handleClear = function handleClear() {
    onClear();
  };

  var id = "facet-search-".concat(label);
  var drawerLabel = isFilterDrawer ? 'drawer-' : '';
  var placeholderText = "Search ".concat(label);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()((FacetSearch_module_default()).container, (0,defineProperty/* default */.Z)({}, (FacetSearch_module_default()).filterDrawer, isFilterDrawer)),
    "data-test": id,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      htmlFor: id,
      className: "visuallyHidden",
      children: placeholderText
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input["default"], {
      className: classnames_default()((_classnames2 = {}, (0,defineProperty/* default */.Z)(_classnames2, (FacetSearch_module_default())["input--search-icon-showing"], hasSearchIconVisible), (0,defineProperty/* default */.Z)(_classnames2, (FacetSearch_module_default())["input--clear-button-showing"], hasClearButtonVisible), _classnames2)),
      id: drawerLabel + id,
      name: id,
      value: search,
      placeholder: placeholderText,
      onChange: handleSearch,
      autoComplete: "off"
    }), hasSearchIconVisible && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (FacetSearch_module_default()).searchIcon,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Search24PxOutlined/* default */.ZP, {})
    }), hasClearButtonVisible && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      onClick: handleClear,
      className: (FacetSearch_module_default()).clear,
      "aria-label": "Reset search",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Close24PxOutlined["default"], {})
    })]
  });
};

FacetSearch.defaultProps = {
  isFilterDrawer: false,
  label: '',
  onClear: function onClear() {},
  onSearch: function onSearch() {},
  search: ''
};
/* harmony default export */ var facet_search_FacetSearch = (/*#__PURE__*/(0,external_React_.memo)(FacetSearch));
// EXTERNAL MODULE: ./node_modules/memoize-one/dist/memoize-one.esm.js
var memoize_one_esm = __webpack_require__(30845);
;// CONCATENATED MODULE: ./src/components/facets/facet-accordion/selectors/filterValues.js

/* harmony default export */ var filterValues = ((0,memoize_one_esm/* default */.Z)(function (values, search) {
  if (search) {
    return values ? {
      numberOfOwnBrandItems: 0,
      items: values.filter(function (value) {
        return value.label.toLowerCase().indexOf(search.toLowerCase()) > -1;
      })
    } : {
      numberOfOwnBrandItems: 0,
      items: []
    };
  }

  return values ? {
    numberOfOwnBrandItems: values.filter(function (value) {
      return value.isBoosted === 'true';
    }).length,
    items: values
  } : {
    numberOfOwnBrandItems: 0,
    items: []
  };
}));
;// CONCATENATED MODULE: ./src/components/facets/facet-accordion/selectors/selectedValues.js
var getSelectedValues = function getSelectedValues(values) {
  return values.filter(function (value) {
    return value.selected === true;
  }).map(function (_ref) {
    var label = _ref.label,
        qty = _ref.qty;
    return {
      label: label,
      qty: qty
    };
  });
};
// EXTERNAL MODULE: ./src/components/facets/facet-accordion/FacetAccordion.module.scss
var FacetAccordion_module = __webpack_require__(56605);
var FacetAccordion_module_default = /*#__PURE__*/__webpack_require__.n(FacetAccordion_module);
;// CONCATENATED MODULE: ./src/components/facets/facet-accordion/FacetAccordion.jsx














var SEARCH_LENGTH = 21;
var INITIAL_NUMBER_TO_SHOW = 8;
var MAX_NUMBER_TO_SHOW_BEFORE_PROMPTING = 10;

var FacetAccordion = function FacetAccordion(_ref) {
  var _ref$facet = _ref.facet,
      facet = _ref$facet === void 0 ? {} : _ref$facet,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? '' : _ref$href,
      _ref$initialSearch = _ref.initialSearch,
      initialSearch = _ref$initialSearch === void 0 ? '' : _ref$initialSearch,
      _ref$isFilterDrawer = _ref.isFilterDrawer,
      isFilterDrawer = _ref$isFilterDrawer === void 0 ? false : _ref$isFilterDrawer,
      _ref$isShown = _ref.isShown,
      isShown = _ref$isShown === void 0 ? true : _ref$isShown,
      _ref$opened = _ref.opened,
      opened = _ref$opened === void 0 ? false : _ref$opened,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 1 : _ref$position,
      _ref$showColourFilter = _ref.showColourFilterSwatches,
      showColourFilterSwatches = _ref$showColourFilter === void 0 ? false : _ref$showColourFilter;

  var _useState = (0,external_React_.useState)(initialSearch),
      search = _useState[0],
      setSearch = _useState[1];

  var _useState2 = (0,external_React_.useState)(false),
      isFacetListExpanded = _useState2[0],
      setIsFacetListExpanded = _useState2[1];

  var label = facet.label,
      dimensionName = facet.dimensionName,
      filterTypes = facet.filterTypes;
  var isFacetListSearchable = (0,external_React_.useMemo)(function () {
    return facet.values.length >= SEARCH_LENGTH;
  }, [facet.values.length]);

  var _useMemo = (0,external_React_.useMemo)(function () {
    return filterValues(facet.values, search);
  }, [facet.values, search]),
      numberOfOwnBrandItems = _useMemo.numberOfOwnBrandItems,
      items = _useMemo.items;

  var itemsToDisplay = items;
  var selectedItems = getSelectedValues(facet.values);
  var numberOfValuesToShow = itemsToDisplay.length > MAX_NUMBER_TO_SHOW_BEFORE_PROMPTING && !isFacetListExpanded ? INITIAL_NUMBER_TO_SHOW : itemsToDisplay.length;

  var handleSearch = function handleSearch(value) {
    setSearch(value);
  };

  var handleClear = function handleClear() {
    setSearch('');
  };

  var handleAccordionToggle = function handleAccordionToggle() {};

  var toggleShowMore = function toggleShowMore(e) {
    // Stop this event propagating to the parent Accordion so that the click does not get handled there
    // (which would lead to the search value being cleared)
    e.stopPropagation();
    setIsFacetListExpanded(!isFacetListExpanded);
  };

  var numberOfHiddenValues = itemsToDisplay.length > MAX_NUMBER_TO_SHOW_BEFORE_PROMPTING ? itemsToDisplay.length - INITIAL_NUMBER_TO_SHOW : 0;
  var facetLabel = "".concat(isFilterDrawer ? 'drawer-' : '', "accordion-summary-").concat(label.replace(/ /g, '-').toLowerCase());
  var isShowMoreOrFewerVisible = itemsToDisplay.length > MAX_NUMBER_TO_SHOW_BEFORE_PROMPTING;
  var facetRel = (filterTypes === null || filterTypes === void 0 ? void 0 : filterTypes.indexOf('Seo')) >= 0 ? null : 'nofollow';

  var showMoreOrFewerButton = function showMoreOrFewerButton() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Button.UnderlinedButton, {
      className: (FacetAccordion_module_default()).showMoreFacetValues,
      onClick: toggleShowMore,
      "data-test": "show-".concat(isFacetListExpanded ? 'fewer' : 'more', "-button"),
      children: isFacetListExpanded ? 'Show fewer' : "Show ".concat(numberOfHiddenValues, " more")
    });
  };

  var showCollapsedFilterSummary = selectedItems.length > 0;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion/* default */.Z, {
      animated: false,
      onClick: handleAccordionToggle,
      "data-test": "accordion-".concat(label.toLowerCase()),
      "data-label": label,
      "data-test2": "position".concat(position),
      label: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
          id: facetLabel,
          children: label
        }), showCollapsedFilterSummary && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (FacetAccordion_module_default()).collapsedSummary,
          children: selectedItems.map(function (value, index) {
            return "".concat(index > 0 ? ', ' : '').concat(value.label, " (").concat(value.qty, ")");
          })
        })]
      }),
      open: opened,
      size: "S",
      className: classnames_default()((FacetAccordion_module_default()).accordion, (0,defineProperty/* default */.Z)({}, (FacetAccordion_module_default())["accordion--is-hidden"], !isShown)),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        "aria-labelledby": facetLabel,
        role: "group",
        children: [isFacetListSearchable && /*#__PURE__*/(0,jsx_runtime.jsx)(facet_search_FacetSearch, {
          label: label,
          search: search,
          onSearch: handleSearch,
          onClear: handleClear,
          isFilterDrawer: isFilterDrawer
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
          className: (FacetAccordion_module_default()).list,
          children: [itemsToDisplay.length === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: (FacetAccordion_module_default()).noResults,
              "data-test": "facet-search-no-results",
              children: ["No results were found for ", "'".concat(search, "'"), ". Please try another search."]
            })
          }), itemsToDisplay.map(function (value, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)((external_React_default()).Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(facet_item_FacetItem, {
                href: href,
                value: value,
                dimensionName: dimensionName,
                showColourFilterSwatches: showColourFilterSwatches,
                onFacetClicked: handleClear,
                hidden: index >= numberOfValuesToShow ? true : undefined,
                isFilterDrawer: isFilterDrawer,
                last: index + 1 === numberOfValuesToShow || index === INITIAL_NUMBER_TO_SHOW - 1 && isFacetListSearchable && isShowMoreOrFewerVisible && isFacetListExpanded,
                divider: index === numberOfOwnBrandItems - 1,
                rel: facetRel
              }, value.name), index === INITIAL_NUMBER_TO_SHOW - 1 && isFacetListSearchable && isShowMoreOrFewerVisible && isFacetListExpanded && showMoreOrFewerButton()]
            }, value.name);
          })]
        }), isShowMoreOrFewerVisible && showMoreOrFewerButton()]
      })
    }, label)
  });
};

/* harmony default export */ var facet_accordion_FacetAccordion = (FacetAccordion);
// EXTERNAL MODULE: ./src/components/oos-toggle/oos-toggle.module.scss
var oos_toggle_module = __webpack_require__(75215);
var oos_toggle_module_default = /*#__PURE__*/__webpack_require__.n(oos_toggle_module);
;// CONCATENATED MODULE: ./src/components/oos-toggle/OosToggle.tsx







var OosToggle = function OosToggle(_ref) {
  var checked = _ref.checked;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
    className: classnames_default()((oos_toggle_module_default())["oos-toggle"], (0,defineProperty/* default */.Z)({}, (oos_toggle_module_default())["oos-toggle--checked"], checked)),
    "aria-hidden": "true",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: classnames_default()((oos_toggle_module_default())["oos-toggle__label"], (0,defineProperty/* default */.Z)({}, (oos_toggle_module_default())["oos-toggle__label--active"], checked)),
      children: "Show"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: classnames_default()((oos_toggle_module_default())["oos-toggle__label"], (0,defineProperty/* default */.Z)({}, (oos_toggle_module_default())["oos-toggle__label--active"], !checked)),
      children: "Hide"
    })]
  });
};

/* harmony default export */ var oos_toggle_OosToggle = (OosToggle);
// EXTERNAL MODULE: ./src/components/facets/out-of-stock-filter/OutOfStockFilter.module.scss
var OutOfStockFilter_module = __webpack_require__(2974);
var OutOfStockFilter_module_default = /*#__PURE__*/__webpack_require__.n(OutOfStockFilter_module);
;// CONCATENATED MODULE: ./src/components/facets/out-of-stock-filter/OutOfStockFilter.jsx








var OutOfStockFilter = function OutOfStockFilter(_ref) {
  var showHideOutOfStockFilter = _ref.showHideOutOfStockFilter,
      _ref$outOfStockInfo = _ref.outOfStockInfo,
      outOfStockInfo = _ref$outOfStockInfo === void 0 ? {} : _ref$outOfStockInfo;
  var selected = outOfStockInfo.selected,
      facetId = outOfStockInfo.facetId,
      trackingId = outOfStockInfo.trackingId;
  var triggerAnalyticsEvent = (0,facet_context/* useFacetAnalyticsEvent */.NI)({
    value: {
      facetName: 'stock availability',
      label: 'show in stock items only',
      selected: selected,
      trackingId: trackingId
    }
  });

  var triggerEvents = function triggerEvents() {
    triggerAnalyticsEvent();
  };

  if (!showHideOutOfStockFilter) {
    return '';
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)((external_React_default()).Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StatefulLink/* default */.ZP, {
      onClick: function onClick() {
        return triggerEvents();
      },
      facetId: facetId,
      query: {
        page: undefined
      },
      queryOpts: {
        filter: (0,StatefulLink/* facetsFilter */.xK)()
      },
      className: (OutOfStockFilter_module_default()).container,
      "data-test": "oos-switch",
      tabIndex: 0,
      rel: "nofollow",
      role: "switch",
      "aria-checked": !selected,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (OutOfStockFilter_module_default()).label,
        "data-test": "facets-hide-out-of-stock",
        children: "Out of stock items"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(oos_toggle_OosToggle, {
        checked: !selected
      })]
    })
  });
};

/* harmony default export */ var out_of_stock_filter_OutOfStockFilter = (OutOfStockFilter);
// EXTERNAL MODULE: ./src/components/facets/applied-filters/AppliedFilters.jsx
var AppliedFilters = __webpack_require__(26180);
// EXTERNAL MODULE: ./src/components/grid/GridColumn.jsx
var GridColumn = __webpack_require__(59376);
// EXTERNAL MODULE: ./src/context/FacetContext.jsx
var FacetContext = __webpack_require__(22030);
// EXTERNAL MODULE: ./src/components/facets/Facets.module.scss
var Facets_module = __webpack_require__(71784);
var Facets_module_default = /*#__PURE__*/__webpack_require__.n(Facets_module);
// EXTERNAL MODULE: ./src/components/analytics/analyticsEvents.js
var analyticsEvents = __webpack_require__(85576);
// EXTERNAL MODULE: ./src/components/facets/single-item-facet/SingleItemFacet.module.scss
var SingleItemFacet_module = __webpack_require__(17585);
var SingleItemFacet_module_default = /*#__PURE__*/__webpack_require__.n(SingleItemFacet_module);
;// CONCATENATED MODULE: ./src/components/facets/single-item-facet/SingleItemFacet.jsx







var SingleItemFacet = function SingleItemFacet(_ref) {
  var facet = _ref.facet,
      mobile = _ref.mobile,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? '/' : _ref$href;

  var _ref2 = facet || {},
      values = _ref2.values,
      show = _ref2.show;

  if (!show || !values || values.length === 0) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
    className: classnames_default()((SingleItemFacet_module_default()).content, (0,defineProperty/* default */.Z)({}, (SingleItemFacet_module_default()).contentMobile, mobile)),
    children: values.map(function (value) {
      var facetId = value.facetId;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(facet_item_FacetItem, {
        href: href,
        mobile: mobile,
        value: value,
        dimensionName: "singleItem"
      }, facetId);
    })
  });
};

/* harmony default export */ var single_item_facet_SingleItemFacet = (SingleItemFacet);
// EXTERNAL MODULE: ./src/components/experiences/Experiences.jsx + 1 modules
var Experiences = __webpack_require__(91576);
// EXTERNAL MODULE: ./src/context/CompareContext.tsx + 1 modules
var CompareContext = __webpack_require__(13525);
;// CONCATENATED MODULE: ./src/components/facets/Facets.jsx





 // eslint-disable-next-line import/no-unresolved
















var _getConfig = config_default()(),
    features = _getConfig.publicRuntimeConfig;

var Facets_INITIAL_NUMBER_TO_SHOW = 5;
var Facets_MAX_NUMBER_TO_SHOW_BEFORE_PROMPTING = 7;
var Facets = function Facets(_ref) {
  var _compare$products, _classNames, _classNames2;

  var isMobile = _ref.isMobile,
      isFilterDrawer = _ref.isFilterDrawer,
      isPrimaryFacetMainFacet = _ref.isPrimaryFacetMainFacet;

  var _useState = (0,external_React_.useState)(false),
      isFacetListExpanded = _useState[0],
      setIsFacetListExpanded = _useState[1];

  var _useExperiencesContex = (0,Experiences/* useExperiencesContext */.Xe)(),
      isFacetLimitOn = _useExperiencesContex.isFacetLimitOn,
      isWiderScrollbarFlagOn = _useExperiencesContex.isWiderScrollbarFlagOn;

  var numberOfOpenFacetAccordions = features.numberOfOpenFacetAccordions,
      numberOfFiltersToShowClear = features.numberOfFiltersToShowClear;

  var _useFacetContext = (0,FacetContext/* useFacetContext */.gv)(),
      applied = _useFacetContext.applied,
      baseFacetId = _useFacetContext.baseFacetId,
      facets = _useFacetContext.facets,
      outOfStockInfo = _useFacetContext.outOfStockInfo,
      showHideOutOfStockFilter = _useFacetContext.showHideOutOfStockFilter,
      singleItemFacet = _useFacetContext.singleItemFacet,
      primaryFacet = _useFacetContext.primaryFacet;

  var sharedFacetContext = {
    filterCombination: applied.filterCombination,
    filterCombinationNvals: applied.filterCombinationNvals,
    isMobile: isMobile
  };
  var compare = (0,CompareContext/* useCompareContext */.EN)();
  var isCompareBarOpen = ((_compare$products = compare.products) === null || _compare$products === void 0 ? void 0 : _compare$products.length) > 0;
  var facetsToShow = facets.filter(function (facet) {
    return facet.show;
  });
  var isShowMoreOrFewerVisible = facetsToShow.length > Facets_MAX_NUMBER_TO_SHOW_BEFORE_PROMPTING;
  var maxFacetsToDisplay = !isMobile && isFacetLimitOn && isShowMoreOrFewerVisible && !isFacetListExpanded ? Facets_INITIAL_NUMBER_TO_SHOW : facetsToShow.length;

  var isAccordionOpen = function isAccordionOpen(index, facetName) {
    if (!isPrimaryFacetMainFacet) {
      return index < numberOfOpenFacetAccordions;
    }

    return facetName === (primaryFacet === null || primaryFacet === void 0 ? void 0 : primaryFacet.name);
  };

  var toggleShowMore = function toggleShowMore(toggleValue) {
    (0,analyticsEvents/* dispatchImmediateAnalyticsEvent */.gM)(analyticsEvents/* FILTER_INTERACTION */.wQ, {
      type: toggleValue ? 'show more' : 'show fewer'
    });
    setIsFacetListExpanded(toggleValue);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(facet_context/* Context.Provider */._y.Provider, {
    value: sharedFacetContext,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(GridColumn/* default */.Z, {
      className: classnames_default()((Facets_module_default()).plp__facets, (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, (Facets_module_default())["plp__facets--desktop"], !isMobile), (0,defineProperty/* default */.Z)(_classNames, (Facets_module_default())["plp__facets--compare-open"], isCompareBarOpen), (0,defineProperty/* default */.Z)(_classNames, (Facets_module_default())["plp__facets--wider-scrollbar"], isWiderScrollbarFlagOn), _classNames)),
      colLg: isMobile ? undefined : 3,
      colXl: 3,
      "data-test": "facet-container",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("nav", {
        "aria-label": "Filters",
        "data-test": "component-facets",
        className: classnames_default()((Facets_module_default()).facets, (_classNames2 = {}, (0,defineProperty/* default */.Z)(_classNames2, (Facets_module_default())["facets--compare-open"], isCompareBarOpen), (0,defineProperty/* default */.Z)(_classNames2, (Facets_module_default())["facets--mobile"], isMobile), (0,defineProperty/* default */.Z)(_classNames2, (Facets_module_default())["facets--wider-scrollbar"], isWiderScrollbarFlagOn), _classNames2)),
        children: [!isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "visuallyHidden",
          children: "Filters"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(AppliedFilters/* default */.Z, {
          applied: applied,
          baseFacetId: baseFacetId,
          numberOfFiltersToShowClear: numberOfFiltersToShowClear,
          showClearFiltersLink: !isMobile,
          mobile: isMobile,
          isFilterDrawer: isFilterDrawer
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(out_of_stock_filter_OutOfStockFilter, {
          showHideOutOfStockFilter: showHideOutOfStockFilter,
          outOfStockInfo: outOfStockInfo
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(single_item_facet_SingleItemFacet, {
          facet: singleItemFacet
        }), facetsToShow.map(function (facet, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(facet_accordion_FacetAccordion, {
            href: "/",
            opened: isAccordionOpen(index, facet.name),
            facet: facet,
            showColourFilterSwatches: true,
            isFilterDrawer: isFilterDrawer,
            position: index + 1,
            isShown: isMobile || !isFacetLimitOn || isFacetListExpanded || index < maxFacetsToDisplay
          }, facet.dimensionName);
        }), !isMobile && isFacetLimitOn && isShowMoreOrFewerVisible && /*#__PURE__*/(0,jsx_runtime.jsx)(Button.TertiaryButton, {
          "data-test": "toggle-more-facets",
          onClick: function onClick() {
            return toggleShowMore(!isFacetListExpanded);
          },
          className: (Facets_module_default())["toggle-more-facets"],
          small: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: (Facets_module_default()).showMoreButton,
            children: [isFacetListExpanded ? /*#__PURE__*/(0,jsx_runtime.jsx)(Minus24PxOutlined["default"], {
              className: (Facets_module_default()).marginRight
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Plus24PxOutlined["default"], {
              className: (Facets_module_default()).marginRight
            }), "Show ", isFacetListExpanded ? 'fewer' : 'more', " filters"]
          })
        })]
      })
    })
  });
};
Facets.defaultProps = {
  isMobile: false,
  isFilterDrawer: false,
  isPrimaryFacetMainFacet: false
};
/* harmony default export */ var facets_Facets = (Facets);

/***/ }),

/***/ 26180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppliedFilter */
/* harmony import */ var _builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(27812);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _JohnLewisPartnership_jl_design_system_elements_icons_jb_Close24PxOutlined__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88823);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57557);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _clear_filters_ClearFilters__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73018);
/* harmony import */ var _AppliedFilters_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(25577);
/* harmony import */ var _AppliedFilters_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_AppliedFilters_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _stateful_link_StatefulLink__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85852);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68243);
/* harmony import */ var _facet_context__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22418);
/* harmony import */ var _context_SearchContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80348);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


// eslint-disable-next-line import/no-unresolved












var AppliedFilter = function AppliedFilter(_ref) {
  var query = _ref.query,
      label = _ref.label,
      name = _ref.name,
      facetName = _ref.facetName,
      facetId = _ref.facetId,
      trackingId = _ref.trackingId;
  var triggerAnalyticsEvent = (0,_facet_context__WEBPACK_IMPORTED_MODULE_9__/* .useFacetAnalyticsEvent */ .NI)({
    value: {
      facetName: facetName,
      label: label,
      name: name,
      selected: true,
      trackingId: trackingId
    }
  });

  var triggerEvents = function triggerEvents() {
    triggerAnalyticsEvent();
  };

  var queryParams = query;
  var queryOpts = {
    filter: (0,_stateful_link_StatefulLink__WEBPACK_IMPORTED_MODULE_7__/* .defaultFilter */ .f9)()
  };

  if (typeof queryParams === 'string') {
    var _queryOpts$filter;

    queryParams = qs__WEBPACK_IMPORTED_MODULE_4___default().parse(queryParams);

    (_queryOpts$filter = queryOpts.filter).push.apply(_queryOpts$filter, (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(Object.keys(queryParams)));
  }

  var ariaTextForPriceRange = (0,_utils_index__WEBPACK_IMPORTED_MODULE_8__/* .getAriaTextIfPriceRange */ .DU)(name);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_stateful_link_StatefulLink__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
    query: _objectSpread(_objectSpread({}, queryParams), {}, {
      page: undefined
    }),
    queryOpts: queryOpts,
    facetId: facetId,
    className: (_AppliedFilters_module_scss__WEBPACK_IMPORTED_MODULE_13___default().filterLink),
    onClick: function onClick() {
      return triggerEvents();
    },
    "aria-label": "'".concat(ariaTextForPriceRange || name, "' filter Remove"),
    "data-test": "applied-filter__link",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
      className: (_AppliedFilters_module_scss__WEBPACK_IMPORTED_MODULE_13___default().filterLinkText),
      children: name
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: (_AppliedFilters_module_scss__WEBPACK_IMPORTED_MODULE_13___default().filterLinkIcon),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_JohnLewisPartnership_jl_design_system_elements_icons_jb_Close24PxOutlined__WEBPACK_IMPORTED_MODULE_2__["default"], {
        title: "Remove filter"
      })
    })]
  });
};

var AppliedFilters = function AppliedFilters(_ref2) {
  var _ref3, _classnames;

  var baseFacetId = _ref2.baseFacetId,
      className = _ref2.className,
      showClearFiltersLink = _ref2.showClearFiltersLink,
      numberOfFiltersToShowClear = _ref2.numberOfFiltersToShowClear,
      mobile = _ref2.mobile,
      grid = _ref2.grid,
      isFilterDrawer = _ref2.isFilterDrawer;

  var _useSearchContext = (0,_context_SearchContext__WEBPACK_IMPORTED_MODULE_10__/* .useSearchContext */ .AB)(),
      filter = _useSearchContext.filter;

  var filteredFilters = lodash_omit__WEBPACK_IMPORTED_MODULE_3___default()(filter, ['outOfStock', 'childSKUs.hideOutOfStock']);

  if (!filteredFilters || !Object.keys(filteredFilters).length || mobile && isFilterDrawer) {
    return '';
  }

  var numberOfFilters = Object.keys(filteredFilters).reduce(function (total, next) {
    return total + filteredFilters[next].length;
  }, 0);
  var showClearFilters = numberOfFiltersToShowClear <= numberOfFilters;
  Object.values(filteredFilters).forEach(function (filters) {
    return filters.sort(function (filterA, filterB) {
      return filterA.name.toLowerCase().localeCompare(filterB.name.toLowerCase());
    });
  });

  var listOfAppliedFilters = (_ref3 = []).concat.apply(_ref3, (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(Object.values(filteredFilters)));

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(className, (_AppliedFilters_module_scss__WEBPACK_IMPORTED_MODULE_13___default().container), (_classnames = {}, (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_classnames, (_AppliedFilters_module_scss__WEBPACK_IMPORTED_MODULE_13___default().grid), grid), (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_classnames, (_AppliedFilters_module_scss__WEBPACK_IMPORTED_MODULE_13___default().breadbox), true), _classnames)),
    children: [!mobile ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("h3", {
      className: (_AppliedFilters_module_scss__WEBPACK_IMPORTED_MODULE_13___default().header),
      children: "Applied Filters"
    }) : '', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("ul", {
      className: (_AppliedFilters_module_scss__WEBPACK_IMPORTED_MODULE_13___default().filters),
      "data-test": "applied-filters",
      children: [listOfAppliedFilters.map(function (value) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
          className: classnames__WEBPACK_IMPORTED_MODULE_5___default()((_AppliedFilters_module_scss__WEBPACK_IMPORTED_MODULE_13___default().filter), (_AppliedFilters_module_scss__WEBPACK_IMPORTED_MODULE_13___default().breadbox)),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(AppliedFilter, _objectSpread(_objectSpread({}, value), {}, {
            mobile: mobile
          }))
        }, value.name);
      }), showClearFiltersLink && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_clear_filters_ClearFilters__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        baseFacetId: baseFacetId,
        mobile: mobile,
        query: {
          page: undefined
        },
        show: showClearFilters
      })]
    })]
  });
};

AppliedFilters.defaultProps = {
  baseFacetId: '',
  showClearFiltersLink: true,
  grid: false,
  mobile: false,
  onClearAllFilters: function onClearAllFilters() {}
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(AppliedFilters));

/***/ }),

/***/ 73018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _JohnLewisPartnership_jl_design_system_elements_button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73087);
/* harmony import */ var _JohnLewisPartnership_jl_design_system_elements_button_Button__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_JohnLewisPartnership_jl_design_system_elements_button_Button__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _analytics_analyticsEvents__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85576);
/* harmony import */ var _hooks_useAnalytics__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48549);
/* harmony import */ var _hooks_useAnalyticsData__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36710);
/* harmony import */ var _stateful_link_StatefulLink__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85852);
/* harmony import */ var _facet_context__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22418);
/* harmony import */ var _ClearFilters_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16408);
/* harmony import */ var _ClearFilters_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_ClearFilters_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var ClearFilters = function ClearFilters(_ref) {
  var baseFacetId = _ref.baseFacetId,
      query = _ref.query,
      show = _ref.show,
      mobileFilterDrawer = _ref.mobileFilterDrawer,
      isTablet = _ref.isTablet;

  var _useFacetContext = (0,_facet_context__WEBPACK_IMPORTED_MODULE_9__/* .useFacetContext */ .gv)(),
      filterCombination = _useFacetContext.filterCombination,
      filterCombinationNvals = _useFacetContext.filterCombinationNvals;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  var type = router.query.type;
  var rootFacetId = ['brand', 'browse'].includes(type) ? baseFacetId : '';

  var _useAnalyticsData = (0,_hooks_useAnalyticsData__WEBPACK_IMPORTED_MODULE_7__/* .useAnalyticsData */ .I)(),
      pageType = _useAnalyticsData.pageType;

  var filterRemovedEvent = (0,_hooks_useAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .useAnalytics */ .z)(_analytics_analyticsEvents__WEBPACK_IMPORTED_MODULE_5__/* .FILTER_REMOVED */ .B2, {
    pagetype: pageType,
    appliedFilter: filterCombination,
    appliedFilterNval: filterCombinationNvals,
    filterCombination: '',
    filterCombinationNvals: ''
  });

  var triggerEvents = function triggerEvents() {
    filterRemovedEvent();
  };

  if (!show) {
    return null;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_stateful_link_StatefulLink__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
      className: mobileFilterDrawer ? (_ClearFilters_module_scss__WEBPACK_IMPORTED_MODULE_11___default().clearAllButton) : classnames__WEBPACK_IMPORTED_MODULE_3___default()((_ClearFilters_module_scss__WEBPACK_IMPORTED_MODULE_11___default().link), (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (_ClearFilters_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["underline-offset"]), !mobileFilterDrawer)),
      facetId: rootFacetId,
      onClick: function onClick() {
        return triggerEvents();
      },
      query: _objectSpread({}, query),
      queryOpts: {
        filter: (0,_stateful_link_StatefulLink__WEBPACK_IMPORTED_MODULE_8__/* .sortFilter */ .U3)()
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_JohnLewisPartnership_jl_design_system_elements_button_Button__WEBPACK_IMPORTED_MODULE_4__.UnderlinedButton, {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_ClearFilters_module_scss__WEBPACK_IMPORTED_MODULE_11___default().clearAllDrawerButton), (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (_ClearFilters_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["clearAllButton--large"]), isTablet)),
        size: isTablet ? '' : 'small',
        "data-test": "clear-filter-button",
        children: mobileFilterDrawer ? 'Clear filters' : 'Clear all filters'
      })
    })
  });
};

ClearFilters.defaultProps = {
  baseFacetId: '',
  mobile: false,
  show: false,
  mobileFilterDrawer: false
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(ClearFilters));

/***/ }),

/***/ 22418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NI": function() { return /* binding */ useFacetAnalyticsEvent; },
/* harmony export */   "_y": function() { return /* binding */ Context; },
/* harmony export */   "gv": function() { return /* binding */ useFacetContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _analytics_analyticsEvents__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85576);
/* harmony import */ var _hooks_useAnalyticsData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36710);




var Context = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createContext({});
var useFacetContext = function useFacetContext() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Context);
};
var useFacetAnalyticsEvent = function useFacetAnalyticsEvent(_ref) {
  var value = _ref.value;

  var _useAnalyticsData = (0,_hooks_useAnalyticsData__WEBPACK_IMPORTED_MODULE_2__/* .useAnalyticsData */ .I)(),
      pageType = _useAnalyticsData.pageType;

  var _useFacetContext = useFacetContext(),
      currentFilterCombination = _useFacetContext.filterCombination,
      currentFilterCombinationNvals = _useFacetContext.filterCombinationNvals;

  return function () {
    var _value$facetName = value.facetName,
        facetName = _value$facetName === void 0 ? '' : _value$facetName,
        label = value.label,
        name = value.name,
        selected = value.selected,
        trackingId = value.trackingId;
    var appliedFilter = "".concat(facetName, ":").concat(label || name).toLowerCase();
    var appliedFilterNval = "".concat(trackingId);
    var filters = [];
    var nvalFilters = [];

    if (currentFilterCombination) {
      filters = currentFilterCombination.split('|').filter(Boolean);
      nvalFilters = currentFilterCombinationNvals.split('|').filter(Boolean);
    }

    if (selected) {
      var index = filters.indexOf(appliedFilter);
      var nvalIndex = nvalFilters.indexOf(appliedFilterNval);
      if (index > -1) filters.splice(index, 1);
      if (nvalIndex > -1) nvalFilters.splice(nvalIndex, 1);
    } else {
      filters.push(appliedFilter);
      nvalFilters.push(appliedFilterNval);
    }

    var filterCombination = filters.join('|');
    var filterCombinationNvals = nvalFilters.join('|');
    return (0,_analytics_analyticsEvents__WEBPACK_IMPORTED_MODULE_1__/* .dispatchAnalyticsEvent */ .$j)(selected ? _analytics_analyticsEvents__WEBPACK_IMPORTED_MODULE_1__/* .FILTER_REMOVED */ .B2 : _analytics_analyticsEvents__WEBPACK_IMPORTED_MODULE_1__/* .FILTER_APPLIED */ .pg, {
      pagetype: pageType,
      filterCombination: filterCombination,
      filterCombinationNvals: filterCombinationNvals,
      appliedFilter: appliedFilter,
      appliedFilterNval: appliedFilterNval
    });
  };
};

/***/ }),

/***/ 59376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _GridColumn_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52564);
/* harmony import */ var _GridColumn_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_GridColumn_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["children", "type", "className", "col", "colSm", "colMd", "colLg", "colXl"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var GridColumn = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _mergeClasses;

  var children = _ref.children,
      type = _ref.type,
      className = _ref.className,
      col = _ref.col,
      colSm = _ref.colSm,
      colMd = _ref.colMd,
      colLg = _ref.colLg,
      colXl = _ref.colXl,
      rest = (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  var Tag = "".concat(type);
  var mergeClasses = (_mergeClasses = {}, (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mergeClasses, (_GridColumn_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["col-12"]), !col && !colSm && !colMd && !colLg && !colXl), (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mergeClasses, (_GridColumn_module_scss__WEBPACK_IMPORTED_MODULE_5___default())["col-".concat(col)], col), (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mergeClasses, (_GridColumn_module_scss__WEBPACK_IMPORTED_MODULE_5___default())["col-sm-".concat(colSm)], colSm), (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mergeClasses, (_GridColumn_module_scss__WEBPACK_IMPORTED_MODULE_5___default())["col-md-".concat(colMd)], colMd), (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mergeClasses, (_GridColumn_module_scss__WEBPACK_IMPORTED_MODULE_5___default())["col-lg-".concat(colLg)], colLg), (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mergeClasses, (_GridColumn_module_scss__WEBPACK_IMPORTED_MODULE_5___default())["col-xl-".concat(colXl)], colXl), _mergeClasses);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Tag, _objectSpread(_objectSpread({
    "data-test": "component-grid-column",
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(mergeClasses, className)
  }, rest), {}, {
    ref: ref,
    children: children
  }));
});
GridColumn.defaultProps = {
  className: null,
  col: null,
  colSm: null,
  colMd: null,
  colLg: null,
  colXl: null,
  type: 'div'
};
GridColumn.displayName = 'GridColumn';
/* harmony default export */ __webpack_exports__["Z"] = (GridColumn);

/***/ }),

/***/ 23824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _JohnLewisPartnership_jl_design_system_components_loading_spinner_LoadingSpinner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72601);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Loading_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36928);
/* harmony import */ var _Loading_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Loading_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var Loading = function Loading(_ref) {
  var showSpinner = _ref.showSpinner;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Loading_module_scss__WEBPACK_IMPORTED_MODULE_4___default().loading)),
    children: showSpinner ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_JohnLewisPartnership_jl_design_system_components_loading_spinner_LoadingSpinner__WEBPACK_IMPORTED_MODULE_1__["default"], {}) : null
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Loading);

/***/ }),

/***/ 85852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U3": function() { return /* binding */ sortFilter; },
/* harmony export */   "Wz": function() { return /* binding */ getQueryString; },
/* harmony export */   "f9": function() { return /* binding */ defaultFilter; },
/* harmony export */   "vl": function() { return /* binding */ getQueryParams; },
/* harmony export */   "xK": function() { return /* binding */ facetsFilter; }
/* harmony export */ });
/* unused harmony exports resolvePage, StatefulLink */
/* harmony import */ var _builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4730);
/* harmony import */ var _builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);



var _excluded = ["query", "facetId", "facetType", "children", "router", "queryOpts", "scroll"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable no-param-reassign */





var pages = [[/^\/[a-z-]+\//, '/[type]/[[...facetId]]']];
var defaultFilter = function defaultFilter() {
  return ['search-term', 'sortBy', 'page', 'facet', 'cardType', 'listHead', 'lolcode'];
};
var sortFilter = function sortFilter() {
  return ['search-term', 'sortBy', 'cardType', 'listHead', 'lolcode'];
};
var facetsFilter = function facetsFilter() {
  return defaultFilter().concat(['price', 'priceBands']);
};
var resolvePage = function resolvePage(href) {
  var page = pages.find(function (_ref) {
    var _ref2 = (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref, 1),
        regex = _ref2[0];

    return regex.test(href);
  });

  if (!page) {
    return href;
  }

  return page[1];
};
var getQueryParams = function getQueryParams(query, filter) {
  return Object.keys(query).reduce(function (filtered, key) {
    var value = query[key];

    if (filter.includes(key)) {
      filtered[key] = value;
    }

    if (key === 'facetId' && value === '') {
      filtered[key] = value;

      if (value === '') {
        filtered[key] = null;
      }
    }

    if (['page', 'facet'].includes(key) && !value) {
      delete filtered[key];
    }

    if (key === 'page' && Number(value) === 1) {
      delete filtered[key];
    }

    return filtered;
  }, {});
};
var getQueryString = function getQueryString(query) {
  var queryOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var stringifyOpts = _objectSpread({
    encode: false,
    skipNulls: true
  }, queryOpts);

  return qs__WEBPACK_IMPORTED_MODULE_2___default().stringify(query, stringifyOpts);
};
var StatefulLink = function StatefulLink(_ref3) {
  var query = _ref3.query,
      facetId = _ref3.facetId,
      facetType = _ref3.facetType,
      children = _ref3.children,
      router = _ref3.router,
      queryOpts = _ref3.queryOpts,
      scroll = _ref3.scroll,
      DOMProps = (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref3, _excluded);

  var routerQuery = _objectSpread({}, router.query);

  var type = routerQuery.type;
  var pageType = type === 's' ? 'search' : facetType || type;

  if (type === 's') {
    routerQuery['search-term'] = routerQuery.facetId[0].replace(/-/g, ' ');
    delete routerQuery.facetId;
  }

  var facetPath = facetId;

  if (typeof facetPath !== 'string') {
    facetPath = routerQuery.facetId ? routerQuery.facetId.join('/') : '';
  }

  var urlPrefixRegex = new RegExp("^/(brand|browse|search|s)/");
  facetPath = facetPath.replace(urlPrefixRegex, '/');
  var filter = (queryOpts === null || queryOpts === void 0 ? void 0 : queryOpts.filter) || defaultFilter();

  var stringifyOpts = _objectSpread({
    encode: false,
    skipNulls: true
  }, queryOpts);

  var queryParams = _objectSpread(_objectSpread(_objectSpread({}, routerQuery), query), {}, {
    facetId: facetPath
  });

  var filteredQueryParams = getQueryParams(queryParams, filter);
  var queryString = getQueryString(filteredQueryParams, stringifyOpts);
  var as = "/".concat(pageType, "/").concat(facetPath, "?").concat(queryString).replace(/\/{2,}/g, '/'); // Replaces // with /

  var pathname = resolvePage(as); // remove trailing ? if one exists

  if (as[as.length - 1] === '?') {
    as = as.slice(0, as.length - 1);
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
    href: {
      pathname: pathname,
      query: filteredQueryParams
    },
    as: as.replace(/(?=\/(\?|$))\//, ''),
    scroll: scroll,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", _objectSpread(_objectSpread({}, DOMProps), {}, {
      children: children
    }))
  });
};
/* harmony default export */ __webpack_exports__["ZP"] = ((0,next_router__WEBPACK_IMPORTED_MODULE_4__.withRouter)(StatefulLink));

/***/ }),

/***/ 13525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zt": function() { return /* binding */ Provider; },
  "EN": function() { return /* binding */ useCompareContext; }
});

// UNUSED EXPORTS: Context, LOCAL_STORAGE_KEY, createStorageKey, default

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: external "React"
var external_React_ = __webpack_require__(37667);
var external_React_default = /*#__PURE__*/__webpack_require__.n(external_React_);
// EXTERNAL MODULE: ./node_modules/use-local-storage-state/dist/index.js
var dist = __webpack_require__(80044);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dist/build/polyfills/fetch/index.js
var fetch = __webpack_require__(63144);
var fetch_default = /*#__PURE__*/__webpack_require__.n(fetch);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/api/compare/index.js



var _getConfig = config_default()(),
    features = _getConfig.publicRuntimeConfig;

var fetcher = function fetcher() {
  return fetch_default().apply(void 0, arguments).then(function (r) {
    if (r.ok) {
      return r.json();
    }

    throw new Error("Received error fetching compare data: ".concat(r.status));
  })["catch"](function (e) {
    throw new Error(e);
  });
};

var PATH = "".concat(features.applicationPrefix, "/api/compare");
var fetchCompareData = function fetchCompareData(products) {
  return fetcher("".concat(PATH, "/").concat(products));
};
// EXTERNAL MODULE: ./src/hooks/useMedia.jsx
var useMedia = __webpack_require__(91763);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/context/CompareContext.tsx





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var LOCAL_STORAGE_KEY = 'compare:data';
var N_PREFIX = /\/(?:_\/)(N-[0-9a-zA-Y]+)/;
var initialSelected = {
  products: [],
  category: null
};
var Context = /*#__PURE__*/external_React_default().createContext({});
var useCompareContext = function useCompareContext() {
  return (0,external_React_.useContext)(Context);
};
var createStorageKey = function createStorageKey(router) {
  var query = router.query,
      asPath = router.asPath;
  var type = query.type,
      term = query['search-term'],
      facetId = query.facetId;
  var isSearch = type === 'search' || type === 's';

  if (isSearch) {
    var searchTerm = type === 's' && facetId ? facetId[0].replace(/-/g, ' ') : term;

    if (!searchTerm) {
      return 'unknown';
    }

    return searchTerm.toLowerCase();
  }

  var _ref = asPath.match(N_PREFIX) || [],
      _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
      value = _ref2[1];

  if (!value) {
    return 'unknown';
  }

  return value;
};
var Provider = function Provider(_ref3) {
  var children = _ref3.children;
  var router = (0,next_router.useRouter)();
  var storageKey = (0,external_React_.useMemo)(function () {
    return createStorageKey(router);
  }, [router]);
  var maxCompare = (0,useMedia/* useMedia */.G)(['(min-width: 768px)', '(min-width: 375px)', '(min-width: 0px)'], [4, 3, 2], 4);

  var _useState = (0,external_React_.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = (0,external_React_.useState)(true),
      isAvailable = _useState2[0],
      setIsAvailable = _useState2[1];

  var _useLocalStorageState = (0,dist/* default */.ZP)(LOCAL_STORAGE_KEY, {}),
      _useLocalStorageState2 = (0,slicedToArray/* default */.Z)(_useLocalStorageState, 2),
      store = _useLocalStorageState2[0],
      setStore = _useLocalStorageState2[1];

  var selected = store[storageKey] || initialSelected;

  var setSelected = function setSelected(data) {
    return setStore(_objectSpread(_objectSpread({}, store), {}, (0,defineProperty/* default */.Z)({}, storageKey, data)));
  };

  var _useState3 = (0,external_React_.useState)(null),
      data = _useState3[0],
      setData = _useState3[1];

  var _useState4 = (0,external_React_.useState)({}),
      phase = _useState4[0],
      setPhase = _useState4[1];

  var load = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var products,
          productsData,
          response,
          filteredProducts,
          _args = arguments;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              products = _args.length > 0 && _args[0] !== undefined ? _args[0] : selected.products;
              productsData = data;

              if (!(products.length > 1 && products.length <= 4)) {
                _context.next = 15;
                break;
              }

              _context.prev = 3;
              setPhase({
                loading: true,
                error: false
              });
              _context.next = 7;
              return fetchCompareData(products.join(','));

            case 7:
              response = _context.sent;
              productsData = response.products;
              setPhase({
                loading: false,
                error: false
              });
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);
              setPhase({
                loading: false,
                error: true
              });

            case 15:
              if (productsData) {
                _context.next = 17;
                break;
              }

              return _context.abrupt("return");

            case 17:
              filteredProducts = productsData.filter(function (_ref5) {
                var productId = _ref5.productId;
                return products.includes(productId);
              });
              setData(filteredProducts);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 12]]);
    }));

    return function load() {
      return _ref4.apply(this, arguments);
    };
  }();

  var toggle = function toggle(id, category) {
    var currentCategory = selected.category,
        products = selected.products;
    var updatedProducts = products;

    if (!products.includes(id)) {
      updatedProducts = products.concat([id]);
    } else {
      updatedProducts = products.filter(function (val) {
        return val !== id;
      });
    }

    if (updatedProducts.length === 0 && isOpen) {
      setIsOpen(false);
    }

    setSelected({
      products: updatedProducts,
      category: category || currentCategory
    });

    if (isOpen) {
      return load(updatedProducts);
    }

    return Promise.resolve();
  };

  var removeAll = function removeAll() {
    setSelected({
      products: []
    });
    setData(null);
    setIsOpen(false);
  };

  var open = function open() {
    return setIsOpen(true);
  };

  var close = function close() {
    return setIsOpen(false);
  };

  var setAvailability = function setAvailability(isCompareAvailable) {
    return setIsAvailable(isCompareAvailable);
  };

  var context = (0,external_React_.useMemo)(function () {
    return {
      data: data,
      open: open,
      close: close,
      load: load,
      setAvailability: setAvailability,
      toggle: toggle,
      removeAll: removeAll,
      storageKey: storageKey,
      isOpen: isOpen,
      isAvailable: isAvailable,
      max: maxCompare,
      isDisabled: !isAvailable || selected.products.length >= maxCompare,
      products: selected.products,
      category: selected.category,
      loading: phase.loading,
      error: phase.error
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [toggle, load, phase, selected, data, isOpen, isAvailable]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Context.Provider, {
    value: context,
    children: children
  });
};
Provider.displayName = 'Compare.Provider';
/* harmony default export */ var CompareContext = ((/* unused pure expression or super */ null && (Context)));

/***/ }),

/***/ 88613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YP": function() { return /* binding */ useEnergyDrawerContext; },
/* harmony export */   "zt": function() { return /* binding */ Provider; }
/* harmony export */ });
/* unused harmony export Context */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var Context = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createContext({});
var useEnergyDrawerContext = function useEnergyDrawerContext() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Context);
};
var Provider = function Provider(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    imageSrc: '',
    altText: '',
    energyRating: ''
  }),
      energyDrawerData = _useState[0],
      setEnergyDrawerData = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      energyDrawerIsOpen = _useState2[0],
      setEnergyDrawerIsOpen = _useState2[1];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Context.Provider, {
    value: {
      energyDrawerData: energyDrawerData,
      energyDrawerIsOpen: energyDrawerIsOpen,
      setEnergyDrawerData: setEnergyDrawerData,
      setEnergyDrawerIsOpen: setEnergyDrawerIsOpen
    },
    children: children
  });
};

/***/ }),

/***/ 22030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gv": function() { return /* binding */ useFacetContext; },
/* harmony export */   "zt": function() { return /* binding */ Provider; }
/* harmony export */ });
/* unused harmony export Context */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var Context = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createContext();
var useFacetContext = function useFacetContext() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Context);
};
var Provider = function Provider(_ref) {
  var facets = _ref.facets,
      children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Context.Provider, {
    value: facets || {},
    children: children
  });
};

/***/ }),

/***/ 79164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$h": function() { return /* binding */ useProductContext; },
/* harmony export */   "zt": function() { return /* binding */ Provider; }
/* harmony export */ });
/* unused harmony export Context */
/* harmony import */ var _builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var deepmerge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9996);
/* harmony import */ var deepmerge__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(deepmerge__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var Context = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createContext();
var useProductContext = function useProductContext() {
  return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(Context);
};
var defaultProductsData = {
  products: [],
  totalNumberOfResults: 0,
  pagesAvailable: 1,
  pageNumber: 1
};

var serialiseProducts = function serialiseProducts(products) {
  return JSON.stringify(_objectSpread(_objectSpread({}, products), {}, {
    products: products.products.map(function (_ref) {
      var id = _ref.id;
      return id;
    })
  }));
};

var productsAreDifferent = function productsAreDifferent(set1, set2) {
  return serialiseProducts(set1) !== serialiseProducts(set2);
};

var Provider = function Provider(_ref2) {
  var products = _ref2.products,
      children = _ref2.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(products),
      originalProducts = _useState[0],
      setOriginalProducts = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(deepmerge__WEBPACK_IMPORTED_MODULE_2___default()(defaultProductsData, products)),
      productContextState = _useState2[0],
      setProductContextState = _useState2[1];

  var setProductContext = function setProductContext(data) {
    setProductContextState(_objectSpread(_objectSpread({}, productContextState), {}, {
      products: productContextState.products.concat(data)
    }));
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (productsAreDifferent(products, originalProducts)) {
      setOriginalProducts(products);
      setProductContextState(deepmerge__WEBPACK_IMPORTED_MODULE_2___default()(defaultProductsData, products));
    }
  }, [products]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Context.Provider, {
    value: _objectSpread(_objectSpread({}, productContextState), {}, {
      setProductContext: setProductContext
    }),
    children: children
  });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Context)));

/***/ }),

/***/ 80348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AB": function() { return /* binding */ useSearchContext; },
/* harmony export */   "zt": function() { return /* binding */ Provider; }
/* harmony export */ });
/* unused harmony export Context */
/* harmony import */ var _builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var Context = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createContext();
var useSearchContext = function useSearchContext() {
  return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(Context);
};
var Provider = function Provider(_ref) {
  var _ref$search = _ref.search,
      search = _ref$search === void 0 ? {} : _ref$search,
      children = _ref.children;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(),
      query = _useRouter.query;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      alsoSearched = _useState[0],
      setAlsoSearched = _useState[1];

  var term = query['search-term'],
      sortBy = query.sortBy,
      _query$page = query.page,
      page = _query$page === void 0 ? 1 : _query$page,
      _query$originalSearch = query.originalSearchTerm,
      originalSearchTerm = _query$originalSearch === void 0 ? undefined : _query$originalSearch,
      suggestion = query.suggestion,
      type = query.type,
      facetId = query.facetId;
  var searchTerm = type !== 's' ? term : facetId ? facetId[0].replace(/-/g, ' ') : undefined;

  var contextValue = _objectSpread(_objectSpread({}, search), {}, {
    term: searchTerm,
    sortBy: sortBy,
    page: page,
    originalSearchTerm: originalSearchTerm,
    alsoSearched: alsoSearched,
    setAlsoSearched: setAlsoSearched,
    isSuggestionLink: (suggestion === null || suggestion === void 0 ? void 0 : suggestion.split(':')[0]) === 'true'
  });

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Context.Provider, {
    value: contextValue,
    children: children
  });
};

/***/ }),

/***/ 48549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useAnalytics; }
/* harmony export */ });
/* harmony import */ var _builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _components_analytics_analyticsEvents__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85576);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_JohnLewisPartnership_digital_services_standard_plp_standard_plp_ui_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var useAnalytics = function useAnalytics(eventName) {
  var defaultEventData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!eventName) {
    throw new Error("Expected useAnalytics(\"event.name\") received event name: \"".concat(eventName, "\""));
  }

  return function () {
    var eventData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0,_components_analytics_analyticsEvents__WEBPACK_IMPORTED_MODULE_1__/* .dispatchAnalyticsEvent */ .$j)(eventName, _objectSpread(_objectSpread({}, defaultEventData), eventData));
  };
};

/***/ }),

/***/ 36710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useAnalyticsData; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

var useAnalyticsData = function useAnalyticsData() {
  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)(),
      query = _useRouter.query;

  var type = query.type;
  var pageType = 'search results';

  if (type === 'browse' || type === 'brand') {
    pageType = 'product list page grid';
  }

  return {
    pageType: pageType
  };
};

/***/ }),

/***/ 91763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ useMedia; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable react-hooks/rules-of-hooks */

function useMedia(queries, values, defaultValue) {
  if (false) {} // Array containing a media query list for each query


  var mediaQueryLists = queries.map(function (q) {
    return window.matchMedia(q);
  }); // Function that gets value based on matching media query

  var getValue = function getValue() {
    // Get index of first media query that matches
    var index = mediaQueryLists.findIndex(function (mql) {
      return mql.matches;
    }); // Return related value or defaultValue if none

    return typeof values[index] !== 'undefined' ? values[index] : defaultValue;
  }; // State and setter for matched value


  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getValue),
      value = _useState[0],
      setValue = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // Event listener callback
    // Note: By defining getValue outside of useEffect we ensure that it has ...
    // ... current values of hook args (as this hook callback is created once on mount).
    var handler = function handler() {
      return setValue(getValue);
    }; // Set a listener for each media query with above handler as callback.


    mediaQueryLists.forEach(function (mql) {
      return mql.addListener(handler);
    }); // Remove listeners on cleanup

    return function () {
      return mediaQueryLists.forEach(function (mql) {
        return mql.removeListener(handler);
      });
    };
  }, [] // Empty array ensures effect is only run on mount and unmount
  );
  return value;
}

/***/ }),

/***/ 20784:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var constants = {
  DEPARTMENT_DIMENSION_NAME: 'Store.Department',
  DEPARTMENT_NAME_MODIFICATION: 'Select a Department',
  AGE_RANGE_DIMENSION_NAME: 'babykidsclothingsize',
  AGE_RANGE_MODIFICATION: 'Age Range',
  BRAND_DIMENSION_NAME: 'brand',
  WOMENS_SIZE_DIMENSION_NAME: 'womensclothingsize',
  WOMENS_SIZE_MODIFICATION: 'Size',
  MENS_SIZE_DIMENSION_NAME: 'mensclothingsize',
  MENS_SIZE_MODIFICATION: 'Size',
  XXS_MOBILE_MAX_WIDTH: 375,
  XS_MOBILE_MAX_WIDTH: 568,
  MOBILE_MAX_WIDTH: 768,
  TABLET_MAX_WIDTH: 849,
  QUICK_VIEW_MIN_WIDTH: 1024,
  MAX_COMPARE_DESKTOP: 4,
  MAX_COMPARE_MOBILE: 3,
  MAX_OPTIONS_TO_SHOW: 9,
  COMPARE_LOCAL_STORAGE_KEY: 'compare:data',
  FASHION_SIZE_DIMENSION_NAMES: ['fashionsize', 'FashionSize'],
  STORAGE_TYPES: {
    COOKIES: 'cookie',
    LOCAL_STORAGE: 'localStorage',
    SESSION_STORAGE: 'sessionStorage'
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (constants);

/***/ }),

/***/ 68243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DU": function() { return /* binding */ getAriaTextIfPriceRange; }
/* harmony export */ });
/* unused harmony exports getChunkedData, getQueryString, isElementInView, randNumBetween */
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);

var priceRangeRegex = /^£[\d]+ - £[\d]+$/; // e.g. £300 - £500

var getAriaTextIfPriceRange = function getAriaTextIfPriceRange(label) {
  return label && priceRangeRegex.test(label) ? label.replace('-', 'to') : undefined;
};
/**
 * Returns an array of products with `chunkSize` number of products.
 * The products included in the array is determined by which `chunk` it is
 * @param products
 * @param chunk
 * @param chunkSize
 * @returns {*}
 */

var getChunkedData = function getChunkedData(products, chunk, chunkSize) {
  var startIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  if (!products) return [];

  if (products.data) {
    return products.data.slice(startIndex, chunk * parseInt(chunkSize, 10));
  }

  return products.slice(startIndex, chunk * parseInt(chunkSize, 10));
};
var getQueryString = function getQueryString(_ref) {
  var sortBy = _ref.sortBy,
      pageSize = _ref.pageSize,
      page = _ref.page,
      pageNumber = _ref.pageNumber,
      facetId = _ref.facetId,
      price = _ref.price,
      priceBands = _ref.priceBands;
  var safeFacetId = facetId && facetId.replace(/®/g, '');
  var query = {
    sortBy: sortBy,
    pageSize: pageSize,
    page: pageNumber || page,
    facetId: safeFacetId,
    price: price || undefined,
    priceBands: priceBands || undefined
  };

  var removeArrayDuplicates = function removeArrayDuplicates(prefix, value) {
    /* istanbul ignore else */
    if (Array.isArray(value)) {
      return value[0];
    }

    return value;
  };

  return qs.stringify(query, {
    encode: true,
    indices: false,
    filter: removeArrayDuplicates
  });
}; // eslint-disable-next-line import/prefer-default-export

var isElementInView = function isElementInView(el) {
  var bounding = el.getBoundingClientRect();
  return bounding.top >= 0 || bounding.bottom >= 0;
};
var randNumBetween = function randNumBetween() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  return Math.floor(Math.random() * (max - min + 1) + min);
};

/***/ }),

/***/ 63396:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[type]/[[...facetId]]",
      function () {
        return __webpack_require__(75403);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 99380:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary-main":"search_primary-main__3KMFz"};

/***/ }),

/***/ 76616:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"back-to-top":"BackToTop_back-to-top__woKp8","back-to-top__container":"BackToTop_back-to-top__container__1KnFr","back-to-top__text":"BackToTop_back-to-top__text__nl69j","back-to-top__button":"BackToTop_back-to-top__button__5zkkx","back-to-top__icon":"BackToTop_back-to-top__icon___ibFQ","back-to-top--active":"BackToTop_back-to-top--active__rIH6u","back-to-top--compare-active":"BackToTop_back-to-top--compare-active__fdtez","back-to-top--swatches-active":"BackToTop_back-to-top--swatches-active__I1Tdp"};

/***/ }),

/***/ 26171:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Banner_container__NBzkd","banners":"Banner_banners__eckJ3","hybridbanners":"Banner_hybridbanners__YJ4DE","seobanners":"Banner_seobanners__Ncrwu","seobanners-top":"Banner_seobanners-top__vuRBa","citrusbanners":"Banner_citrusbanners__nxUr_"};

/***/ }),

/***/ 83557:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"BrandBanner_container__7OHud","chanelStripe":"BrandBanner_chanelStripe__9uqOh","chanel":"BrandBanner_chanel__AhmHd","banner":"BrandBanner_banner__uKsQM","backStage":"BrandBanner_backStage__q7O1i"};

/***/ }),

/***/ 86640:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs-carousel":"Breadcrumbs_breadcrumbs-carousel__wiiut"};

/***/ }),

/***/ 71784:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"plp__facets":"Facets_plp__facets__96P9X","plp__facets--wider-scrollbar":"Facets_plp__facets--wider-scrollbar__Se_V8","plp__facets--desktop":"Facets_plp__facets--desktop__ZFMyq","facets":"Facets_facets__TzJbG","facets--tablet":"Facets_facets--tablet__k8WlJ","facets--mobile":"Facets_facets--mobile__3ctRR","facets--compare-open":"Facets_facets--compare-open__KxcKz","facets--wider-scrollbar":"Facets_facets--wider-scrollbar__VBHBl","toggle-more-facets":"Facets_toggle-more-facets__2fc2R","showMoreButton":"Facets_showMoreButton__3Utw7","marginRight":"Facets_marginRight__MBo2r"};

/***/ }),

/***/ 25577:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"AppliedFilters_container__FZHEm","grid":"AppliedFilters_grid__4rEGa","header":"AppliedFilters_header__9iOKy","filters":"AppliedFilters_filters__LCWMf","filter":"AppliedFilters_filter__5QuEv","breadbox":"AppliedFilters_breadbox__O5W49","filterLink":"AppliedFilters_filterLink__v2ZhC","filterLink__icon":"AppliedFilters_filterLink__icon__qnxPe","filterLinkText":"AppliedFilters_filterLinkText__0iMy_","filterLinkIcon":"AppliedFilters_filterLinkIcon__0TKhU"};

/***/ }),

/***/ 16408:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ClearFilters_container__vYq2V","grid":"ClearFilters_grid__wt6J_","header":"ClearFilters_header__WCfKm","filters":"ClearFilters_filters__wDhx_","filter":"ClearFilters_filter__i88KH","breadbox":"ClearFilters_breadbox__R8dGr","filterLink":"ClearFilters_filterLink__Q2s4b","filterLink__icon":"ClearFilters_filterLink__icon__OnRG8","filterLinkText":"ClearFilters_filterLinkText__tG__G","filterLinkIcon":"ClearFilters_filterLinkIcon__uzTEm","clearAllButton":"ClearFilters_clearAllButton__niiDm","clearAllDrawerButton":"ClearFilters_clearAllDrawerButton__oNKhw","clearAllButton--large":"ClearFilters_clearAllButton--large__cjn0C","link":"ClearFilters_link__upp02","underline-offset":"ClearFilters_underline-offset__PdLKV"};

/***/ }),

/***/ 56605:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"FacetAccordion_list__KK27y","collapsedSummary":"FacetAccordion_collapsedSummary__SdsOl","noResults":"FacetAccordion_noResults__W9FlV","showMoreFacetValues":"FacetAccordion_showMoreFacetValues__ozZMs","accordion--is-hidden":"FacetAccordion_accordion--is-hidden__RxnrX"};

/***/ }),

/***/ 12299:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listItem":"FacetItem_listItem__cU9gv","nopadding":"FacetItem_nopadding__RfPmV","bordered":"FacetItem_bordered__W_I_x","last":"FacetItem_last__kJ_fP","divider":"FacetItem_divider__Q4T_F","link":"FacetItem_link__jgAL5","active":"FacetItem_active__jlcBz","disabled":"FacetItem_disabled__kSC4_","hidden":"FacetItem_hidden__4f2ZC"};

/***/ }),

/***/ 86240:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"BlockFacet_container__pZg7D","container__selected":"BlockFacet_container__selected__uQwDl","disabled":"BlockFacet_disabled__woC0W","info":"BlockFacet_info__eSQBG","swatch":"BlockFacet_swatch__rWr60","black":"BlockFacet_black__eTiK0","blue":"BlockFacet_blue__YEM_n","brown":"BlockFacet_brown__6pCdL","clear":"BlockFacet_clear__otNe3","gold":"BlockFacet_gold__1txVm","green":"BlockFacet_green__AvBwF","grey":"BlockFacet_grey__dq5MW","metallics":"BlockFacet_metallics__NRjpI","multi":"BlockFacet_multi__PD2_0","natural":"BlockFacet_natural__ZvYId","neutrals":"BlockFacet_neutrals__dWGfn","orange":"BlockFacet_orange__myiRl","pink":"BlockFacet_pink__ywB1J","purple":"BlockFacet_purple__p79RT","red":"BlockFacet_red__Uoe2a","silver":"BlockFacet_silver__UjYhT","white":"BlockFacet_white__srOTh","yellow":"BlockFacet_yellow___xOhA","tick":"BlockFacet_tick__QnK0A"};

/***/ }),

/***/ 48906:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"DepartmentItem_item__GKORC"};

/***/ }),

/***/ 82189:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"FacetSearch_container__NdVM9","filterDrawer":"FacetSearch_filterDrawer__oqrUS","searchIcon":"FacetSearch_searchIcon__Dlh_s","clear":"FacetSearch_clear__5C46_","input":"FacetSearch_input__QzFF2","input--search-icon-showing":"FacetSearch_input--search-icon-showing__x338Q","input--clear-button-showing":"FacetSearch_input--clear-button-showing__rmgx7"};

/***/ }),

/***/ 2974:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"OutOfStockFilter_container__urUP6","label":"OutOfStockFilter_label__Rxa9E"};

/***/ }),

/***/ 17585:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"SingleItemFacet_content__Gow3a","contentMobile":"SingleItemFacet_contentMobile__fldrC"};

/***/ }),

/***/ 46971:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"FilterSuggestions_container__B_UgF","title":"FilterSuggestions_title__dLK50"};

/***/ }),

/***/ 52564:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"col-1":"GridColumn_col-1__2MM_N","col-2":"GridColumn_col-2__BcDVx","col-3":"GridColumn_col-3__5I2Y_","col-4":"GridColumn_col-4__ZEzIH","col-5":"GridColumn_col-5__Rd4aG","col-6":"GridColumn_col-6__UbfRA","col-7":"GridColumn_col-7__KcIkN","col-8":"GridColumn_col-8__5pYq2","col-9":"GridColumn_col-9__cxWhJ","col-10":"GridColumn_col-10__xILSq","col-11":"GridColumn_col-11__bMJ6n","col-12":"GridColumn_col-12__eMHHt","col-sm-1":"GridColumn_col-sm-1__1w9hS","col-sm-2":"GridColumn_col-sm-2__cY0Xr","col-sm-3":"GridColumn_col-sm-3__iLBgO","col-sm-4":"GridColumn_col-sm-4__zN7Xv","col-sm-5":"GridColumn_col-sm-5__9_r6_","col-sm-6":"GridColumn_col-sm-6__QugVH","col-sm-7":"GridColumn_col-sm-7__IrB9d","col-sm-8":"GridColumn_col-sm-8__VvN4I","col-sm-9":"GridColumn_col-sm-9__els_U","col-sm-10":"GridColumn_col-sm-10__4t763","col-sm-11":"GridColumn_col-sm-11__teAj4","col-sm-12":"GridColumn_col-sm-12__rwo19","col-md-1":"GridColumn_col-md-1__7M0K_","col-md-2":"GridColumn_col-md-2__QwVeK","col-md-3":"GridColumn_col-md-3__d60_U","col-md-4":"GridColumn_col-md-4__FJutD","col-md-5":"GridColumn_col-md-5__kU88z","col-md-6":"GridColumn_col-md-6__D2rEl","col-md-7":"GridColumn_col-md-7__Ehtmf","col-md-8":"GridColumn_col-md-8__QMBmt","col-md-9":"GridColumn_col-md-9__khY9O","col-md-10":"GridColumn_col-md-10__5zEu3","col-md-11":"GridColumn_col-md-11__eqOzP","col-md-12":"GridColumn_col-md-12__c7eov","col-lg-1":"GridColumn_col-lg-1__P_4K7","col-lg-2":"GridColumn_col-lg-2__nHu5U","col-lg-3":"GridColumn_col-lg-3__qaeie","col-lg-4":"GridColumn_col-lg-4__cQCVo","col-lg-5":"GridColumn_col-lg-5__ChUHy","col-lg-6":"GridColumn_col-lg-6__aGkI7","col-lg-7":"GridColumn_col-lg-7__ZGToO","col-lg-8":"GridColumn_col-lg-8__uae7i","col-lg-9":"GridColumn_col-lg-9__iRL44","col-lg-10":"GridColumn_col-lg-10__y90z8","col-lg-11":"GridColumn_col-lg-11__a8tCK","col-lg-12":"GridColumn_col-lg-12__ClaaS","col-xl-1":"GridColumn_col-xl-1__5uqbs","col-xl-2":"GridColumn_col-xl-2__v44L_","col-xl-3":"GridColumn_col-xl-3__8fkAv","col-xl-4":"GridColumn_col-xl-4___YF_B","col-xl-5":"GridColumn_col-xl-5__mGPjO","col-xl-6":"GridColumn_col-xl-6__fTX40","col-xl-7":"GridColumn_col-xl-7__9lATQ","col-xl-8":"GridColumn_col-xl-8__Qenlk","col-xl-9":"GridColumn_col-xl-9__Fnrny","col-xl-10":"GridColumn_col-xl-10__ypX6L","col-xl-11":"GridColumn_col-xl-11__iFoaM","col-xl-12":"GridColumn_col-xl-12__lSmEH"};

/***/ }),

/***/ 45550:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"row":"GridRow_row__tb76V"};

/***/ }),

/***/ 89449:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heading":"Header_heading__RtM_n","heading__main":"Header_heading__main__PGKhL","heading__filters":"Header_heading__filters__JI_mf","heading__copy":"Header_heading__copy__G8SfP","heading__count":"Header_heading__count__UzJxc","breadcrumbs":"Header_breadcrumbs__JD4F7"};

/***/ }),

/***/ 47269:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"corrected-search-term":"CorrectedSearchTerm_corrected-search-term__YuCbT","corrected-search-term__copy":"CorrectedSearchTerm_corrected-search-term__copy__pWT5M"};

/***/ }),

/***/ 16969:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"alternative-search-terms--also-searched":"AlternativeSearchTerms_alternative-search-terms--also-searched__ElqxU","alternative-search-terms":"AlternativeSearchTerms_alternative-search-terms__ANTl0","alternative-search-terms__link":"AlternativeSearchTerms_alternative-search-terms__link__F5ILJ","alternative-search-terms__suggestion":"AlternativeSearchTerms_alternative-search-terms__suggestion__RuaS4","alternative-search-terms__suggestion--also-searched":"AlternativeSearchTerms_alternative-search-terms__suggestion--also-searched__rjaS8"};

/***/ }),

/***/ 43259:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sub-copy":"SubCopy_sub-copy__syDsb","sub-copy__copy":"SubCopy_sub-copy__copy__RoUtF"};

/***/ }),

/***/ 36928:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__lzQfu"};

/***/ }),

/***/ 88501:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nonpromomessage":"NonPromoMessage_nonpromomessage__WmdMY"};

/***/ }),

/***/ 75215:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"oos-toggle":"oos-toggle_oos-toggle__DBlh0","oos-toggle--checked":"oos-toggle_oos-toggle--checked__yZhll","oos-toggle__label":"oos-toggle_oos-toggle__label__lW2lz","oos-toggle__label--active":"oos-toggle_oos-toggle__label--active__zpIY6"};

/***/ }),

/***/ 650:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"c-pagination":"Pagination_c-pagination__ZRgMw","c-pagination--footer":"Pagination_c-pagination--footer__gyYWr","c-pagination__list":"Pagination_c-pagination__list__NpeH6","c-pagination__item":"Pagination_c-pagination__item__H23EU","c-pagination__pages":"Pagination_c-pagination__pages__mFeSG","c-pagination__btn":"Pagination_c-pagination__btn__gaTFF","c-pagination__ellipsis":"Pagination_c-pagination__ellipsis__DjAsT","c-pagination__active":"Pagination_c-pagination__active__14iYQ","c-pagination__active-underline":"Pagination_c-pagination__active-underline__RddJ3","c-pagination__next":"Pagination_c-pagination__next__CJltD","c-pagination__prev":"Pagination_c-pagination__prev__aUMdf","c-pagination__prev-btn":"Pagination_c-pagination__prev-btn__G9bdy","c-pagination__next-btn":"Pagination_c-pagination__next-btn__bBExU","c-pagination__prev-text":"Pagination_c-pagination__prev-text__31HHA","c-pagination__next-text":"Pagination_c-pagination__next-text__eTZk6","c-pagination--header":"Pagination_c-pagination--header__iXHVz"};

/***/ }),

/***/ 28059:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product-grid":"ProductGrid_product-grid__Ph0C3","product__list-view":"ProductGrid_product__list-view__16fm2","product-grid__product":"ProductGrid_product-grid__product__oD7Jq","product-grid__product--large":"ProductGrid_product-grid__product--large__L1T1R","product-grid__product--list-view":"ProductGrid_product-grid__product--list-view__n0tfp","product-count":"ProductGrid_product-count__etlC8","product":"ProductGrid_product__ER835","chunkLoadingSpinner":"ProductGrid_chunkLoadingSpinner__85DPD","chunkLoadErrorMessage":"ProductGrid_chunkLoadErrorMessage__ZR53E","compare-checkbox-list-view":"ProductGrid_compare-checkbox-list-view__g0S8R","discovery-rail":"ProductGrid_discovery-rail__0ASjw","discovery-rail__product":"ProductGrid_discovery-rail__product__BGcik"};

/***/ }),

/***/ 96011:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productCountInfo":"ProductCount_productCountInfo__gz_NV","product-count__list-view":"ProductCount_product-count__list-view__S4eyj"};

/***/ }),

/***/ 97997:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"ProductListing_mainContent__sId32","primaryFacet":"ProductListing_primaryFacet__Ha_3g"};

/***/ }),

/***/ 40443:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"Sort_visuallyHidden__rknXe","sort":"Sort_sort__RIrdF","sort__form":"Sort_sort__form__vq1Ul","sort__select":"Sort_sort__select__4_dY9","sort__submit":"Sort_sort__submit____EPN","sort__submit--visible":"Sort_sort__submit--visible__XZyHs"};

/***/ }),

/***/ 1635:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sticky-controls":"StickyControls_sticky-controls__RJXs_","sticky-controls--isStuck":"StickyControls_sticky-controls--isStuck__SJ33C","isHeaderPeeping":"StickyControls_isHeaderPeeping__z1nyG","sticky-controls__controls":"StickyControls_sticky-controls__controls__gYffH","sticky-controls__controls--isStuck":"StickyControls_sticky-controls__controls--isStuck__K78AZ"};

/***/ }),

/***/ 23350:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"filter-drawer-button":"Controls_filter-drawer-button__uVChB","filter-drawer-button-wrapper":"Controls_filter-drawer-button-wrapper__nY9kh","align-right":"Controls_align-right__zdQ9_"};

/***/ }),

/***/ 62013:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"ProductCardToggles_form__TqV__","formLabel":"ProductCardToggles_formLabel____Glg","toggleButton":"ProductCardToggles_toggleButton__k77Xj","toggleOption":"ProductCardToggles_toggleOption__m89Q5","selected":"ProductCardToggles_selected__OMvbk","option-large":"ProductCardToggles_option-large__mqsiR","option-small":"ProductCardToggles_option-small__67u0w","toggleOptionText":"ProductCardToggles_toggleOptionText__msNCY","sizeIcon":"ProductCardToggles_sizeIcon__vdpSR","icon-small":"ProductCardToggles_icon-small__XW7Vv","icon-large":"ProductCardToggles_icon-large__zzCyH"};

/***/ }),

/***/ 55399:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"PLP_visuallyHidden__tYeBv","visibleOnFocus":"PLP_visibleOnFocus__GqQJI","plp":"PLP_plp__yhz_K","plp__header":"PLP_plp__header__Z4_R0","plp__body":"PLP_plp__body__ysGeP","plp__breadcrumbs":"PLP_plp__breadcrumbs__WYDMU"};

/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [201,774,888,179], function() { return __webpack_exec__(63396); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);